
; /*!
 * jQuery Form Plugin
 * version: 3.45.0-2013.10.17
 * Requires jQuery v1.5 or later
 * Copyright (c) 2013 M. Alsup
 * Examples and documentation at: http://malsup.com/jquery/form/
 * Project repository: https://github.com/malsup/form
 * Dual licensed under the MIT and GPL licenses.
 * https://github.com/malsup/form#copyright-and-license
 */
(function ($) {
    var feature = {};
    feature.fileapi = $("<input type='file'/>").get(0).files !== undefined;
    feature.formdata = window.FormData !== undefined;
    var hasProp = !!$.fn.prop;
    $.fn.attr2 = function () {
        if (!hasProp)
            return this.attr.apply(this, arguments);
        var val = this.prop.apply(this, arguments);
        if (( val && val.jquery ) || typeof val === 'string')
            return val;
        return this.attr.apply(this, arguments);
    };
    $.fn.ajaxSubmit = function (options) {
        if (!this.length) {
            log('ajaxSubmit: skipping submit process - no element selected');
            return this;
        }
        var method, action, url, $form = this;
        if (typeof options == 'function') {
            options = { success: options };
        }
        else if (options === undefined) {
            options = {};
        }
        method = options.type || this.attr2('method');
        action = options.url || this.attr2('action');
        url = (typeof action === 'string') ? $.trim(action) : '';
        url = url || window.location.href || '';
        if (url) {
            url = (url.match(/^([^#]+)/) || [])[1];
        }
        options = $.extend(true, {
            url: url,
            success: $.ajaxSettings.success,
            type: method || $.ajaxSettings.type,
            iframeSrc: /^https/i.test(window.location.href || '') ? 'javascript:false' : 'about:blank',
            ajax_caller: bm.ajax
        }, options);
        var veto = {};
        this.trigger('form-pre-serialize', [this, options, veto]);
        if (veto.veto) {
            log('ajaxSubmit: submit vetoed via form-pre-serialize trigger');
            return this;
        }
        if (options.beforeSerialize && options.beforeSerialize(this, options) === false) {
            log('ajaxSubmit: submit aborted via beforeSerialize callback');
            return this;
        }
        var traditional = options.traditional;
        if (traditional === undefined) {
            traditional = $.ajaxSettings.traditional;
        }
        var elements = [];
        var qx, a = this.formToArray(options.semantic, elements);
        if (options.data) {
            options.extraData = options.data;
            qx = $.param(options.data, traditional);
        }
        if (options.beforeSubmit && options.beforeSubmit(a, this, options) === false) {
            log('ajaxSubmit: submit aborted via beforeSubmit callback');
            return this;
        }
        this.trigger('form-submit-validate', [a, this, options, veto]);
        if (veto.veto) {
            log('ajaxSubmit: submit vetoed via form-submit-validate trigger');
            return this;
        }
        var q = $.param(a, traditional);
        if (qx) {
            q = ( q ? (q + '&' + qx) : qx );
        }
        if (options.type.toUpperCase() == 'GET') {
            options.url += (options.url.indexOf('?') >= 0 ? '&' : '?') + q;
            options.data = null;
        }
        else {
            options.data = q;
        }
        var callbacks = [];
        if (options.resetForm) {
            callbacks.push(function () {
                $form.resetForm();
            });
        }
        if (options.clearForm) {
            callbacks.push(function () {
                $form.clearForm(options.includeHidden);
            });
        }
        if (!options.dataType && options.target) {
            var oldSuccess = options.success || function () {
            };
            callbacks.push(function (data) {
                var fn = options.replaceTarget ? 'replaceWith' : 'html';
                $(options.target)[fn](data).each(oldSuccess, arguments);
            });
        }
        else if (options.success) {
            callbacks.push(options.success);
        }
        options.success = function (data, status, xhr) {
            var context = options.context || this;
            for (var i = 0, max = callbacks.length; i < max; i++) {
                callbacks[i].apply(context, [data, status, xhr || $form, $form]);
            }
        };
        if (options.error) {
            var oldError = options.error;
            options.error = function (xhr, status, error) {
                var context = options.context || this;
                oldError.apply(context, [xhr, status, error, $form]);
            };
        }
        if (options.complete) {
            var oldComplete = options.complete;
            options.complete = function (xhr, status) {
                var context = options.context || this;
                oldComplete.apply(context, [xhr, status, $form]);
            };
        }
        var fileInputs = $('input[type=file]:enabled', this);
        fileInputs = fileInputs.filter(function () {
            return this.value != "";
        })
        var hasFileInputs = fileInputs.length > 0;
        var mp = 'multipart/form-data';
        var multipart = ($form.attr('enctype') == mp || $form.attr('encoding') == mp);
        var fileAPI = feature.fileapi && feature.formdata;
        log("fileAPI :" + fileAPI);
        var shouldUseFrame = (hasFileInputs || multipart) && !fileAPI;
        var jqxhr;
        if (options.iframe !== false && (options.iframe || shouldUseFrame)) {
            if (options.closeKeepAlive) {
                $.get(options.closeKeepAlive, function () {
                    jqxhr = fileUploadIframe(a);
                });
            }
            else {
                jqxhr = fileUploadIframe(a);
            }
        }
        else if ((hasFileInputs || multipart) && fileAPI) {
            var dynamicFields = this.data("form-extra-data");
            if (dynamicFields) {
                if ($.isArray(dynamicFields)) {
                    dynamicFields.everyCustomFunc(function () {
                        a.push(this)
                    })
                } else {
                    a.push(dynamicFields)
                }
            }
            jqxhr = fileUploadXhr(a);
        }
        else {
            jqxhr = options.ajax_caller(options);
        }
        $form.removeData('jqxhr').data('jqxhr', jqxhr);
        for (var k = 0; k < elements.length; k++)
            elements[k] = null;
        this.trigger('form-submit-notify', [this, options]);
        return this;
        function deepSerialize(extraData) {
            var serialized = $.param(extraData, options.traditional).split('&');
            var len = serialized.length;
            var result = [];
            var i, part;
            for (i = 0; i < len; i++) {
                serialized[i] = serialized[i].replace(/\+/g, ' ');
                part = serialized[i].split('=');
                result.push([decodeURIComponent(part[0]), decodeURIComponent(part[1])]);
            }
            return result;
        }

        function fileUploadXhr(a) {
            var formdata = new FormData();
            for (var i = 0; i < a.length; i++) {
                formdata.append(a[i].name, a[i].value);
            }
            if (options.extraData) {
                var serializedData = deepSerialize(options.extraData);
                for (i = 0; i < serializedData.length; i++)
                    if (serializedData[i])
                        formdata.append(serializedData[i][0], serializedData[i][1]);
            }
            options.data = null;
            var s = $.extend(true, {}, $.ajaxSettings, options, {
                contentType: false,
                processData: false,
                cache: false,
                type: method || 'POST'
            });
            if (options.uploadProgress) {
                s.xhr = function () {
                    var xhr = $.ajaxSettings.xhr();
                    if (xhr.upload) {
                        xhr.upload.addEventListener('progress', function (event) {
                            var percent = 0;
                            var position = event.loaded || event.position;
                            var total = event.total;
                            if (event.lengthComputable) {
                                percent = Math.ceil(position / total * 100);
                            }
                            options.uploadProgress(event, position, total, percent);
                        }, false);
                    }
                    return xhr;
                };
            }
            s.data = null;
            var beforeSend = s.beforeSend;
            s.beforeSend = function (xhr, o) {
                if (options.formData)
                    o.data = options.formData;
                else
                    o.data = formdata;
                if (beforeSend)
                    beforeSend.call(this, xhr, o);
            };
            return s.ajax_caller(s);
        }

        function fileUploadIframe(a, repeat, repeatWithSettings) {
            var form = $form[0], el, i, s, g, id, $io, io, xhr, sub, n, timedOut, timeoutHandle;
            var deferred = $.Deferred();
            deferred.abort = function (status) {
                xhr.abort(status);
            };
            if (a) {
                for (i = 0; i < elements.length; i++) {
                    el = $(elements[i]);
                    if (hasProp)
                        el.prop('disabled', false);
                    else
                        el.removeAttr('disabled');
                }
            }
            if(repeat) {
                s = repeatWithSettings
            } else {
                options.on_login = function () {
                    fileUploadIframe(a, true, s)
                }
                options = bm._modified_ajax_settings(options)
                s = $.extend(true, {}, $.ajaxSettings, options);
            }
            s.context = s.context || s;
            id = 'jqFormIO' + (new Date().getTime());
            if (s.iframeTarget) {
                $io = $(s.iframeTarget);
                n = $io.attr2('name');
                if (!n)
                    $io.attr2('name', id);
                else
                    id = n;
            }
            else {
                $io = $('<iframe name="' + id + '" src="' + s.iframeSrc + '" />');
                $io.css({ position: 'absolute', top: '-1000px', left: '-1000px' });
            }
            io = $io[0];

            xhr = {                 aborted: 0,
                responseText: null,
                responseXML: null,
                status: 0,
                statusText: 'n/a',
                getAllResponseHeaders: function () {
                },
                getResponseHeader: function () {
                },
                setRequestHeader: function () {
                },
                abort: function (status) {
                    var e = (status === 'timeout' ? 'timeout' : 'aborted');
                    log('aborting upload... ' + e);
                    this.aborted = 1;
                    try {
                        if (io.contentWindow.document.execCommand) {
                            io.contentWindow.document.execCommand('Stop');
                        }
                    }
                    catch (ignore) {
                    }
                    $io.attr('src', s.iframeSrc);
                    xhr.error = e;
                    if (s.error)
                        s.error.call(s.context, xhr, e, status);
                    if (g)
                        $.event.trigger("ajaxError", [xhr, s, e]);
                    if (s.complete)
                        s.complete.call(s.context, xhr, e);
                }
            };
            g = s.global;
            if (g && 0 === $.active++) {
                $.event.trigger("ajaxStart");
            }
            if (g) {
                $.event.trigger("ajaxSend", [xhr, s]);
            }
            if (s.beforeSend && s.beforeSend.call(s.context, xhr, s) === false) {
                if (s.global) {
                    $.active--;
                }
                deferred.reject();
                return deferred;
            }
            if (xhr.aborted) {
                deferred.reject();
                return deferred;
            }
            sub = form.clk;
            if (sub) {
                n = sub.name;
                if (n && !sub.disabled) {
                    s.extraData = s.extraData || {};
                    s.extraData[n] = sub.value;
                    if (sub.type == "image") {
                        s.extraData[n + '.x'] = form.clk_x;
                        s.extraData[n + '.y'] = form.clk_y;
                    }
                }
            }
            var CLIENT_TIMEOUT_ABORT = 1;
            var SERVER_ABORT = 2;

            function getDoc(frame) {
                var doc = null;
                try {
                    if (frame.contentWindow) {
                        doc = frame.contentWindow.document;
                    }
                } catch (err) {
                    log('cannot get iframe.contentWindow document: ' + err);
                }
                if (doc) {
                    return doc;
                }
                try {
                    doc = frame.contentDocument ? frame.contentDocument : frame.document;
                } catch (err) {
                    log('cannot get iframe.contentDocument: ' + err);
                    doc = frame.document;
                }
                return doc;
            }

            var csrf_token = $('meta[name=csrf-token]').attr('content');
            var csrf_param = $('meta[name=csrf-param]').attr('content');
            if (csrf_param && csrf_token) {
                s.extraData = s.extraData || {};
                s.extraData[csrf_param] = csrf_token;
            }
            function doSubmit() {
                var t = $form.attr2('target'), a = $form.attr2('action');
                form.setAttribute('target', id);
                if (!method || /post/i.test(method)) {
                    form.setAttribute('method', 'POST');
                }
                if (a != s.url) {
                    form.setAttribute('action', s.url);
                }
                if (!s.skipEncodingOverride && (!method || /post/i.test(method))) {
                    $form.attr({
                        encoding: 'multipart/form-data',
                        enctype: 'multipart/form-data'
                    });
                }
                if (s.timeout) {
                    timeoutHandle = setTimeout(function () {
                        timedOut = true;
                        cb(CLIENT_TIMEOUT_ABORT);
                    }, s.timeout);
                }
                function checkState() {
                    try {
                        var state = getDoc(io).readyState;
                        log('state = ' + state);
                        if (state && state.toLowerCase() == 'uninitialized')
                            setTimeout(checkState, 50);
                    }
                    catch (e) {
                        log('Server abort: ', e, ' (', e.name, ')');
                        cb(SERVER_ABORT);
                        if (timeoutHandle)
                            clearTimeout(timeoutHandle);
                        timeoutHandle = undefined;
                    }
                }

                var extraInputs = [];
                try {
                    if (s.extraData) {
                        for (var n in s.extraData) {
                            if (s.extraData.hasOwnProperty(n)) {
                                if ($.isPlainObject(s.extraData[n]) && s.extraData[n].hasOwnProperty('name') && s.extraData[n].hasOwnProperty('value')) {
                                    extraInputs.push(
                                        $('<input type="hidden" name="' + s.extraData[n].name + '">').val(s.extraData[n].value)
                                            .appendTo(form)[0]);
                                } else {
                                    extraInputs.push(
                                        $('<input type="hidden" name="' + n + '">').val(s.extraData[n])
                                            .appendTo(form)[0]);
                                }
                            }
                        }
                    }
                    if ((s.dataType || 'html') == "json") {
                        extraInputs.push(
                            $('<input type="hidden" name="jsonashtml">').val("true")
                                .appendTo(form)[0]);
                    }
                    extraInputs.push(
                        $('<input type="hidden" name="xhriniframe">').val("true")
                            .appendTo(form)[0]);
                    if (!s.iframeTarget) {
                        $io.appendTo('body');
                    }
                    if (io.attachEvent)
                        io.attachEvent('onload', cb);
                    else
                        io.addEventListener('load', cb, false);
                    setTimeout(checkState, 15);
                    try {
                        form.submit();
                    } catch (err) {
                        var submitFn = document.createElement('form').submit;
                        submitFn.apply(form);
                    }
                }
                finally {
                    form.setAttribute('action', a);
                    if (t) {
                        form.setAttribute('target', t);
                    } else {
                        $form.removeAttr('target');
                    }
                    $(extraInputs).remove();
                }
            }

            if (s.forceSync) {
                doSubmit();
            }
            else {
                setTimeout(doSubmit, 10);
            }
            var data, doc, domCheckCount = 50, callbackProcessed;

            function cb(e) {
                if (xhr.aborted || callbackProcessed) {
                    return;
                }
                doc = getDoc(io);
                if (!doc) {
                    log('cannot access response document');
                    e = SERVER_ABORT;
                }
                if (e === CLIENT_TIMEOUT_ABORT && xhr) {
                    xhr.abort('timeout');
                    deferred.reject(xhr, 'timeout');
                    return;
                }
                else if (e == SERVER_ABORT && xhr) {
                    xhr.abort('server abort');
                    deferred.reject(xhr, 'error', 'server abort');
                    return;
                }
                if (!doc || doc.location.href == s.iframeSrc) {
                    if (!timedOut)
                        return;
                }
                if (io.detachEvent)
                    io.detachEvent('onload', cb);
                else
                    io.removeEventListener('load', cb, false);
                var status = 'success', errMsg;
                try {
                    if (timedOut) {
                        throw 'timeout';
                    }
                    var isXml = s.dataType == 'xml' || doc.XMLDocument || $.isXMLDoc(doc);
                    log('isXml=' + isXml);
                    if (!isXml && window.opera && (doc.body === null || !doc.body.innerHTML)) {
                        if (--domCheckCount) {
                            log('requeing onLoad callback, DOM not available');
                            setTimeout(cb, 250);
                            return;
                        }
                    }
                    var docRoot = doc.body ? doc.body : doc.documentElement;
                    xhr.responseText = docRoot ? docRoot.innerHTML : null;
                    xhr.responseXML = doc.XMLDocument ? doc.XMLDocument : doc;
                    if (isXml)
                        s.dataType = 'xml';
                    xhr.getResponseHeader = function (header) {
                        var headers = {'content-type': s.dataType};
                        return headers[header.toLowerCase()];
                    };
                    if (docRoot) {
                        xhr.status = Number(docRoot.getAttribute('status')) || xhr.status;
                        xhr.statusText = docRoot.getAttribute('statusText') || xhr.statusText;
                    }
                    var dt = (s.dataType || 'html').toLowerCase();
                    var scr = /(json|script|text)/.test(dt);
                    if (scr || s.textarea) {
                        var ta = doc.getElementsByTagName('textarea')[0];
                        if (ta) {
                            xhr.responseText = ta.value;
                            xhr.status = Number(ta.getAttribute('status')) || xhr.status;
                            xhr.statusText = ta.getAttribute('statusText') || xhr.statusText;
                        }
                        else if (scr) {
                            var pre = doc.getElementsByTagName('pre')[0];
                            var b = doc.getElementsByTagName('body')[0];
                            if (pre) {
                                xhr.responseText = pre.textContent ? pre.textContent : pre.innerText;
                            }
                            else if (b) {
                                xhr.responseText = b.textContent ? b.textContent : b.innerText;
                            }
                        }
                    }
                    else if (dt == 'xml' && !xhr.responseXML && xhr.responseText) {
                        xhr.responseXML = toXml(xhr.responseText);
                    }
                    try {
                        data = httpData(xhr, dt, s);
                    }
                    catch (err) {
                        status = 'parsererror';
                        xhr.error = errMsg = (err || status);
                    }
                }
                catch (err) {
                    log('error caught: ', err);
                    status = 'error';
                    xhr.error = errMsg = (err || status);
                }
                if (xhr.aborted) {
                    log('upload aborted');
                    status = null;
                }
                if (xhr.status) {
                    status = (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) ? 'success' : 'error';
                }
                if (status === 'success') {
                    if (s.success)
                        s.success.call(s.context, data, 'success', xhr);
                    deferred.resolve(xhr.responseText, 'success', xhr);
                    if (g)
                        $.event.trigger("ajaxSuccess", [xhr, s]);
                }
                else if (status) {
                    if (errMsg === undefined)
                        errMsg = xhr.statusText;
                    if (s.error)
                        s.error.call(s.context, xhr, status, errMsg);
                    deferred.reject(xhr, 'error', errMsg);
                    if (g)
                        $.event.trigger("ajaxError", [xhr, s, errMsg]);
                }
                if (g)
                    $.event.trigger("ajaxComplete", [xhr, s]);
                if (g && !--$.active) {
                    $.event.trigger("ajaxStop");
                }
                if (s.complete)
                    s.complete.call(s.context, xhr, status);
                callbackProcessed = true;
                if (s.timeout)
                    clearTimeout(timeoutHandle);
                setTimeout(function () {
                    if (!s.iframeTarget)
                        $io.remove();
                    else                          $io.attr('src', s.iframeSrc);
                    xhr.responseXML = null;
                }, 100);
            }

            var toXml = $.parseXML || function (s, doc) {
                if (window.ActiveXObject) {
                    doc = new ActiveXObject('Microsoft.XMLDOM');
                    doc.async = 'false';
                    doc.loadXML(s);
                }
                else {
                    doc = (new DOMParser()).parseFromString(s, 'text/xml');
                }
                return (doc && doc.documentElement && doc.documentElement.nodeName != 'parsererror') ? doc : null;
            };
            var parseJSON = $.parseJSON || function (s) {
                return window['eval']('(' + s + ')');
            };
            var httpData = function (xhr, type, s) {
                var ct = xhr.getResponseHeader('content-type') || '',
                    xml = type === 'xml' || !type && ct.indexOf('xml') >= 0,
                    data = xml ? xhr.responseXML : xhr.responseText;
                if (xml && data.documentElement.nodeName === 'parsererror') {
                    if ($.error)
                        $.error('parsererror');
                }
                if (s && s.dataFilter) {
                    data = s.dataFilter(data, type);
                }
                if (typeof data === 'string') {
                    if (type === 'json' || !type && ct.indexOf('json') >= 0) {
                        data = parseJSON(data);
                    } else if (type === "script" || !type && ct.indexOf("javascript") >= 0) {
                        $.globalEval(data);
                    }
                }
                return data;
            };
            return deferred;
        }
    };
    $.fn.ajaxForm = function (options) {
        options = options || {};
        options.delegation = options.delegation && $.isFunction($.fn.on);
        options.ajax_caller = options.ajax_caller || $.ajax_caller || $.ajax;
        if (!options.delegation && this.length === 0) {
            var o = { s: this.selector, c: this.context };
            if (!$.isReady && o.s) {
                log('DOM not ready, queuing ajaxForm');
                $(function () {
                    $(o.s, o.c).ajaxForm(options);
                });
                return this;
            }
            log('terminating; zero elements found by selector' + ($.isReady ? '' : ' (DOM not ready)'));
            return this;
        }
        if (options.delegation) {
            $(document)
                .off('submit.form-plugin', this.selector, doAjaxSubmit)
                .off('click.form-plugin', this.selector, captureSubmittingElement)
                .on('submit.form-plugin', this.selector, options, doAjaxSubmit)
                .on('click.form-plugin', this.selector, options, captureSubmittingElement);
            return this;
        }
        return this.ajaxFormUnbind()
            .bind('submit.form-plugin', options, doAjaxSubmit)
            .bind('click.form-plugin', options, captureSubmittingElement);
    };
    function doAjaxSubmit(e) {
        var options = e.data;
        if (!e.isDefaultPrevented()) {
            e.preventDefault();
            $(e.target).ajaxSubmit(options);
        }
    }

    function captureSubmittingElement(e) {
        var target = e.target;
        var $el = $(target);
        if (!($el.is("[type=submit],[type=image]"))) {
            var t = $el.closest('[type=submit]');
            if (t.length === 0) {
                return;
            }
            target = t[0];
        }
        var form = this;
        form.clk = target;
        if (target.type == 'image') {
            if (e.offsetX !== undefined) {
                form.clk_x = e.offsetX;
                form.clk_y = e.offsetY;
            } else if (typeof $.fn.offset == 'function') {
                var offset = $el.offset();
                form.clk_x = e.pageX - offset.left;
                form.clk_y = e.pageY - offset.top;
            } else {
                form.clk_x = e.pageX - target.offsetLeft;
                form.clk_y = e.pageY - target.offsetTop;
            }
        }
        setTimeout(function () {
            form.clk = form.clk_x = form.clk_y = null;
        }, 100);
    }

    $.fn.ajaxFormUnbind = function () {
        return this.unbind('submit.form-plugin click.form-plugin');
    };
    $.fn.formToArray = function (semantic, elements) {
        var a = [];
        if (this.length === 0) {
            return a;
        }
        var form = this[0];
        var els = semantic ? form.getElementsByTagName('*') : form.elements;
        if (!els) {
            return a;
        }
        var i, j, n, v, el, max, jmax;
        for (i = 0, max = els.length; i < max; i++) {
            el = els[i];
            n = el.name;
            if (!n || el.disabled) {
                continue;
            }
            if (semantic && form.clk && el.type == "image") {
                if (form.clk == el) {
                    a.push({name: n, value: $(el).val(), type: el.type });
                    a.push({name: n + '.x', value: form.clk_x}, {name: n + '.y', value: form.clk_y});
                }
                continue;
            }
            v = $.fieldValue(el, true);
            if (v && v.constructor == Array) {
                if (elements)
                    elements.push(el);
                for (j = 0, jmax = v.length; j < jmax; j++) {
                    a.push({name: n, value: v[j]});
                }
            }
            else if (feature.fileapi && el.type == 'file') {
                if (elements)
                    elements.push(el);
                var files = el.files;
                if (files.length) {
                    for (j = 0; j < files.length; j++) {
                        a.push({name: n, value: files[j], type: el.type});
                    }
                }
                else {
                    a.push({ name: n, value: '', type: el.type });
                }
            }
            else if (v !== null && typeof v != 'undefined') {
                if (elements)
                    elements.push(el);
                a.push({name: n, value: v, type: el.type, required: el.required});
            }
        }
        if (!semantic && form.clk) {
            var $input = $(form.clk), input = $input[0];
            n = input.name;
            if (n && !input.disabled && input.type == 'image') {
                a.push({name: n, value: $input.val()});
                a.push({name: n + '.x', value: form.clk_x}, {name: n + '.y', value: form.clk_y});
            }
        }
        return a;
    };
    $.fn.formSerialize = function (semantic) {
        return $.param(this.formToArray(semantic));
    };
    $.fn.fieldSerialize = function (successful) {
        var a = [];
        this.each(function () {
            var n = this.name;
            if (!n) {
                return;
            }
            var v = $.fieldValue(this, successful);
            if (v && v.constructor == Array) {
                for (var i = 0, max = v.length; i < max; i++) {
                    a.push({name: n, value: v[i]});
                }
            }
            else if (v !== null && typeof v != 'undefined') {
                a.push({name: this.name, value: v});
            }
        });
        return $.param(a);
    };
    $.fn.fieldValue = function (successful) {
        for (var val = [], i = 0, max = this.length; i < max; i++) {
            var el = this[i];
            var v = $.fieldValue(el, successful);
            if (v === null || typeof v == 'undefined' || (v.constructor == Array && !v.length)) {
                continue;
            }
            if (v.constructor == Array)
                $.merge(val, v);
            else
                val.push(v);
        }
        return val;
    };
    $.fieldValue = function (el, successful) {
        var n = el.name, t = el.type, tag = el.tagName.toLowerCase();
        if (successful === undefined) {
            successful = true;
        }
        if (successful && (!n || el.disabled || t == 'reset' || t == 'button' ||
            (t == 'checkbox' || t == 'radio') && !el.checked ||
            (t == 'submit' || t == 'image') && el.form && el.form.clk != el ||
            tag == 'select' && el.selectedIndex == -1)) {
            return null;
        }
        if (tag == 'select') {
            var index = el.selectedIndex;
            if (index < 0) {
                return null;
            }
            var a = [], ops = el.options;
            var one = (t == 'select-one');
            var max = (one ? index + 1 : ops.length);
            for (var i = (one ? index : 0); i < max; i++) {
                var op = ops[i];
                if (op.selected) {
                    var v = op.value;
                    if (!v) {
                        v = (op.attributes && op.attributes['value'] && !(op.attributes['value'].specified)) ? op.text : op.value;
                    }
                    if (one) {
                        return v;
                    }
                    a.push(v);
                }
            }
            return a;
        }
        return $(el).val();
    };
    $.fn.clearForm = function (includeHidden) {
        return this.each(function () {
            $('input,select,textarea', this).clearFields(includeHidden);
        });
    };
    $.fn.clearFields = $.fn.clearInputs = function (includeHidden) {
        var re = /^(?:color|date|datetime|email|month|number|password|range|search|tel|text|time|url|week)$/i;
        return this.each(function () {
            var $this = $(this), t = this.type, tag = this.tagName.toLowerCase();
            if (re.test(t) || tag == 'textarea') {
                this.value = '';
            }
            else if (t == 'checkbox' || t == 'radio') {
                $this.prop("checked", false)
            }
            else if (tag == 'select') {
                this.selectedIndex = -1;
            }
            else if (t == "file") {
                if (/MSIE/.test(navigator.userAgent)) {
                    $(this).replaceWith($(this).clone(true));
                } else {
                    $(this).val('');
                }
            }
            else if (includeHidden) {
                if ((includeHidden === true && /hidden/.test(t)) ||
                    (typeof includeHidden == 'string' && $(this).is(includeHidden)))
                    this.value = '';
            }
        });
    };
    $.fn.resetForm = function () {
        return this.each(function () {
            if (typeof this.reset == 'function' || (typeof this.reset == 'object' && !this.reset.nodeType)) {
                this.reset();
            }
        });
    };
    $.fn.enable = function (b) {
        if (b === undefined) {
            b = true;
        }
        return this.each(function () {
            this.disabled = !b;
        });
    };
    $.fn.selected = function (select) {
        if (select === undefined) {
            select = true;
        }
        return this.each(function () {
            var t = this.type;
            if (t == 'checkbox' || t == 'radio') {
                this.checked = select;
            }
            else if (this.tagName.toLowerCase() == 'option') {
                var $sel = $(this).parent('select');
                if (select && $sel[0] && $sel[0].type == 'select-one') {
                    $sel.find('option').selected(false);
                }
                this.selected = select;
            }
        });
    };
    $.fn.ajaxSubmit.debug = false;
    function log() {
        if (!$.fn.ajaxSubmit.debug)
            return;
        var msg = '[jquery.form] ' + Array.prototype.join.call(arguments, '');
        if (window.console && window.console.log) {
            window.console.log(msg);
        }
        else if (window.opera && window.opera.postError) {
            window.opera.postError(msg);
        }
    }
})(jQuery);
; var Hashtable=function(){function n(t){var r;if(typeof t=="string")return t;if(typeof t.hashCode==e)return r=t.hashCode(),typeof r=="string"?r:n(r);if(typeof t.toString==e)return t.toString();try{return String(t)}catch(i){return Object.prototype.toString.call(t)}}function r(e,t){return e.equals(t)}function i(t,n){return typeof n.equals==e?n.equals(t):t===n}function s(e){return function(t){if(t===null)throw new Error("null is not a valid "+e);if(typeof t=="undefined")throw new Error(e+" must not be undefined")}}function a(e,t,n,r){this[0]=e,this.entries=[],this.addEntry(t,n),r!==null&&(this.getEqualityFunction=function(){return r})}function h(e){return function(t){var n=this.entries.length,r,i=this.getEqualityFunction(t);while(n--){r=this.entries[n];if(i(t,r[0]))switch(e){case f:return!0;case l:return r;case c:return[n,r[1]]}}return!1}}function p(e){return function(t){var n=t.length;for(var r=0,i=this.entries.length;r<i;++r)t[n+r]=this.entries[r][e]}}function d(e,t){var n=e.length,r;while(n--){r=e[n];if(t===r[0])return n}return null}function v(e,t){var n=e[t];return n&&n instanceof a?n:null}function m(r,i){var s=this,f=[],l={},c=typeof r==e?r:n,h=typeof i==e?i:null;this.put=function(e,t){o(e),u(t);var n=c(e),r,i,s=null;return r=v(l,n),r?(i=r.getEntryForKey(e),i?(s=i[1],i[1]=t):r.addEntry(e,t)):(r=new a(n,e,t,h),f[f.length]=r,l[n]=r),s},this.get=function(e){o(e);var t=c(e),n=v(l,t);if(n){var r=n.getEntryForKey(e);if(r)return r[1]}return null},this.containsKey=function(e){o(e);var t=c(e),n=v(l,t);return n?n.containsKey(e):!1},this.containsValue=function(e){u(e);var t=f.length;while(t--)if(f[t].containsValue(e))return!0;return!1},this.clear=function(){f.length=0,l={}},this.isEmpty=function(){return!f.length};var p=function(e){return function(){var t=[],n=f.length;while(n--)f[n][e](t);return t}};this.keys=p("keys"),this.values=p("values"),this.entries=p("getEntries"),this.remove=function(e){o(e);var n=c(e),r,i=null,s=v(l,n);return s&&(i=s.removeEntryForKey(e),i!==null&&(s.entries.length||(r=d(f,n),t(f,r),delete l[n]))),i},this.size=function(){var e=0,t=f.length;while(t--)e+=f[t].entries.length;return e},this.each=function(e){var t=s.entries(),n=t.length,r;while(n--)r=t[n],e(r[0],r[1])},this.putAll=function(t,n){var r=t.entries(),i,o,u,a,f=r.length,l=typeof n==e;while(f--)i=r[f],o=i[0],u=i[1],l&&(a=s.get(o))&&(u=n(o,a,u)),s.put(o,u)},this.clone=function(){var e=new m(r,i);return e.putAll(s),e}}var e="function",t=typeof Array.prototype.splice==e?function(e,t){e.splice(t,1)}:function(e,t){var n,r,i;if(t===e.length-1)e.length=t;else{n=e.slice(t+1),e.length=t;for(r=0,i=n.length;r<i;++r)e[t+r]=n[r]}},o=s("key"),u=s("value"),f=0,l=1,c=2;return a.prototype={getEqualityFunction:function(t){return typeof t.equals==e?r:i},getEntryForKey:h(l),getEntryAndIndexForKey:h(c),removeEntryForKey:function(e){var n=this.getEntryAndIndexForKey(e);return n?(t(this.entries,n[0]),n[1]):null},addEntry:function(e,t){this.entries[this.entries.length]=[e,t]},keys:p(0),values:p(1),getEntries:function(e){var t=e.length;for(var n=0,r=this.entries.length;n<r;++n)e[t+n]=this.entries[n].slice(0)},containsKey:h(f),containsValue:function(e){var t=this.entries.length;while(t--)if(e===this.entries[t][1])return!0;return!1}},m}();(function(e){function a(e,t,n){this.dec=e,this.group=t,this.neg=n}function f(){for(var e=0;e<u.length;e++){localeGroup=u[e];for(var n=0;n<localeGroup.length;n++)t.put(localeGroup[n],e)}}function l(e,n){t.size()==0&&f();var r=".",i=",",s="-";n==0&&(e.indexOf("_")!=-1?e=e.split("_")[1].toLowerCase():e.indexOf("-")!=-1&&(e=e.split("-")[1].toLowerCase()));var u=t.get(e);if(u){var l=o[u];l&&(r=l[0],i=l[1])}return new a(r,i,s)}var t=new Hashtable,n=["ae","au","ca","cn","eg","gb","hk","il","in","jp","sk","th","tw","us"],r=["at","br","de","dk","es","gr","it","nl","pt","tr","vn"],i=["cz","fi","fr","ru","se","pl"],s=["ch"],o=[[".",","],[",","."],[","," "],[".","'"]],u=[n,r,i,s];e.fn.formatNumber=function(t,n,r){return this.each(function(){n==null&&(n=!0),r==null&&(r=!0);var i;e(this).is(":input")?i=new String(e(this).val()):i=new String(e(this).text());var s=e.formatNumber(i,t);n&&(e(this).is(":input")?e(this).val(s):e(this).text(s));if(r)return s})},e.formatNumber=function(t,n){var n=e.extend({},e.fn.formatNumber.defaults,n),r=l(n.locale.toLowerCase(),n.isFullLocale),i=r.dec,s=r.group,o=r.neg,u="0#-,.",a="",f=!1;for(var c=0;c<n.format.length;c++){if(u.indexOf(n.format.charAt(c))!=-1){if(c==0&&n.format.charAt(c)=="-"){f=!0;continue}break}a+=n.format.charAt(c)}var h="";for(var c=n.format.length-1;c>=0;c--){if(u.indexOf(n.format.charAt(c))!=-1)break;h=n.format.charAt(c)+h}n.format=n.format.substring(a.length),n.format=n.format.substring(0,n.format.length-h.length);var p=new Number(t);return e._formatNumber(p,n,h,a,f)},e._formatNumber=function(t,n,r,i,s){var n=e.extend({},e.fn.formatNumber.defaults,n),o=l(n.locale.toLowerCase(),n.isFullLocale),u=o.dec,a=o.group,f=o.neg,c=!1;if(isNaN(t)){if(n.nanForceZero!=1)return null;t=0,c=!0}r=="%"&&(t*=100);var h="";if(n.format.indexOf(".")>-1){var p=u,d=n.format.substring(n.format.lastIndexOf(".")+1);if(n.round==1)t=new Number(t.toFixed(d.length));else{var v=t.toString();v=v.substring(0,v.lastIndexOf(".")+d.length+1),t=new Number(v)}var m=t%1,g=new String(m.toFixed(d.length));g=g.substring(g.lastIndexOf(".")+1);for(var y=0;y<d.length;y++){if(d.charAt(y)=="#"&&g.charAt(y)!="0"){p+=g.charAt(y);continue}if(d.charAt(y)=="#"&&g.charAt(y)=="0"){var b=g.substring(y);if(b.match("[1-9]")){p+=g.charAt(y);continue}break}d.charAt(y)=="0"&&(p+=g.charAt(y))}h+=p}else t=Math.round(t);var w=Math.floor(t);t<0&&(w=Math.ceil(t));var E="";n.format.indexOf(".")==-1?E=n.format:E=n.format.substring(0,n.format.indexOf("."));var S="";if(w!=0||E.substr(E.length-1)!="#"||c){var x=new String(Math.abs(w)),T=9999;E.lastIndexOf(",")!=-1&&(T=E.length-E.lastIndexOf(",")-1);var N=0;for(var y=x.length-1;y>-1;y--)S=x.charAt(y)+S,N++,N==T&&y!=0&&(S=a+S,N=0);if(E.length>S.length){var C=E.indexOf("0");if(C!=-1){var k=E.length-C,L=E.length-S.length-1;while(S.length<k){var A=E.charAt(L);A==","&&(A=a),S=A+S,L--}}}}return!S&&E.indexOf("0",E.length-1)!==-1&&(S="0"),h=S+h,t<0&&s&&i.length>0?i=f+i:t<0&&(h=f+h),n.decimalSeparatorAlwaysShown||h.lastIndexOf(u)==h.length-1&&(h=h.substring(0,h.length-1)),h=i+h+r,h},e.fn.parseNumber=function(t,n,r){n==null&&(n=!0),r==null&&(r=!0);var i;e(this).is(":input")?i=new String(e(this).val()):i=new String(e(this).text());var s=e.parseNumber(i,t);if(s){n&&(e(this).is(":input")?e(this).val(s.toString()):e(this).text(s.toString()));if(r)return s}},e.parseNumber=function(t,n){var n=e.extend({},e.fn.parseNumber.defaults,n),r=l(n.locale.toLowerCase(),n.isFullLocale),i=r.dec,s=r.group,o=r.neg,u="1234567890.-";while(t.indexOf(s)>-1)t=t.replace(s,"");t=t.replace(i,".").replace(o,"-");var a="",f=!1;if(t.charAt(t.length-1)=="%"||n.isPercentage==1)f=!0;for(var c=0;c<t.length;c++)u.indexOf(t.charAt(c))>-1&&(a+=t.charAt(c));var h=new Number(a);if(f){h/=100;var p=a.indexOf(".");if(p!=-1){var d=a.length-p-1;h=h.toFixed(d+2)}else h=h.toFixed(a.length-1)}return h},e.fn.parseNumber.defaults={locale:"us",decimalSeparatorAlwaysShown:!1,isPercentage:!1,isFullLocale:!1},e.fn.formatNumber.defaults={format:"#,###.00",locale:"us",decimalSeparatorAlwaysShown:!1,nanForceZero:!0,round:!0,isFullLocale:!1},Number.prototype.toFixed=function(t){return e._roundNumber(this,t)},e._roundNumber=function(e,t){var n=Math.pow(10,t||0),r=String(Math.round(e*n)/n);if(t>0){var i=r.indexOf(".");i==-1?(r+=".",i=0):i=r.length-(i+1);while(i<t)r+="0",i++}return r}})(jQuery),function(){var e={};this.tmpl=function t(n,r){var i=/\W/.test(n)?new Function("obj","var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push('"+n.replace(/[\r\t\n]/g," ").split("<%").join("	").replace(/((^|%>)[^\t]*)'/g,"$1\r").replace(/\t=(.*?)%>/g,"',$1,'").split("	").join("');").split("%>").join("p.push('").split("\r").join("\\'")+"');}return p.join('');"):e[n]=e[n]||t(document.getElementById(n).innerHTML);return r?i(r):i}}(),function(e){e.baseClass=function(t){return t=e(t),t.get(0).className.match(/([^ ]+)/)[1]},e.fn.addDependClass=function(t,n){var r={delimiter:n?n:"-"};return this.each(function(){var n=e.baseClass(this);n&&e(this).addClass(n+r.delimiter+t)})},e.fn.removeDependClass=function(t,n){var r={delimiter:n?n:"-"};return this.each(function(){var n=e.baseClass(this);n&&e(this).removeClass(n+r.delimiter+t)})},e.fn.toggleDependClass=function(t,n){var r={delimiter:n?n:"-"};return this.each(function(){var n=e.baseClass(this);n&&(e(this).is("."+n+r.delimiter+t)?e(this).removeClass(n+r.delimiter+t):e(this).addClass(n+r.delimiter+t))})}}(jQuery),function(e){function t(){this._init.apply(this,arguments)}t.prototype.oninit=function(){},t.prototype.events=function(){},t.prototype.onmousedown=function(){this.ptr.css({position:"absolute"})},t.prototype.onmousemove=function(e,t,n){this.ptr.css({left:t,top:n})},t.prototype.onmouseup=function(){},t.prototype.isDefault={drag:!1,clicked:!1,toclick:!0,mouseup:!1},t.prototype._init=function(){if(arguments.length>0){this.ptr=e(arguments[0]),this.outer=e(".draggable-outer"),this.is={},e.extend(this.is,this.isDefault);var t=this.ptr.offset();this.d={left:t.left,top:t.top,width:this.ptr.width(),height:this.ptr.height()},this.oninit.apply(this,arguments),this._events()}},t.prototype._getPageCoords=function(e){return e.targetTouches&&e.targetTouches[0]?{x:e.targetTouches[0].pageX,y:e.targetTouches[0].pageY}:{x:e.pageX,y:e.pageY}},t.prototype._bindEvent=function(e,t,n){var r=this;this.supportTouches_?e.get(0).addEventListener(this.events_[t],n,!1):e.bind(this.events_[t],n)},t.prototype._events=function(){var t=this;this.supportTouches_=browser.gc&&navigator.userAgent.indexOf("Mobile")!=-1,this.events_={click:this.supportTouches_?"touchstart":"click",down:this.supportTouches_?"touchstart":"mousedown",move:this.supportTouches_?"touchmove":"mousemove",up:this.supportTouches_?"touchend":"mouseup"},this._bindEvent(e(document),"move",function(e){t.is.drag&&(e.stopPropagation(),e.preventDefault(),t._mousemove(e))}),this._bindEvent(e(document),"down",function(e){t.is.drag&&(e.stopPropagation(),e.preventDefault())}),this._bindEvent(e(document),"up",function(e){t._mouseup(e)}),this._bindEvent(this.ptr,"down",function(e){return t._mousedown(e),!1}),this._bindEvent(this.ptr,"up",function(e){t._mouseup(e)}),this.ptr.find("a").click(function(){t.is.clicked=!0;if(!t.is.toclick)return t.is.toclick=!0,!1}).mousedown(function(e){return t._mousedown(e),!1}),this.events()},t.prototype._mousedown=function(t){this.is.drag=!0,this.is.clicked=!1,this.is.mouseup=!1;var n=this.ptr.offset(),r=this._getPageCoords(t);this.cx=r.x-n.left,this.cy=r.y-n.top,e.extend(this.d,{left:n.left,top:n.top,width:this.ptr.width(),height:this.ptr.height()}),this.outer&&this.outer.get(0)&&this.outer.css({height:Math.max(this.outer.height(),e(document.body).height()),overflow:"hidden"}),this.onmousedown(t)},t.prototype._mousemove=function(e){this.is.toclick=!1;var t=this._getPageCoords(e);this.onmousemove(e,t.x-this.cx,t.y-this.cy)},t.prototype._mouseup=function(t){var n=this;this.is.drag&&(this.is.drag=!1,this.outer&&this.outer.get(0)&&(browser.ff?this.outer.css({overflow:"hidden"}):this.outer.css({overflow:"visible"}),browser.ie&&browser.version==6?this.outer.css({height:"100%"}):this.outer.css({height:"auto"})),this.onmouseup(t))},window.Draggable=t}(jQuery),function(e){function t(e){return typeof e=="undefined"?!1:e instanceof Array||!(e instanceof Object)&&Object.prototype.toString.call(e)=="[object Array]"||typeof e.length=="number"&&typeof e.splice!="undefined"&&typeof e.propertyIsEnumerable!="undefined"&&!e.propertyIsEnumerable("splice")?!0:!1}function r(){return this.init.apply(this,arguments)}function i(){Draggable.apply(this,arguments)}e.slider=function(t,n){var i=e(t);return i.data("jslider")||i.data("jslider",new r(t,n)),i.data("jslider")},e.fn.slider=function(n,r){function o(e){return e!==undefined}function u(e){return e!=null}var i,s=arguments;return this.each(function(){var a=e.slider(this,n);if(typeof n=="string")switch(n){case"value":if(o(s[1])&&o(s[2])){var f=a.getPointers();u(f[0])&&u(s[1])&&(f[0].set(s[1]),f[0].setIndexOver()),u(f[1])&&u(s[2])&&(f[1].set(s[2]),f[1].setIndexOver())}else if(o(s[1])){var f=a.getPointers();u(f[0])&&u(s[1])&&(f[0].set(s[1]),f[0].setIndexOver())}else i=a.getValue();break;case"prc":if(o(s[1])&&o(s[2])){var f=a.getPointers();u(f[0])&&u(s[1])&&(f[0]._set(s[1]),f[0].setIndexOver()),u(f[1])&&u(s[2])&&(f[1]._set(s[2]),f[1].setIndexOver())}else if(o(s[1])){var f=a.getPointers();u(f[0])&&u(s[1])&&(f[0]._set(s[1]),f[0].setIndexOver())}else i=a.getPrcValue();break;case"calculatedValue":var l=a.getValue().split(";");i="";for(var c=0;c<l.length;c++)i+=(c>0?";":"")+a.nice(l[c]);break;case"skin":a.setSkin(s[1])}else!n&&!r&&(t(i)||(i=[]),i.push(a))}),t(i)&&i.length==1&&(i=i[0]),i||this};var n={settings:{from:1,to:10,step:1,smooth:!0,limits:!0,round:0,format:{format:"#,##0.##"},value:"5;7",dimension:""},className:"jslider",selector:".jslider-",template:tmpl('<span class="<%=className%>"><table><tr><td><div class="<%=className%>-bg"><i class="l"></i><i class="f"></i><i class="r"></i><i class="v"></i></div><div class="<%=className%>-pointer"></div><div class="<%=className%>-pointer <%=className%>-pointer-to"></div><div class="<%=className%>-label"><span><%=settings.from%></span></div><div class="<%=className%>-label <%=className%>-label-to"><span><%=settings.to%></span><%=settings.dimension%></div><div class="<%=className%>-value"><span></span><%=settings.dimension%></div><div class="<%=className%>-value <%=className%>-value-to"><span></span><%=settings.dimension%></div><div class="<%=className%>-scale"><%=scale%></div></td></tr></table></span>')};r.prototype.init=function(t,r){this.settings=e.extend(!0,{},n.settings,r?r:{}),this.inputNode=e(t).hide(),this.settings.interval=this.settings.to-this.settings.from,this.settings.value=this.inputNode.attr("value"),this.settings.calculate&&e.isFunction(this.settings.calculate)&&(this.nice=this.settings.calculate),this.settings.onstatechange&&e.isFunction(this.settings.onstatechange)&&(this.onstatechange=this.settings.onstatechange),this.is={init:!1},this.o={},this.create()},r.prototype.onstatechange=function(){},r.prototype.create=function(){var t=this;this.domNode=e(n.template({className:n.className,settings:{from:this.nice(this.settings.from),to:this.nice(this.settings.to),dimension:this.settings.dimension},scale:this.generateScale()})),this.inputNode.after(this.domNode),this.drawScale(),this.settings.skin&&this.settings.skin.length>0&&this.setSkin(this.settings.skin),this.sizes={domWidth:this.domNode.width(),domOffset:this.domNode.offset()},e.extend(this.o,{pointers:{},labels:{0:{o:this.domNode.find(n.selector+"value").not(n.selector+"value-to")},1:{o:this.domNode.find(n.selector+"value").filter(n.selector+"value-to")}},limits:{0:this.domNode.find(n.selector+"label").not(n.selector+"label-to"),1:this.domNode.find(n.selector+"label").filter(n.selector+"label-to")}}),e.extend(this.o.labels[0],{value:this.o.labels[0].o.find("span")}),e.extend(this.o.labels[1],{value:this.o.labels[1].o.find("span")}),t.settings.value.split(";")[1]||(this.settings.single=!0,this.domNode.addDependClass("single")),t.settings.limits||this.domNode.addDependClass("limitless"),this.domNode.find(n.selector+"pointer").each(function(e){var n=t.settings.value.split(";")[e];if(n){t.o.pointers[e]=new i(this,e,t);var r=t.settings.value.split(";")[e-1];r&&new Number(n)<new Number(r)&&(n=r),n=n<t.settings.from?t.settings.from:n,n=n>t.settings.to?t.settings.to:n,t.o.pointers[e].set(n,!0)}}),this.o.value=this.domNode.find(".v"),this.is.init=!0,e.each(this.o.pointers,function(e){t.redraw(this)}),function(t){e(window).resize(function(){t.onresize()})}(this)},r.prototype.setSkin=function(e){this.skin_&&this.domNode.removeDependClass(this.skin_,"_"),this.domNode.addDependClass(this.skin_=e,"_")},r.prototype.setPointersIndex=function(t){e.each(this.getPointers(),function(e){this.index(e)})},r.prototype.getPointers=function(){return this.o.pointers},r.prototype.generateScale=function(){if(this.settings.scale&&this.settings.scale.length>0){var e="",t=this.settings.scale,n=Math.round(100/(t.length-1)*10)/10;for(var r=0;r<t.length;r++)e+='<span style="left: '+r*n+'%">'+(t[r]!="|"?"<ins>"+t[r]+"</ins>":"")+"</span>";return e}return""},r.prototype.drawScale=function(){this.domNode.find(n.selector+"scale span ins").each(function(){e(this).css({marginLeft:-e(this).outerWidth()/2})})},r.prototype.onresize=function(){var t=this;this.sizes={domWidth:this.domNode.width(),domOffset:this.domNode.offset()},e.each(this.o.pointers,function(e){t.redraw(this)})},r.prototype.update=function(){this.onresize(),this.drawScale()},r.prototype.limits=function(e,t){if(!this.settings.smooth){var n=this.settings.step*100/this.settings.interval;e=Math.round(e/n)*n}var r=this.o.pointers[1-t.uid];return r&&t.uid&&e<r.value.prc&&(e=r.value.prc),r&&!t.uid&&e>r.value.prc&&(e=r.value.prc),e<0&&(e=0),e>100&&(e=100),Math.round(e*10)/10},r.prototype.redraw=function(e){if(!this.is.init)return!1;this.setValue(),this.o.pointers[0]&&this.o.pointers[1]&&this.o.value.css({left:this.o.pointers[0].value.prc+"%",width:this.o.pointers[1].value.prc-this.o.pointers[0].value.prc+"%"}),this.o.labels[e.uid].value.html(this.nice(e.value.origin)),this.redrawLabels(e)},r.prototype.redrawLabels=function(e){function t(e,t,r){return t.margin=-t.label/2,label_left=t.border+t.margin,label_left<0&&(t.margin-=label_left),t.border+t.label/2>n.sizes.domWidth?(t.margin=0,t.right=!0):t.right=!1,e.o.css({left:r+"%",marginLeft:t.margin,right:"auto"}),t.right&&e.o.css({left:"auto",right:0}),t}var n=this,r=this.o.labels[e.uid],i=e.value.prc,s={label:r.o.outerWidth(),right:!1,border:i*this.sizes.domWidth/100};if(!this.settings.single){var o=this.o.pointers[1-e.uid],u=this.o.labels[o.uid];switch(e.uid){case 0:s.border+s.label/2>u.o.offset().left-this.sizes.domOffset.left?(u.o.css({visibility:"hidden"}),u.value.html(this.nice(o.value.origin)),r.o.css({visibility:"visible"}),i=(o.value.prc-i)/2+i,o.value.prc!=e.value.prc&&(r.value.html(this.nice(e.value.origin)+"&nbsp;&ndash;&nbsp;"+this.nice(o.value.origin)),s.label=r.o.outerWidth(),s.border=i*this.sizes.domWidth/100)):u.o.css({visibility:"visible"});break;case 1:s.border-s.label/2<u.o.offset().left-this.sizes.domOffset.left+u.o.outerWidth()?(u.o.css({visibility:"hidden"}),u.value.html(this.nice(o.value.origin)),r.o.css({visibility:"visible"}),i=(i-o.value.prc)/2+o.value.prc,o.value.prc!=e.value.prc&&(r.value.html(this.nice(o.value.origin)+"&nbsp;&ndash;&nbsp;"+this.nice(e.value.origin)),s.label=r.o.outerWidth(),s.border=i*this.sizes.domWidth/100)):u.o.css({visibility:"visible"})}}s=t(r,s,i);if(u){var s={label:u.o.outerWidth(),right:!1,border:o.value.prc*this.sizes.domWidth/100};s=t(u,s,o.value.prc)}this.redrawLimits()},r.prototype.redrawLimits=function(){if(this.settings.limits){var e=[!0,!0];for(key in this.o.pointers)if(!this.settings.single||key==0){var t=this.o.pointers[key],n=this.o.labels[t.uid],r=n.o.offset().left-this.sizes.domOffset.left,i=this.o.limits[0];r<i.outerWidth()&&(e[0]=!1);var i=this.o.limits[1];r+n.o.outerWidth()>this.sizes.domWidth-i.outerWidth()&&(e[1]=!1)}for(var s=0;s<e.length;s++)e[s]?this.o.limits[s].fadeIn("fast"):this.o.limits[s].fadeOut("fast")}},r.prototype.setValue=function(){var e=this.getValue();this.inputNode.attr("value",e),this.onstatechange.call(this,e)},r.prototype.getValue=function(){if(!this.is.init)return!1;var t=this,n="";return e.each(this.o.pointers,function(e){this.value.prc!=undefined&&!isNaN(this.value.prc)&&(n+=(e>0?";":"")+t.prcToValue(this.value.prc))}),n},r.prototype.getPrcValue=function(){if(!this.is.init)return!1;var t=this,n="";return e.each(this.o.pointers,function(e){this.value.prc!=undefined&&!isNaN(this.value.prc)&&(n+=(e>0?";":"")+this.value.prc)}),n},r.prototype.prcToValue=function(e){if(this.settings.heterogeneity&&this.settings.heterogeneity.length>0){var t=this.settings.heterogeneity,n=0,r=this.settings.from;for(var i=0;i<=t.length;i++){if(t[i])var s=t[i].split("/");else var s=[100,this.settings.to];s[0]=new Number(s[0]),s[1]=new Number(s[1]);if(e>=n&&e<=s[0])var o=r+(e-n)*(s[1]-r)/(s[0]-n);n=s[0],r=s[1]}}else var o=this.settings.from+e*this.settings.interval/100;return this.round(o)},r.prototype.valueToPrc=function(e,t){if(this.settings.heterogeneity&&this.settings.heterogeneity.length>0){var n=this.settings.heterogeneity,r=0,i=this.settings.from;for(var s=0;s<=n.length;s++){if(n[s])var o=n[s].split("/");else var o=[100,this.settings.to];o[0]=new Number(o[0]),o[1]=new Number(o[1]);if(e>=i&&e<=o[1])var u=t.limits(r+(e-i)*(o[0]-r)/(o[1]-i));r=o[0],i=o[1]}}else var u=t.limits((e-this.settings.from)*100/this.settings.interval);return u},r.prototype.round=function(e){return e=Math.round(e/this.settings.step)*this.settings.step,this.settings.round?e=Math.round(e*Math.pow(10,this.settings.round))/Math.pow(10,this.settings.round):e=Math.round(e),e},r.prototype.nice=function(t){return t=t.toString().replace(/,/gi,".").replace(/ /gi,""),e.formatNumber?e.formatNumber(new Number(t),this.settings.format||{}).replace(/-/gi,"&minus;"):new Number(t)},i.prototype=new Draggable,i.prototype.oninit=function(e,t,n){this.uid=t,this.parent=n,this.value={},this.settings=this.parent.settings},i.prototype.onmousedown=function(e){this._parent={offset:this.parent.domNode.offset(),width:this.parent.domNode.width()},this.ptr.addDependClass("hover"),this.setIndexOver()},i.prototype.onmousemove=function(e,t){var n=this._getPageCoords(e);this._set(this.calc(n.x))},i.prototype.onmouseup=function(t){this.parent.settings.callback&&e.isFunction(this.parent.settings.callback)&&this.parent.settings.callback.call(this.parent,this.parent.getValue()),this.ptr.removeDependClass("hover")},i.prototype.setIndexOver=function(){this.parent.setPointersIndex(1),this.index(2)},i.prototype.index=function(e){this.ptr.css({zIndex:e})},i.prototype.limits=function(e){return this.parent.limits(e,this)},i.prototype.calc=function(e){var t=this.limits((e-this._parent.offset.left)*100/this._parent.width);return t},i.prototype.set=function(e,t){this.value.origin=this.parent.round(e),this._set(this.parent.valueToPrc(e,this),t)},i.prototype._set=function(e,t){t||(this.value.origin=this.parent.prcToValue(e)),this.value.prc=e,this.ptr.css({left:e+"%"}),this.parent.redraw(this)}}(jQuery);
; /**
 *  Zebra_DatePicker
 *
 *  Zebra_DatePicker is a small, compact and highly configurable date picker plugin for jQuery
 *
 *  Visit {@link http://stefangabos.ro/jquery/zebra-datepicker/} for more information.
 *
 *  For more resources visit {@link http://stefangabos.ro/}
 *
 *  @author     Stefan Gabos <contact@stefangabos.ro>
 *  @version    1.8.7 (last revision: October 12, 2013)
 *  @copyright  (c) 2011 - 2013 Stefan Gabos
 *  @license    http://www.gnu.org/licenses/lgpl-3.0.txt GNU LESSER GENERAL PUBLIC LICENSE
 *  @package    Zebra_DatePicker
 */
;
(function ($) {

    $.Zebra_DatePicker = function (element, options) {

        var defaults = {

            //  setting this property to a jQuery element, will result in the date picker being always visible, the indicated
            //  element being the date picker's container;
            always_visible: false,

            //  days of the week; Sunday to Saturday
            days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],

            //  by default, the abbreviated name of a day consists of the first 2 letters from the day's full name;
            //  while this is common for most languages, there are also exceptions for languages like Thai, Loa, Myanmar,
            //  etc. where this is not correct; for these cases, specify an array with the abbreviations to be used for
            //  the 7 days of the week; leave it FALSE to use the first 2 letters of a day's name as the abbreviation.
            //
            //  default is FALSE
            days_abbr: false,

            //  direction of the calendar
            //
            //  a positive or negative integer: n (a positive integer) creates a future-only calendar beginning at n days
            //  after today; -n (a negative integer); if n is 0, the calendar has no restrictions. use boolean true for
            //  a future-only calendar starting with today and use boolean false for a past-only calendar ending today.
            //
            //  you may also set this property to an array with two elements in the following combinations:
            //
            //  -   first item is boolean TRUE (calendar starts today), an integer > 0 (calendar starts n days after
            //      today), or a valid date given in the format defined by the "format" attribute, using English for
            //      month names (calendar starts at the specified date), and the second item is boolean FALSE (the calendar
            //      has no ending date), an integer > 0 (calendar ends n days after the starting date), or a valid date
            //      given in the format defined by the "format" attribute, using English for month names, and which occurs
            //      after the starting date (calendar ends at the specified date)
            //
            //  -   first item is boolean FALSE (calendar ends today), an integer < 0 (calendar ends n days before today),
            //      or a valid date given in the format defined by the "format" attribute, using English for month names
            //      (calendar ends at the specified date), and the second item is an integer > 0 (calendar ends n days
            //      before the ending date), or a valid date given in the format defined by the "format" attribute, using
            //      English for month names  and which occurs before the starting date (calendar starts at the specified
            //      date)
            //
            //  [1, 7] - calendar starts tomorrow and ends seven days after that
            //  [true, 7] - calendar starts today and ends seven days after that
            //  ['2013-01-01', false] - calendar starts on January 1st 2013 and has no ending date ("format" is YYYY-MM-DD)
            //  [false, '2012-01-01'] - calendar ends today and starts on January 1st 2012 ("format" is YYYY-MM-DD)
            //
            //  note that "disabled_dates" property will still apply!
            //
            //  default is 0 (no restrictions)
            direction: 0,

            //  an array of disabled dates in the following format: 'day month year weekday' where "weekday" is optional
            //  and can be 0-6 (Saturday to Sunday); the syntax is similar to cron's syntax: the values are separated by
            //  spaces and may contain * (asterisk) - (dash) and , (comma) delimiters:
            //
            //  ['1 1 2012'] would disable January 1, 2012;
            //  ['* 1 2012'] would disable all days in January 2012;
            //  ['1-10 1 2012'] would disable January 1 through 10 in 2012;
            //  ['1,10 1 2012'] would disable January 1 and 10 in 2012;
            //  ['1-10,20,22,24 1-3 *'] would disable 1 through 10, plus the 22nd and 24th of January through March for every year;
            //  ['* * * 0,6'] would disable all Saturdays and Sundays;
            //  ['01 07 2012', '02 07 2012', '* 08 2012'] would disable 1st and 2nd of July 2012, and all of August of 2012
            //
            //  default is FALSE, no disabled dates
            disabled_dates: false,

            //  an array of enabled dates in the same format as required for "disabled_dates" property.
            //  to be used together with the "disabled_dates" property by first setting the "disabled_dates" property to
            //  something like "[* * * *]" (which will disable everything) and the setting the "enabled_dates" property to,
            //  say, "[* * * 0,6]" to enable just weekends.
            enabled_dates: false,

            //  week's starting day
            //
            //  valid values are 0 to 6, Sunday to Saturday
            //
            //  default is 1, Monday
            first_day_of_week: 1,

            //  format of the returned date
            //
            //  accepts the following characters for date formatting: d, D, j, l, N, w, S, F, m, M, n, Y, y borrowing
            //  syntax from (PHP's date function)
            //
            //  note that when setting a date format without days ('d', 'j'), the users will be able to select only years
            //  and months, and when setting a format without months and days ('F', 'm', 'M', 'n', 'd', 'j'), the
            //  users will be able to select only years; likewise, when setting a date format with just months ('F', 'm',
            //  'M', 'n') or just years ('Y', 'y'), users will be able to select only months and years, respectively.
            //
            //  also note that the value of the "view" property (see below) may be overridden if it is the case: a value of
            //  "days" for the "view" property makes no sense if the date format doesn't allow the selection of days.
            //
            //  default is yyyy-MM-dd
            format: 'yyyy-MM-dd',

            //  HTML to be used for the previous month/next month buttons
            //
            //  default is ['&#171;','&#187;']

            header_navigation: ['&#171;', '&#187;'],

            //  time picker UI style
            //  'classic' - original range sliders for Hour / Minute / Second (default)
            //  'modern'  - side-by-side calendar + scrollable 12h hour list with AM/PM toggle + OK button
            //
            //  'modern' requires that plugin.settings.time is truthy
            //
            //  default is 'modern'
            time_style: 'modern',

            //  should the icon for opening the datepicker be inside the element?
            //  if set to FALSE, the icon will be placed to the right of the parent element, while if set to TRUE it will
            //  be placed to the right of the parent element, but *inside* the element itself
            //
            //  default is TRUE
            inside: true,

            //  the caption for the "Clear" button
            lang_clear_date: 'Clear date',

            //  months names
            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],

            //  by default, the abbreviated name of a month consists of the first 3 letters from the month's full name;
            //  while this is common for most languages, there are also exceptions for languages like Thai, Loa, Myanmar,
            //  etc. where this is not correct; for these cases, specify an array with the abbreviations to be used for
            //  the months of the year; leave it FALSE to use the first 3 letters of a month's name as the abbreviation.
            //
            //  default is FALSE
            months_abbr: false,

            //  the offset, in pixels (x, y), to shift the date picker's position relative to the top-right of the icon
            //  that toggles the date picker or, if the icon is disabled, relative to the top-right corner of the element
            //  the plugin is attached to.
            //
            //  note that this only applies if the position of element relative to the browser's viewport doesn't require
            //  the date picker to be placed automatically so that it is visible!
            //
            //  default is [5, -5]
            offset: [5, -5],

            //  if set as a jQuery element with a Zebra_DatePicker attached, that particular date picker will use the
            //  current date picker's value as starting date
            //  note that the rules set in the "direction" property will still apply, only that the reference date will
            //  not be the current system date but the value selected in the current date picker
            //  default is FALSE (not paired with another date picker)
            pair: false,

            //  should the element the calendar is attached to, be read-only?
            //  if set to TRUE, a date can be set only through the date picker and cannot be entered manually
            //
            //  default is TRUE
            readonly_element: true,

            //  should days from previous and/or next month be selectable when visible?
            //  note that if the value of this property is set to TRUE, the value of "show_other_months" will be considered
            //  TRUE regardless of the actual value!
            //
            //  default is FALSE
            select_other_months: false,

            //  should the "Clear date" button be visible?
            //
            //  accepted values are:
            //
            //  - 0 (zero) - the button for clearing a previously selected date is shown only if a previously selected date
            //  already exists; this means that if the input the date picker is attached to is empty, and the user selects
            //  a date for the first time, this button will not be visible; once the user picked a date and opens the date
            //  picker again, this time the button will be visible.
            //
            //  - TRUE will make the button visible all the time
            //
            //  - FALSE will disable the button
            //
            //  default is "0" (without quotes)
            show_clear_date: 0,

            //  should a calendar icon be added to the elements the plugin is attached to?
            //
            //  default is TRUE
            show_icon: true,

            //  should days from previous and/or next month be visible?
            //
            //  default is TRUE
            show_other_months: true,

            //  should the "Today" button be visible?
            //  setting it to anything but boolean FALSE will enable the button and will use the property's value as
            //  caption for the button; setting it to FALSE will disable the button
            //
            //  default is "Today"
            show_select_today: 'Today',

            //  should an extra column be shown, showing the number of each week?
            //  anything other than FALSE will enable this feature, and use the given value as column title
            //  i.e. show_week_number: 'Wk' would enable this feature and have "Wk" as the column's title
            //
            //  default is FALSE
            show_week_number: false,

            //  a default date to start the date picker with
            //  must be specified in the format defined by the "format" property, or it will be ignored!
            //  note that this value is used only if there is no value in the field the date picker is attached to!
            start_date: false,

            //  should default values, in the input field the date picker is attached to, be deleted if they are not valid
            //  according to "direction" and/or "disabled_dates"?
            //
            //  default is FALSE
            strict: false,

            //  how should the date picker start; valid values are "days", "months" and "years"
            //  note that the date picker is always cycling days-months-years when clicking in the date picker's header,
            //  and years-months-days when selecting dates (unless one or more of the views are missing due to the date's
            //  format)
            //
            //  also note that the value of the "view" property may be overridden if the date's format requires so! (i.e.
            //  "days" for the "view" property makes no sense if the date format doesn't allow the selection of days)
            //
            //  default is "days"
            view: 'days',

            //  days of the week that are considered "weekend days"
            //  valid values are 0 to 6, Sunday to Saturday
            //
            //  default values are 0 and 6 (Saturday and Sunday)
            weekend_days: [0, 6],

            //  when set to TRUE, day numbers < 10 will be prefixed with 0; set to FALSE if you don't want that
            //
            //  default is TRUE
            zero_pad: false,

            //  callback function to be executed whenever the user changes the view (days/months/years), as well as when
            //  the user navigates by clicking on the "next"/"previous" icons in any of the views;
            //
            //  the callback function called by this event takes 3 arguments - the first argument represents the current
            //  view (can be "days", "months" or "years"), the second argument represents an array containing the "active"
            //  elements (not disabled) from the view, as jQuery elements, allowing for easy customization and interaction
            //  with particular cells in the date picker's view, while the third argument is a reference to the element
            //  the date picker is attached to, as a jQuery object
            //
            //  for simplifying searching for particular dates, each element in the second argument will also have a
            //  "date" data attribute whose format depends on the value of the "view" argument:
            //  - YYYY-MM-DD for elements in the "days" view
            //  - YYYY-MM for elements in the "months" view
            //  - YYYY for elements in the "years" view
            onChange: null,

            //  callback function to be executed when the user clicks the "Clear" button
            //  the callback function takes a single argument:
            //  -   a reference to the element the date picker is attached to, as a jQuery object
            onClear: null,

            //  callback function to be executed when a date is selected
            //  the callback function takes 4 arguments:
            //  -   the date in the format specified by the "format" attribute;
            //  -   the date in YYYY-MM-DD format
            //  -   the date as a JavaScript Date object
            //  -   a reference to the element the date picker is attached to, as a jQuery object
            onSelect: null

        };

        // private properties
        var view, datepicker, icon, header, daypicker, timepicker, monthpicker, yearpicker, cleardate, current_system_month, current_system_year,
            current_system_day, first_selectable_month, first_selectable_year, first_selectable_day, selected_month, selected_year, selected_hour = 0, selected_minute = 0, selected_second = 0,
            selected_day, default_day, default_month, default_year, enabled_dates, disabled_dates, shim, start_date, end_date, last_selectable_day,
            last_selectable_year, last_selectable_month, daypicker_cells, monthpicker_cells, yearpicker_cells, views, clickables,
            selecttoday, footer, show_select_today, timeout;

        var plugin = this;

        plugin.settings = {};

        // the jQuery version of the element
        // "element" (without the $) will point to the DOM element
        var $element = $(element);

        /**
         *  Constructor method. Initializes the date picker.
         *
         *  @return void
         */
        var init = function (update) {

            // unless we're just updating settings
            if (!update) {

                // merge default settings with user-settings (
                plugin.settings = $.extend({}, defaults, options);

                // iterate through the element's data attributes (if any)
                for (var data in $element.data())

                    // if data attribute's name starts with "zdp_"
                    if (data.indexOf('zdp_') === 0) {

                        // remove the "zdp_" prefix
                        data = data.replace(/^zdp\_/, '');

                        // if such a property exists
                        if (undefined !== defaults[data])

                            // update the property's value
                            plugin.settings[data] = $element.data('zdp_' + data);

                    }

            }

            // if the element should be read-only, set the "readonly" attribute
            if (plugin.settings.readonly_element) $element.attr('readonly', 'readonly');

            // determine the views the user can cycle through, depending on the format
            // that is, if the format doesn't contain the day, the user will be able to cycle only through years and months,
            // whereas if the format doesn't contain months nor days, the user will only be able to select years

            var

                // the characters that may be present in the date format and that represent days, months and years
                date_chars = {
                    days: ['d', 'j', 'D'],
                    months: ['F', 'm', 'M', 'n', 't'],
                    years: ['o', 'Y', 'y']
                },

                // some defaults
                has_days = false,
                has_months = false,
                has_years = false,
                type = null;

            // iterate through all the character blocks
            for (type in date_chars)

                // iterate through the characters of each block
                $.each(date_chars[type], function (index, character) {

                    // if current character exists in the "format" property
                    if (plugin.settings.format.indexOf(character) > -1)

                        // set to TRUE the appropriate flag
                        if (type == 'days') has_days = true;
                        else if (type == 'months') has_months = true;
                        else if (type == 'years') has_years = true;

                });

            // if user can cycle through all the views, set the flag accordingly
            if (has_days && has_months && has_years) views = ['years', 'months', 'days'];

            // if user can cycle only through year and months, set the flag accordingly
            else if (!has_days && has_months && has_years) views = ['years', 'months'];

            // if user can only see the year picker, set the flag accordingly
            else if (!has_days && !has_months && has_years) views = ['years'];

            // if user can only see the month picker, set the flag accordingly
            else if (!has_days && has_months && !has_years) views = ['months'];

                // if invalid format (no days, no months, no years) use the default where the user is able to cycle through
            // all the views
            else views = ['years', 'months', 'days'];

            // if the starting view is not amongst the views the user can cycle through, set the correct starting view
            if ($.inArray(plugin.settings.view, views) == -1) plugin.settings.view = views[views.length - 1];

            // parse the rules for disabling dates and turn them into arrays of arrays

            // array that will hold the rules for enabling/disabling dates
            disabled_dates = [];
            enabled_dates = [];

            var dates;

            // it's the same logic for preparing the enabled/disable dates...
            for (var l = 0; l < 2; l++) {

                // first time we're doing disabled dates,
                if (l === 0) dates = plugin.settings.disabled_dates;

                // second time we're doing enabled_dates
                else dates = plugin.settings.enabled_dates;

                // if we have a non-empty array
                if ($.isArray(dates) && dates.length > 0)

                    // iterate through the rules
                    $.each(dates, function () {

                        // split the values in rule by white space
                        var rules = this.split(' ');

                        // there can be a maximum of 4 rules (days, months, years and, optionally, day of the week)
                        for (var i = 0; i < 4; i++) {

                            // if one of the values is not available
                            // replace it with a * (wildcard)
                            if (!rules[i]) rules[i] = '*';

                            // if rule contains a comma, create a new array by splitting the rule by commas
                            // if there are no commas create an array containing the rule's string
                            rules[i] = (rules[i].indexOf(',') > -1 ? rules[i].split(',') : new Array(rules[i]));

                            // iterate through the items in the rule
                            for (var j = 0; j < rules[i].length; j++)

                                // if item contains a dash (defining a range)
                                if (rules[i][j].indexOf('-') > -1) {

                                    // get the lower and upper limits of the range
                                    var limits = rules[i][j].match(/^([0-9]+)\-([0-9]+)/);

                                    // if range is valid
                                    if (null !== limits) {

                                        // iterate through the range
                                        for (var k = to_int(limits[1]); k <= to_int(limits[2]); k++)

                                            // if value is not already among the values of the rule
                                            // add it to the rule
                                            if ($.inArray(k, rules[i]) == -1) rules[i].push(k + '');

                                        // remove the range indicator
                                        rules[i].splice(j, 1);

                                    }

                                }

                            // iterate through the items in the rule
                            // and make sure that numbers are numbers
                            for (j = 0; j < rules[i].length; j++) rules[i][j] = (isNaN(to_int(rules[i][j])) ? rules[i][j] : to_int(rules[i][j]));

                        }

                        // add to the correct list of processed rules
                        // first time we're doing disabled dates,
                        if (l === 0) disabled_dates.push(rules);

                        // second time we're doing enabled_dates
                        else enabled_dates.push(rules);

                    });

            }

            var

                // cache the current system date
                date = new Date(),

                // when the date picker's starting date depends on the value of another date picker, this value will be
                // set by the other date picker
                // this value will be used as base for all calculations (if not set, will be the same as the current
                // system date)
                reference_date = (!plugin.settings.reference_date ? ($element.data('zdp_reference_date') && undefined !== $element.data('zdp_reference_date') ? $element.data('zdp_reference_date') : date) : plugin.settings.reference_date),

                tmp_start_date, tmp_end_date;

            // reset these values here as this method might be called more than once during a date picker's lifetime
            // (when the selectable dates depend on the values from another date picker)
            start_date = undefined;
            end_date = undefined;

            // extract the date parts
            // also, save the current system month/day/year - we'll use them to highlight the current system date
            first_selectable_month = reference_date.getMonth();
            current_system_month = date.getMonth();
            first_selectable_year = reference_date.getFullYear();
            current_system_year = date.getFullYear();
            first_selectable_day = reference_date.getDate();
            current_system_day = date.getDate();

            // check if the calendar has any restrictions

            // calendar is future-only, starting today
            // it means we have a starting date (the current system date), but no ending date
            if (plugin.settings.direction === true) start_date = reference_date;

            // calendar is past only, ending today
            else if (plugin.settings.direction === false) {

                // it means we have an ending date (the reference date), but no starting date
                end_date = reference_date;

                // extract the date parts
                last_selectable_month = end_date.getMonth();
                last_selectable_year = end_date.getFullYear();
                last_selectable_day = end_date.getDate();

            } else if (

                // if direction is not given as an array and the value is an integer > 0
                (!$.isArray(plugin.settings.direction) && is_integer(plugin.settings.direction) && to_int(plugin.settings.direction) > 0) ||

                // or direction is given as an array
                ($.isArray(plugin.settings.direction) && (

                    // and first entry is a valid date
                    (tmp_start_date = check_date(plugin.settings.direction[0])) ||
                    // or a boolean TRUE
                    plugin.settings.direction[0] === true ||
                    // or an integer > 0
                    (is_integer(plugin.settings.direction[0]) && plugin.settings.direction[0] > 0)

                ) && (

                    // and second entry is a valid date
                    (tmp_end_date = check_date(plugin.settings.direction[1])) ||
                    // or a boolean FALSE
                    plugin.settings.direction[1] === false ||
                    // or integer >= 0
                    (is_integer(plugin.settings.direction[1]) && plugin.settings.direction[1] >= 0)

                ))

            ) {

                // if an exact starting date was given, use that as a starting date
                if (tmp_start_date) start_date = tmp_start_date;

                // otherwise
                else

                    // figure out the starting date
                    // use the Date object to normalize the date
                    // for example, 2011 05 33 will be transformed to 2011 06 02
                    start_date = new Date(
                        first_selectable_year,
                        first_selectable_month,
                        first_selectable_day + (!$.isArray(plugin.settings.direction) ? to_int(plugin.settings.direction) : to_int(plugin.settings.direction[0] === true ? 0 : plugin.settings.direction[0]))
                    );

                // re-extract the date parts
                first_selectable_month = start_date.getMonth();
                first_selectable_year = start_date.getFullYear();
                first_selectable_day = start_date.getDate();

                // if an exact ending date was given and the date is after the starting date, use that as a ending date
                if (tmp_end_date && +tmp_end_date >= +start_date) end_date = tmp_end_date;

                // if have information about the ending date
                else if (!tmp_end_date && plugin.settings.direction[1] !== false && $.isArray(plugin.settings.direction))

                    // figure out the ending date
                    // use the Date object to normalize the date
                    // for example, 2011 05 33 will be transformed to 2011 06 02
                    end_date = new Date(
                        first_selectable_year,
                        first_selectable_month,
                        first_selectable_day + to_int(plugin.settings.direction[1])
                    );

                // if a valid ending date exists
                if (end_date) {

                    // extract the date parts
                    last_selectable_month = end_date.getMonth();
                    last_selectable_year = end_date.getFullYear();
                    last_selectable_day = end_date.getDate();

                }

            } else if (

                // if direction is not given as an array and the value is an integer < 0
                (!$.isArray(plugin.settings.direction) && is_integer(plugin.settings.direction) && to_int(plugin.settings.direction) < 0) ||

                // or direction is given as an array
                ($.isArray(plugin.settings.direction) && (

                    // and first entry is boolean FALSE
                    plugin.settings.direction[0] === false ||
                    // or an integer < 0
                    (is_integer(plugin.settings.direction[0]) && plugin.settings.direction[0] < 0)

                ) && (

                    // and second entry is a valid date
                    (tmp_start_date = check_date(plugin.settings.direction[1])) ||
                    // or an integer >= 0
                    (is_integer(plugin.settings.direction[1]) && plugin.settings.direction[1] >= 0)

                ))

            ) {

                // figure out the ending date
                // use the Date object to normalize the date
                // for example, 2011 05 33 will be transformed to 2011 06 02
                end_date = new Date(
                    first_selectable_year,
                    first_selectable_month,
                    first_selectable_day + (!$.isArray(plugin.settings.direction) ? to_int(plugin.settings.direction) : to_int(plugin.settings.direction[0] === false ? 0 : plugin.settings.direction[0]))
                );

                // re-extract the date parts
                last_selectable_month = end_date.getMonth();
                last_selectable_year = end_date.getFullYear();
                last_selectable_day = end_date.getDate();

                // if an exact starting date was given, and the date is before the ending date, use that as a starting date
                if (tmp_start_date && +tmp_start_date < +end_date) start_date = tmp_start_date;

                // if have information about the starting date
                else if (!tmp_start_date && $.isArray(plugin.settings.direction))

                    // figure out the staring date
                    // use the Date object to normalize the date
                    // for example, 2011 05 33 will be transformed to 2011 06 02
                    start_date = new Date(
                        last_selectable_year,
                        last_selectable_month,
                        last_selectable_day - to_int(plugin.settings.direction[1])
                    );

                // if a valid starting date exists
                if (start_date) {

                    // extract the date parts
                    first_selectable_month = start_date.getMonth();
                    first_selectable_year = start_date.getFullYear();
                    first_selectable_day = start_date.getDate();

                }

                // if there are disabled dates
            } else if ($.isArray(plugin.settings.disabled_dates) && plugin.settings.disabled_dates.length > 0)

                // iterate through the rules for disabling dates
                for (var interval in disabled_dates)

                    // only if there is a rule that disables *everything*
                    if (disabled_dates[interval][0] == '*' && disabled_dates[interval][1] == '*' && disabled_dates[interval][2] == '*' && disabled_dates[interval][3] == '*') {

                        var tmpDates = [];

                        // iterate through the rules for enabling dates
                        // looking for the minimum/maximum selectable date (if it's the case)
                        $.each(enabled_dates, function () {

                            var rule = this;

                            // if the rule doesn't apply to all years
                            if (rule[2][0] != '*')

                                // format date and store it in our stack
                                tmpDates.push(parseInt(
                                    rule[2][0] +
                                    (rule[1][0] == '*' ? '12' : str_pad(rule[1][0], 2)) +
                                    (rule[0][0] == '*' ? (rule[1][0] == '*' ? '31' : new Date(rule[2][0], rule[1][0], 0).getDate()) : str_pad(rule[0][0], 2)), 10));

                        });

                        // sort dates ascending
                        tmpDates.sort();

                        // if we have any rules
                        if (tmpDates.length > 0) {

                            // get date parts
                            var matches = (tmpDates[0] + '').match(/([0-9]{4})([0-9]{2})([0-9]{2})/);

                            // assign the date parts to the appropriate variables
                            first_selectable_year = parseInt(matches[1], 10);
                            first_selectable_month = parseInt(matches[2], 10) - 1;
                            first_selectable_day = parseInt(matches[3], 10);

                        }

                        // don't look further
                        break;

                    }

            // if first selectable date exists but is disabled, find the actual first selectable date
            if (is_disabled(first_selectable_year, first_selectable_month, first_selectable_day)) {

                // loop until we find the first selectable year
                while (is_disabled(first_selectable_year)) {

                    // if calendar is past-only,
                    if (!start_date) {

                        // decrement the year
                        first_selectable_year--;

                        // because we've changed years, reset the month to December
                        first_selectable_month = 11;

                        // otherwise
                    } else {

                        // increment the year
                        first_selectable_year++;

                        // because we've changed years, reset the month to January
                        first_selectable_month = 0;

                        // break the loop if last selectable date passed. No date available in this case
                        if (first_selectable_year > last_selectable_year) {
                            break;
                        }

                    }

                }

                // loop until we find the first selectable month
                while (is_disabled(first_selectable_year, first_selectable_month)) {

                    // if calendar is past-only
                    if (!start_date) {

                        // decrement the month
                        first_selectable_month--;

                        // because we've changed months, reset the day to the last day of the month
                        first_selectable_day = new Date(first_selectable_year, first_selectable_month + 1, 0).getDate();

                        // otherwise
                    } else {

                        // increment the month
                        first_selectable_month++;

                        // because we've changed months, reset the day to the first day of the month
                        first_selectable_day = 1;

                    }

                    // if we moved to a following year
                    if (first_selectable_month > 11) {

                        // increment the year
                        first_selectable_year++;

                        // reset the month to January
                        first_selectable_month = 0;

                        // because we've changed months, reset the day to the first day of the month
                        first_selectable_day = 1;

                        // if we moved to a previous year
                    } else if (first_selectable_month < 0) {

                        // decrement the year
                        first_selectable_year--;

                        // reset the month to December
                        first_selectable_month = 11;

                        // because we've changed months, reset the day to the last day of the month
                        first_selectable_day = new Date(first_selectable_year, first_selectable_month + 1, 0).getDate();

                    }

                    // break the loop if last selectable date passed. No date available in this case
                    if (first_selectable_year > last_selectable_year && first_selectable_month > last_selectable_month) {
                        break;
                    }

                }

                // loop until we find the first selectable day
                while (is_disabled(first_selectable_year, first_selectable_month, first_selectable_day)) {

                    // if calendar is past-only, decrement the day
                    if (!start_date) first_selectable_day--;

                    // otherwise, increment the day
                    else first_selectable_day++;

                    // use the Date object to normalize the date
                    // for example, 2011 05 33 will be transformed to 2011 06 02
                    date = new Date(first_selectable_year, first_selectable_month, first_selectable_day);

                    // re-extract date parts from the normalized date
                    // as we use them in the current loop
                    first_selectable_year = date.getFullYear();
                    first_selectable_month = date.getMonth();
                    first_selectable_day = date.getDate();
                    // break the loop if last selectable date passed. No date available in this case
                    if (first_selectable_year > last_selectable_year && first_selectable_month > last_selectable_month && first_selectable_day > last_selectable_day) {
                        break;
                    }

                }

                // use the Date object to normalize the date
                // for example, 2011 05 33 will be transformed to 2011 06 02
                date = new Date(first_selectable_year, first_selectable_month, first_selectable_day);

                // re-extract date parts from the normalized date
                // as we use them in the current loop
                first_selectable_year = date.getFullYear();
                first_selectable_month = date.getMonth();
                first_selectable_day = date.getDate();

            }

            // get the default date, from the element, and check if it represents a valid date, according to the required format
            var default_date = check_date($element.val() || (plugin.settings.start_date ? plugin.settings.start_date : ''));

            // if there is a default date, date picker is in "strict" mode, and the default date is disabled
            if (default_date && plugin.settings.strict && is_disabled(default_date.getFullYear(), default_date.getMonth(), default_date.getDate()))

                // clear the value of the parent element
                $element.val('');

            // updates value for the date picker whose starting date depends on the selected date (if any)
            update_dependent(default_date);

            // if date picker is not always visible
            if (!plugin.settings.always_visible) {

                // if we're just creating the date picker
                if (!update) {

                    // if a calendar icon should be added to the element the plugin is attached to, create the icon now
                    if (plugin.settings.show_icon) {

                        // strangely, in Firefox 21+ (or maybe even earlier) input elements have their "display" property
                        // set to "inline" instead of "inline-block" as do all the other browsers.
                        // because this behavior brakes the positioning of the icon, we'll set the "display" property to
                        // "inline-block" before anything else;
                        if (browser.name == 'firefox' && $element.is('input[type="text"]') && $element.css('display') == 'inline') $element.css('display', 'inline-block');

                        // we create a wrapper for the parent element so that we can later position the icon
                        // also, make sure the wrapper inherits some important css properties of the parent element
                        var icon_wrapper = jQuery('<span class="Zebra_DatePicker_Icon_Wrapper fee-identical-sewc-elm"></span>').css({
                            'display': $element.css('display'),
                            'position': $element.css('position') == 'static' ? 'relative' : $element.css('position'),
                            'float': $element.css('float'),
                            'top': $element.css('top'),
                            'right': $element.css('right'),
                            'bottom': $element.css('bottom'),
                            'left': $element.css('left')
                        });

                        // put wrapper around the element
                        // also, make sure we set some important css properties for it
                        $element.wrap(icon_wrapper).css({
                            'position': 'relative',
                            'top': 'auto',
                            'right': 'auto',
                            'bottom': 'auto',
                            'left': 'auto'
                        });

                        // create the actual calendar icon (show a disabled icon if the element is disabled)
                        icon = jQuery('<button type="button" class="Zebra_DatePicker_Icon fee-identical-sewc-elm' + ($element.attr('disabled') == 'disabled' ? ' Zebra_DatePicker_Icon_Disabled' : '') + '">Pick a date</button>');

                        // a reference to the icon, as a global property
                        plugin.icon = icon;

                        // the date picker will open when clicking both the icon and the element the plugin is attached to
                        clickables = icon.add($element);

                        // if calendar icon is not visible, the date picker will open when clicking the element
                    } else clickables = $element;

                    // attach the click event to the clickable elements (icon and/or element)
                    clickables.bind('click', function (e) {

                        e.preventDefault();

                        // if element is not disabled
                        if (!$element.attr('disabled'))

                            // if the date picker is visible, hide it
                            if (datepicker.css('display') != 'none') plugin.hide();

                            // if the date picker is not visible, show it
                            else plugin.show();

                    });

                    // if icon exists, inject it into the DOM, right after the parent element (and inside the wrapper)
                    if (undefined !== icon) icon.insertAfter($element);

                }

                // if calendar icon exists
                if (undefined !== icon) {

                    // needed when updating: remove any inline style set previously by library,
                    // so we get the right values below
                    icon.attr('style', '');

                    // if calendar icon is to be placed *inside* the element
                    // add an extra class to the icon
                    if (plugin.settings.inside){
                        icon.addClass('Zebra_DatePicker_Icon_Inside');
                    }
                }

            }

            var auto_select_date = default_date || plugin.settings.start_date || new Date();
            selected_day = auto_select_date.getDate();
            selected_month = auto_select_date.getMonth();
            selected_year = auto_select_date.getFullYear();
            selected_hour = auto_select_date.getHours();
            selected_minute = auto_select_date.getMinutes();
            selected_second = auto_select_date.getSeconds();

            // if the "Today" button is to be shown and it makes sense to be shown
            // (the "days" view is available and "today" is not a disabled date)
            show_select_today = (plugin.settings.show_select_today !== false && $.inArray('days', views) > -1 && !is_disabled(current_system_year, current_system_month, current_system_day) ? plugin.settings.show_select_today : false);

            // if we just needed to recompute the things above, return now
            if (update) return;

            // update icon/date picker position on resize
            $(window).bind('resize', _resize);

            // generate the container that will hold everything

            // Build timepicker HTML block conditionally on time_style
            var timepicker_html;
            if (plugin.settings.time && plugin.settings.time_style === 'modern') {
                var _hourItems = '';
                for (var _h = 12; _h >= 1; _h--) {
                    _hourItems += '<li class="dp_tp_hour_item" data-hour="' + _h + '">' + (_h < 10 ? '0' + _h : '' + _h) + ':00</li>';
                }
                timepicker_html =
                    '<div class="dp_timepicker dp_timepicker--modern">' +
                        '<div class="dp_tp_header">Time</div>' +
                        '<div class="dp_tp_body">' +
                            '<ul class="dp_tp_hours">' + _hourItems + '</ul>' +
                            '<div class="dp_tp_ampm">' +
                                '<button type="button" class="dp_tp_ampm_btn dp_tp_am">AM</button>' +
                                '<button type="button" class="dp_tp_ampm_btn dp_tp_pm">PM</button>' +
                            '</div>' +
                        '</div>' +
                        '<div class="dp_tp_footer"><button type="button" class="dp_tp_ok">OK</button></div>' +
                    '</div>';
            } else {
                timepicker_html =
                    '<div class="dp_timepicker">' +
                        '<div class="dp_timepicker_hour_block">' +
                            '<div class="dp_caption dp_timepicker_hour_label">' + $.i18n.prop("hour") + '</div>' +
                            '<div class="dp_timepicker_hour"><input value="0"></div>' +
                        '</div>' +
                        '<div class="dp_timepicker_minute_block">' +
                            '<div class="dp_caption dp_timepicker_minute_label">' + $.i18n.prop("minute") + '</div>' +
                            '<div class="dp_timepicker_minute"><input value="0"></div>' +
                        '</div>' +
                        '<div class="dp_timepicker_second_block">' +
                            '<div class="dp_caption dp_timepicker_second_label">' + $.i18n.prop("second") + '</div>' +
                            '<div class="dp_timepicker_second"><input value="0"></div>' +
                        '</div>' +
                        '<table class="dp_timepicker_done"><tbody><tr>' +
                            '<td class="dp_timepicker_done" style="width:100%">' + $.i18n.prop("done") + '</td>' +
                        '</tr></tbody></table>' +
                    '</div>';
            }

            var html = '' +
                '<div class="Zebra_DatePicker">' +
                '<table class="dp_header">' +
                '<tr>' +
                '<td class="dp_previous">' + plugin.settings.header_navigation[0] + '</td>' +
                '<td class="dp_caption">&#032;</td>' +
                '<td class="dp_next">' + plugin.settings.header_navigation[1] + '</td>' +
                '</tr>' +
                '</table>' +
                '<table class="dp_daypicker"></table>' +
                timepicker_html +
                '<table class="dp_monthpicker"></table>' +
                '<table class="dp_yearpicker"></table>' +
                '<table class="dp_footer"><tr>' +
                '<td class="dp_today"' + (plugin.settings.show_clear_date !== false ? ' style="width:50%"' : '') + '>' + show_select_today + '</td>' +
                '<td class="dp_clear"' + (show_select_today !== false ? ' style="width:50%"' : '') + '>' + plugin.settings.lang_clear_date + '</td>' +
                '</tr></table>' +
                '</div>';

            // create a jQuery object out of the HTML above and create a reference to it
            datepicker = $(html);

            // For modern time picker: inject CSS once, add layout class, wrap calendar elements side-by-side
            if (plugin.settings.time && plugin.settings.time_style === 'modern') {
                if (!$('#zdp-modern-css').length) {
                    $('<style id="zdp-modern-css">' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern{display:flex;flex-direction:row;width:400px;padding:16px 0;align-items: flex-start;border: 1px solid #BDBDBD;box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.15);border-radius: 6px;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern::after{content: "";background: #F0F3F4;height: 1px;width: 100%;position: absolute;left: 0;bottom: 44px;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern .dp_cal_wrap{flex: 1;min-width: 278px;padding: 0 16px;border-right: 1px solid #F0F3F4;box-sizing: border-box;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern .dp_cal_wrap table.dp_header{width: 100% !important;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern .dp_cal_wrap table.dp_daypicker{margin-top: 12px;width: 100% !important;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern td{border-radius: 5px;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern td:hover,' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern td.dp_hover,' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern td.dp_current{background: #F0F3F4;font-weight: 400;color: #008DF2;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern .dp_timepicker--modern{width:120px!important;display:flex;flex-direction:column;margin:0;padding:0;}' +
                        '.Zebra_DatePicker.Zebra_DatePicker--modern .dp_timepicker--modern::before{display:none}' +
                        '.dp_tp_header{padding:0 0 12px;text-align:center;font-size:13px;font-weight:700;color:#111827;border-bottom:1px solid #F0F3F4}' +
                        '.dp_tp_body{display:flex;flex:1;overflow:hidden}' +
                        '.dp_tp_hours{overflow-y: auto;list-style: none;\margin: 0;padding: 4px;border-right: 1px solid #e5e7eb;height: 224px;flex: 0 0 55px;\overflow: auto;scrollbar-width: none;-ms-overflow-style: none;}' +
                        '.dp_tp_hours::-webkit-scrollbar{width:4px}' +
                        '.dp_tp_hours::-webkit-scrollbar-track{background:transparent}' +
                        '.dp_tp_hours::-webkit-scrollbar-thumb{background:#d1d5db;border-radius:2px}' +
                        '.dp_tp_hours li{padding:7px 4px;font-size:12px;color:#000000;cursor:pointer;text-align:center;transition:background .1s;border-radius: 5px;font-family: \'Source Sans 3\', sans-serif;}' +
                        '.dp_tp_hours li:hover,' +
                        '.dp_tp_hours li.dp_tp_selected{background:#F0F3F4;color:#008DF2;}' +
                        '.dp_tp_ampm{display: flex;flex-direction: column;padding: 4px;flex: 0 0 48px;overflow: auto;scrollbar-width: none;-ms-overflow-style: none;}' +
                        '.dp_tp_ampm_btn{padding: 7px 4px;border-radius: 5px;font-size: 12px;color: #000000;cursor: pointer;white-space: nowrap;font-family: \'Source Sans 3\', sans-serif;}' +
                        '.dp_tp_ampm_btn:hover,' +
                        '.dp_tp_ampm_btn.dp_tp_active{background:#F0F3F4;color:#008DF2;}' +
                        '.dp_tp_footer{padding:12px 20px 0;display:flex;justify-content:flex-end}' +
                        '.dp_tp_ok{padding: 0;background: none;border: none;font-size: 12px;font-weight: 60;color: #008DF2;cursor: pointer;}' +
                        '.dp_tp_ok:hover{color:#1d4ed8}' +
                    '</style>').appendTo('head');
                }
                datepicker.addClass('Zebra_DatePicker--modern');
                // Wrap all non-timepicker children in a cal-wrap div for flex side-by-side layout
                datepicker.children(':not(.dp_timepicker)').wrapAll('<div class="dp_cal_wrap"></div>');
            }

            // a reference to the calendar, as a global property
            plugin.datepicker = datepicker;

            // create references to the different parts of the date picker
            header = $('table.dp_header', datepicker);
            daypicker = $('table.dp_daypicker', datepicker);
            timepicker = $('.dp_timepicker', datepicker);
            monthpicker = $('table.dp_monthpicker', datepicker);
            yearpicker = $('table.dp_yearpicker', datepicker);
            footer = $('table.dp_footer', datepicker);
            selecttoday = $('td.dp_today', footer);
            cleardate = $('td.dp_clear', footer);

            // if date picker is not always visible
            if (!plugin.settings.always_visible)

                // inject the container into the DOM
                $('body').append(datepicker);

            // otherwise, if element is not disabled
            else if (!$element.attr('disabled')) {

                // inject the date picker into the designated container element
                plugin.settings.always_visible.append(datepicker);

                // and make it visible right away
                plugin.show();

            }

            // add the mouseover/mousevents to all to the date picker's cells
            // except those that are not selectable
            datepicker.
            delegate('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_blocked, .dp_week_number)', 'mouseover',function () {
                $(this).addClass('dp_hover');
            }).
            delegate('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_blocked, .dp_week_number)', 'mouseout', function () {
                $(this).removeClass('dp_hover');
            });

            // prevent text highlighting for the text in the header
            // (for the case when user keeps clicking the "next" and "previous" buttons)
            disable_text_select($('td', header));

            // event for when clicking the "previous" button
            $('.dp_previous', header).bind('click', function () {

                // if button is not disabled
                if (!$(this).hasClass('dp_blocked')) {

                    // if view is "months"
                    // decrement year by one
                    if (view == 'months') selected_year--;

                        // if view is "years"
                    // decrement years by 12
                    else if (view == 'years') selected_year -= 12;

                        // if view is "days"
                        // decrement the month and
                    // if month is out of range
                    else if (--selected_month < 0) {

                        // go to the last month of the previous year
                        selected_month = 11;
                        selected_year--;

                    }

                    // generate the appropriate view
                    manage_views();

                }

            });

            // attach a click event to the caption in header
            $('.dp_caption', header).bind('click', function () {

                // if current view is "days", take the user to the next view, depending on the format
                if (view == 'days') view = ($.inArray('months', views) > -1 ? 'months' : ($.inArray('years', views) > -1 ? 'years' : 'days'));

                // if current view is "months", take the user to the next view, depending on the format
                else if (view == 'months') view = ($.inArray('years', views) > -1 ? 'years' : ($.inArray('days', views) > -1 ? 'days' : 'months'));

                // if current view is "years", take the user to the next view, depending on the format
                else view = ($.inArray('days', views) > -1 ? 'days' : ($.inArray('months', views) > -1 ? 'months' : 'years'));

                // generate the appropriate view
                manage_views();

            });

            // event for when clicking the "next" button
            $('.dp_next', header).bind('click', function () {

                // if button is not disabled
                if (!$(this).hasClass('dp_blocked')) {

                    // if view is "months"
                    // increment year by 1
                    if (view == 'months') selected_year++;

                        // if view is "years"
                    // increment years by 12
                    else if (view == 'years') selected_year += 12;

                        // if view is "days"
                        // increment the month and
                    // if month is out of range
                    else if (++selected_month == 12) {

                        // go to the first month of the next year
                        selected_month = 0;
                        selected_year++;

                    }

                    // generate the appropriate view
                    manage_views();

                }

            });

            // attach a click event for the cells in the day picker
            daypicker.delegate('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_week_number)', 'click', function () {

                // modern time picker: clicking a day only highlights the selection; OK button commits
                if (plugin.settings.time && plugin.settings.time_style === 'modern') {
                    var $cell = $(this);
                    // update selected_day from the cell text (handles other-month cells too)
                    if (plugin.settings.select_other_months && null !== (matches = $cell.attr('class').match(/date\_([0-9]{4})(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])/))) {
                        selected_year  = to_int(matches[1]);
                        selected_month = to_int(matches[2]) - 1;
                        selected_day   = to_int(matches[3]);
                    } else {
                        selected_day = to_int($cell.html());
                    }
                    // update visual highlight only (do not commit / hide picker)
                    daypicker.find('td.dp_selected').removeClass('dp_selected');
                    $cell.addClass('dp_selected');
                    return;
                }

                // if other months are selectable and currently clicked cell contains a class with the cell's date
                if (plugin.settings.select_other_months && null !== (matches = $(this).attr('class').match(/date\_([0-9]{4})(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])/)))

                    // use the stored date
                    select_date(matches[1], matches[2] - 1, matches[3], 'days', $(this));

                // put selected date in the element the plugin is attached to, and hide the date picker
                else select_date(selected_year, selected_month, to_int($(this).html()), 'days', $(this));

            });

            // attach a click event for the cells in the month picker
            monthpicker.delegate('td:not(.dp_disabled)', 'click', function () {

                // get the month we've clicked on
                var matches = $(this).attr('class').match(/dp\_month\_([0-9]+)/);

                // set the selected month
                selected_month = to_int(matches[1]);

                // if user can select only years and months
                if ($.inArray('days', views) == -1)

                    // put selected date in the element the plugin is attached to, and hide the date picker
                    select_date(selected_year, selected_month, 1, 'months', $(this));

                else {

                    // direct the user to the "days" view
                    view = 'days';

                    // if date picker is always visible
                    // empty the value in the text box the date picker is attached to
                    if (plugin.settings.always_visible) $element.val('');

                    // generate the appropriate view
                    manage_views();

                }

            });

            // attach a click event for the cells in the year picker
            yearpicker.delegate('td:not(.dp_disabled)', 'click', function () {

                // set the selected year
                selected_year = to_int($(this).html());

                // if user can select only years
                if ($.inArray('months', views) == -1)

                    // put selected date in the element the plugin is attached to, and hide the date picker
                    select_date(selected_year, 1, 1, 'years', $(this));

                else {

                    // direct the user to the "months" view
                    view = 'months';

                    // if date picker is always visible
                    // empty the value in the text box the date picker is attached to
                    if (plugin.settings.always_visible) $element.val('');

                    // generate the appropriate view
                    manage_views();

                }

            });

            // function to execute when the "Today" button is clicked
            $(selecttoday).bind('click', function (e) {

                e.preventDefault();

                // select the current date
                select_date(current_system_year, current_system_month, current_system_day, 'days', $('.dp_current', daypicker));

                //TODO: set current time

                // if date picker is always visible
                if (plugin.settings.always_visible)

                    // repaint the datepicker so it centers on the currently selected date
                    plugin.show();

                // hide the date picker
                plugin.hide();

            });

            // function to execute when the "Clear" button is clicked
            $(cleardate).bind('click', function (e) {

                e.preventDefault();

                // clear the element's value
                $element.val('').trigger("change");

                // if date picker is not always visible
                if (!plugin.settings.always_visible) {

                    // reset these values
                    default_day = null;
                    default_month = null;
                    default_year = null;
                    selected_month = null;
                    selected_year = null;
                    selected_day = null;

                    // if date picker is always visible
                } else {

                    // reset these values
                    default_day = null;
                    default_month = null;
                    default_year = null;

                    // remove the "selected" class from all cells that have it
                    $('td.dp_selected', datepicker).removeClass('dp_selected');

                }

                // hide the date picker
                plugin.hide();

                // if a callback function exists for when clearing a date
                if (plugin.settings.onClear && typeof plugin.settings.onClear == 'function')

                    // execute the callback function and pass as argument the element the plugin is attached to
                    plugin.settings.onClear($element);

            });

            // if date picker is not always visible
            if (!plugin.settings.always_visible)

                // bind some events to the document
                $(document).bind({

                    //whenever anything is clicked on the page or a key is pressed
                    'mousedown': _mousedown,
                    'keyup': _keyup

                });

            // last thing is to pre-render some of the date picker right away
            manage_views();

        };

        /**
         *  Destroys the date picker.
         *
         *  @return void
         */
        plugin.destroy = function () {

            // remove the attached icon (if it exists)...
            if (undefined !== plugin.icon) plugin.icon.remove();

            // ...and the calendar
            plugin.datepicker.remove();

            // remove associated event handlers from the document
            $(document).unbind('keyup', _keyup);
            $(document).unbind('mousedown', _mousedown);
            $(window).unbind('resize', _resize);

            // remove association with the element
            $element.removeData('Zebra_DatePicker');

        };

        /**
         *  Hides the date picker.
         *
         *  @return void
         */
        plugin.hide = function () {

            // if date picker is not always visible
            if (!plugin.settings.always_visible) {

                // hide the iFrameShim in Internet Explorer 6
                iframeShim('hide');

                // hide the date picker
                datepicker.hide();

            }

        };

        /**
         *  Shows the date picker.
         *
         *  @return void
         */
        plugin.show = function () {
            // always show the view defined in settings
            view = plugin.settings.view;

            // get the default date, from the element, and check if it represents a valid date, according to the required format
            var default_date = check_date($element.val() || (plugin.settings.start_date ? plugin.settings.start_date : ''));

            // if the value represents a valid date
            if (default_date) {

                // extract the date parts
                // we'll use these to highlight the default date in the date picker and as starting point to
                // what year and month to start the date picker with
                // why separate values? because selected_* will change as user navigates within the date picker
                selected_month = default_month = default_date.getMonth();
                selected_year = default_year = default_date.getFullYear();
                selected_day = default_day = default_date.getDate();

                // if the default date represents a disabled date
                if (is_disabled(default_year, default_month, default_day)) {

                    // if date picker is in "strict" mode, clear the value of the parent element
                    if (plugin.settings.strict) $element.val('');

                    // the calendar will start with the first selectable year/month/day
                    selected_month = first_selectable_month;
                    selected_year = first_selectable_year;
                    selected_day = first_selectable_day;

                }

                // if a default value is not available, or value does not represent a valid date
            } else {

                // the calendar will start with the first selectable year/month/day
                selected_month = first_selectable_month;
                selected_year = first_selectable_year;
                selected_day = first_selectable_day;

            }

            // generate the appropriate view
            manage_views();

            // if date picker is not always visible and the calendar icon is visible
            if (!plugin.settings.always_visible) {

                // Measure real dimensions while off-screen — outerWidth/Height return 0 when display:none.
                // Modern picker uses display:flex; using display:block gives wrong (0) height.
                var _measureDisplay = datepicker.hasClass('Zebra_DatePicker--modern') ? 'flex' : 'block';
                datepicker.css({ position: 'absolute', left: -9999, top: -9999, visibility: 'hidden', display: _measureDisplay });
                var _measured_w = datepicker.outerWidth(), _measured_h = datepicker.outerHeight();
                datepicker.css({ display: 'none', visibility: '', left: '', top: '' });

                var

                    // get the date picker width and height
                    datepicker_width = _measured_w,
                    datepicker_height = _measured_h,

                    // compute the date picker's default left and top
                    // this will be computed relative to the icon's top-right corner (if the calendar icon exists), or
                    // relative to the element's top-right corner otherwise, to which the offsets given at initialization
                    // are added/subtracted
                    left = (undefined !== icon ? icon.offset().left + icon.outerWidth(true) : $element.offset().left + $element.outerWidth(true)) + plugin.settings.offset[0],
                    top = (undefined !== icon ? icon.offset().top : $element.offset().top) - datepicker_height + plugin.settings.offset[1],

                    // get browser window's width and height
                    window_width = $(window).width(),
                    window_height = window.innerHeight,

                    // get browser window's horizontal and vertical scroll offsets
                    window_scroll_top = $(window).scrollTop(),
                    window_scroll_left = $(window).scrollLeft();

                // if date picker is outside the viewport, adjust its position so that it is visible
                if (left + datepicker_width > window_scroll_left + window_width) {
                    left = window_scroll_left + window_width - datepicker_width;
                }
                if (left < window_scroll_left) {
                    left = window_scroll_left;
                }
                if (top + datepicker_height > window_scroll_top + window_height) {
                    top = window_scroll_top + window_height - datepicker_height;
                }
                if (top < window_scroll_top) {
                    top = window_scroll_top;
                }

                // make the date picker visible
                datepicker.css({
                    'left': left,
                    'top': top
                });

                // fade-in the date picker
                // for Internet Explorer < 9 show the date picker instantly or fading alters the font's weight
                datepicker.fadeIn(browser.name == 'explorer' && browser.version < 9 ? 0 : 150, 'linear');

                // show the iFrameShim in Internet Explorer 6
                iframeShim();

                // if date picker is always visible, show it
            } else datepicker.show();

        };

        /**
         *  Updates the configuration options given as argument
         *
         *  @param  object  values  An object containing any number of configuration options to be updated
         *
         *  @return void
         */
        plugin.update = function (values) {

            // if original direction not saved, save it now
            if (plugin.original_direction) plugin.original_direction = plugin.direction;

            // update configuration options
            plugin.settings = $.extend(plugin.settings, values);

            // reinitialize the object with the new options
            init(true);

        };

        /**
         *  Checks if a string represents a valid date according to the format defined by the "format" property.
         *
         *  @param  string  str_date    A string representing a date, formatted accordingly to the "format" property.
         *                              For example, if "format" is "yyyy-MM-dd" the string should look like "2011-06-01"
         *
         *  @return mixed               Returns a JavaScript Date object if string represents a valid date according
         *                              formatted according to the "format" property, or FALSE otherwise.
         *
         *  @access private
         */
        var check_date = function (str_date) {
            str_date = $.trim(str_date);
            if (str_date == "") {
                return false;
            }

            var format = plugin.settings.format;
            if (plugin.settings.time) {
                var time_format = plugin.settings.time;
                if (plugin.settings.time === true) {
                    time_format = "HH:mm:ss"
                }
                format += " " + time_format;
            }

            var date = Date.parseExact(str_date, format);
            return date || false;
        };

        /**
         *  Prevents the possibility of selecting text on a given element. Used on the "previous" and "next" buttons
         *  where text might get accidentally selected when user quickly clicks on the buttons.
         *
         *  Code by http://chris-barr.com/index.php/entry/disable_text_selection_with_jquery/
         *
         *  @param  jQuery Element  el  A jQuery element on which to prevents text selection.
         *
         *  @return void
         *
         *  @access private
         */
        var disable_text_select = function (el) {

            // if browser is Firefox
            if (browser.name == 'firefox') el.css('MozUserSelect', 'none');

            // if browser is Internet Explorer
            else if (browser.name == 'explorer') el.bind('selectstart', function () {
                return false;
            });

            // for the other browsers
            else el.mousedown(function () {
                    return false;
                });

        };

        /**
         *  Escapes special characters in a string, preparing it for use in a regular expression.
         *
         *  @param  string  str     The string in which special characters should be escaped.
         *
         *  @return string          Returns the string with escaped special characters.
         *
         *  @access private
         */
        var escape_regexp = function (str) {

            // return string with special characters escaped
            return str.replace(/([-.,*+?^${}()|[\]\/\\])/g, '\\$1');

        };

        /**
         *  Formats a JavaScript date object to the format specified by the "format" property.
         *  Code taken from http://electricprism.com/aeron/calendar/
         *
         *  @param  date    date    A valid JavaScript date object
         *
         *  @return string          Returns a string containing the formatted date
         *
         *  @access private
         */
        var format = function (date) {

            var format = plugin.settings.format;
            if (plugin.settings.time) {
                var time_format = plugin.settings.time;
                if (plugin.settings.time === true) {
                    time_format = "HH:mm:ss"
                }
                format += " " + time_format;
            }

            return date.toString(format)

        };

        var generate_timepicker = function () {
            if (!plugin.settings.time) {
                return;
            }

            // modern time picker: scrollable 12h list + AM/PM buttons + OK button
            if (plugin.settings.time_style === 'modern') {
                var _isAm = selected_hour < 12;
                var _h12  = (selected_hour % 12) || 12;

                // highlight selected hour item
                timepicker.find('.dp_tp_hour_item').removeClass('dp_tp_selected');
                timepicker.find('.dp_tp_hour_item[data-hour="' + _h12 + '"]').addClass('dp_tp_selected');

                // highlight AM/PM
                timepicker.find('.dp_tp_ampm_btn').removeClass('dp_tp_active');
                timepicker.find(_isAm ? '.dp_tp_am' : '.dp_tp_pm').addClass('dp_tp_active');

                // scroll selected item into the center of the list
                var $list = timepicker.find('.dp_tp_hour_list');
                var $sel  = $list.find('.dp_tp_selected');
                if ($sel.length) {
                    $list.scrollTop($list.scrollTop() + $sel.position().top - $list.height() / 2 + $sel.outerHeight() / 2);
                }

                // remove any previously bound events so we don't stack handlers on re-open
                timepicker.off('click.zdp_modern');

                timepicker.on('click.zdp_modern', '.dp_tp_hour_item', function () {
                    timepicker.find('.dp_tp_hour_item').removeClass('dp_tp_selected');
                    $(this).addClass('dp_tp_selected');
                });

                timepicker.on('click.zdp_modern', '.dp_tp_ampm_btn', function () {
                    timepicker.find('.dp_tp_ampm_btn').removeClass('dp_tp_active');
                    $(this).addClass('dp_tp_active');
                });

                timepicker.on('click.zdp_modern', '.dp_tp_ok', function () {
                    var $selH = timepicker.find('.dp_tp_hour_item.dp_tp_selected');
                    var $selP = timepicker.find('.dp_tp_ampm_btn.dp_tp_active');
                    if (!$selH.length) return;
                    var h12val = parseInt($selH.data('hour'), 10);
                    var isPm   = $selP.hasClass('dp_tp_pm');
                    selected_hour   = (h12val % 12) + (isPm ? 12 : 0);
                    selected_minute = 0;
                    selected_second = 0;
                    select_date(selected_year, selected_month);
                });

                return;
            }

            timepicker.find(".dp_timepicker_hour input").slider({
                from: 0,
                to: 23,
                step: 1,
                callback: function (h) {
                    selected_hour = h;
                }
            }).slider("value", selected_hour)
            if (plugin.settings.show_minute === false) {
                return;
            }
            timepicker.find(".dp_timepicker_minute input").slider({
                from: 0,
                to: 59,
                step: 1,
                callback: function (m) {
                    selected_minute = m;
                }
            }).slider("value", selected_minute)
            if (plugin.settings.show_second === false) {
                return;
            }
            timepicker.find(".dp_timepicker_second input").slider({
                from: 0,
                to: 59,
                step: 1,
                callback: function (s) {
                    selected_second = s;
                }
            }).slider("value", selected_second)
            timepicker.find(".dp_timepicker_done").click(function () {
                select_date(selected_year, selected_month)
            })
        }

        /**
         *  Generates the day picker view, and displays it
         *
         *  @return void
         *
         *  @access private
         */
        var generate_daypicker = function () {

            var

                // get the number of days in the selected month
                days_in_month = new Date(selected_year, selected_month + 1, 0).getDate(),

                // get the selected month's starting day (from 0 to 6)
                first_day = new Date(selected_year, selected_month, 1).getDay(),

                // how many days are there in the previous month
                days_in_previous_month = new Date(selected_year, selected_month, 0).getDate(),

                // how many days are there to be shown from the previous month
                days_from_previous_month = first_day - plugin.settings.first_day_of_week;

            // the final value of how many days are there to be shown from the previous month
            days_from_previous_month = days_from_previous_month < 0 ? 7 + days_from_previous_month : days_from_previous_month;

            // manage header caption and enable/disable navigation buttons if necessary
            manage_header(plugin.settings.months[selected_month] + ', ' + selected_year);

            // start generating the HTML
            var html = '<tr>';

            // if a column featuring the number of the week is to be shown
            if (plugin.settings.show_week_number)

                // column title
                html += '<th>' + plugin.settings.show_week_number + '</th>';

            // name of week days
            // show the abbreviated day names (or only the first two letters of the full name if no abbreviations are specified)
            // and also, take in account the value of the "first_day_of_week" property
            for (var i = 0; i < 7; i++)

                html += '<th>' + ($.isArray(plugin.settings.days_abbr) && undefined !== plugin.settings.days_abbr[(plugin.settings.first_day_of_week + i) % 7] ? plugin.settings.days_abbr[(plugin.settings.first_day_of_week + i) % 7] : plugin.settings.days[(plugin.settings.first_day_of_week + i) % 7].substr(0, 2)) + '</th>';

            html += '</tr><tr>';

            // the calendar shows a total of 42 days
            for (i = 0; i < 42; i++) {

                // seven days per row
                if (i > 0 && i % 7 === 0) html += '</tr><tr>';

                // if week number is to be shown
                if (i % 7 === 0 && plugin.settings.show_week_number)

                    // show ISO 8601 week number
                    html += '<td class="dp_week_number">' + getWeekNumber(new Date(selected_year, selected_month, (i - days_from_previous_month + 1))) + '</td>';

                // the number of the day in month
                var day = (i - days_from_previous_month + 1);

                // if dates in previous/next month can be selected, and this is one of those days
                if (plugin.settings.select_other_months && (i < days_from_previous_month || day > days_in_month)) {

                    // use the Date object to normalize the date
                    // for example, 2011 05 33 will be transformed to 2011 06 02
                    var real_date = new Date(selected_year, selected_month, day),
                        real_year = real_date.getFullYear(),
                        real_month = real_date.getMonth(),
                        real_day = real_date.getDate();

                    // extract normalized date parts and merge them
                    real_date = real_year + str_pad(real_month + 1, 2) + str_pad(real_day, 2);

                }

                // if this is a day from the previous month
                if (i < days_from_previous_month)

                    html += '<td class="' + (plugin.settings.select_other_months && !is_disabled(real_year, real_month, real_day) ? 'dp_not_in_month_selectable date_' + real_date : 'dp_not_in_month') + '">' + (plugin.settings.select_other_months || plugin.settings.show_other_months ? str_pad(days_in_previous_month - days_from_previous_month + i + 1, plugin.settings.zero_pad ? 2 : 0) : '&nbsp;') + '</td>';

                // if this is a day from the next month
                else if (day > days_in_month)

                    html += '<td class="' + (plugin.settings.select_other_months && !is_disabled(real_year, real_month, real_day) ? 'dp_not_in_month_selectable date_' + real_date : 'dp_not_in_month') + '">' + (plugin.settings.select_other_months || plugin.settings.show_other_months ? str_pad(day - days_in_month, plugin.settings.zero_pad ? 2 : 0) : '&nbsp;') + '</td>';

                // if this is a day from the current month
                else {

                    var

                        // get the week day (0 to 6, Sunday to Saturday)
                        weekday = (plugin.settings.first_day_of_week + i) % 7,

                        class_name = '';

                    // if date needs to be disabled
                    if (is_disabled(selected_year, selected_month, day)) {

                        // if day is in weekend
                        if ($.inArray(weekday, plugin.settings.weekend_days) > -1) class_name = 'dp_weekend_disabled';

                        // if work day
                        else class_name += ' dp_disabled';

                        // highlight the current system date
                        if (selected_month == current_system_month && selected_year == current_system_year && current_system_day == day) class_name += ' dp_disabled_current';

                        // if there are no restrictions
                    } else {

                        // if day is in weekend
                        if ($.inArray(weekday, plugin.settings.weekend_days) > -1) class_name = 'dp_weekend';

                        // highlight the currently selected date
                        if (selected_month == default_month && selected_year == default_year && default_day == day) class_name += ' dp_selected';

                        // highlight the current system date
                        if (selected_month == current_system_month && selected_year == current_system_year && current_system_day == day) class_name += ' dp_current';

                    }

                    // print the day of the month
                    html += '<td' + (class_name !== '' ? ' class="' + $.trim(class_name) + '"' : '') + '>' + (plugin.settings.zero_pad ? str_pad(day, 2) : day) + '</td>';

                }

            }

            // wrap up generating the day picker
            html += '</tr>';

            // inject the day picker into the DOM
            daypicker.html($(html));

            // if date picker is always visible
            if (plugin.settings.always_visible)

                // cache all the cells
                // (we need them so that we can easily remove the "dp_selected" class from all of them when user selects a date)
                daypicker_cells = $('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_blocked, .dp_week_number)', daypicker);

            // make the day picker visible
            daypicker.show();
        };

        /**
         *  Generates the month picker view, and displays it
         *
         *  @return void
         *
         *  @access private
         */
        var generate_monthpicker = function () {

            // manage header caption and enable/disable navigation buttons if necessary
            manage_header(selected_year);

            // start generating the HTML
            var html = '<tr>';

            // iterate through all the months
            for (var i = 0; i < 12; i++) {

                // three month per row
                if (i > 0 && i % 3 === 0) html += '</tr><tr>';

                var class_name = 'dp_month_' + i;

                // if month needs to be disabled
                if (is_disabled(selected_year, i)) class_name += ' dp_disabled';

                // else, if a date is already selected and this is that particular month, highlight it
                else if (default_month !== false && default_month == i) class_name += ' dp_selected';

                // else, if this the current system month, highlight it
                else if (current_system_month == i && current_system_year == selected_year) class_name += ' dp_current';

                // first three letters of the month's name
                html += '<td class="' + $.trim(class_name) + '">' + ($.isArray(plugin.settings.months_abbr) && undefined !== plugin.settings.months_abbr[i] ? plugin.settings.months_abbr[i] : plugin.settings.months[i].substr(0, 3)) + '</td>';

            }

            // wrap up
            html += '</tr>';

            // inject into the DOM
            monthpicker.html($(html));

            // if date picker is always visible
            if (plugin.settings.always_visible)

                // cache all the cells
                // (we need them so that we can easily remove the "dp_selected" class from all of them when user selects a month)
                monthpicker_cells = $('td:not(.dp_disabled)', monthpicker);

            // make the month picker visible
            monthpicker.show();

        };

        /**
         *  Generates the year picker view, and displays it
         *
         *  @return void
         *
         *  @access private
         */
        var generate_yearpicker = function () {

            // manage header caption and enable/disable navigation buttons if necessary
            manage_header(selected_year - 7 + ' - ' + (selected_year + 4));

            // start generating the HTML
            var html = '<tr>';

            // we're showing 9 years at a time, current year in the middle
            for (var i = 0; i < 12; i++) {

                // three years per row
                if (i > 0 && i % 3 === 0) html += '</tr><tr>';

                var class_name = '';

                // if year needs to be disabled
                if (is_disabled(selected_year - 7 + i)) class_name += ' dp_disabled';

                // else, if a date is already selected and this is that particular year, highlight it
                else if (default_year && default_year == selected_year - 7 + i) class_name += ' dp_selected';

                // else, if this is the current system year, highlight it
                else if (current_system_year == (selected_year - 7 + i)) class_name += ' dp_current';

                // first three letters of the month's name
                html += '<td' + ($.trim(class_name) !== '' ? ' class="' + $.trim(class_name) + '"' : '') + '>' + (selected_year - 7 + i) + '</td>';

            }

            // wrap up
            html += '</tr>';

            // inject into the DOM
            yearpicker.html($(html));

            // if date picker is always visible
            if (plugin.settings.always_visible)

                // cache all the cells
                // (we need them so that we can easily remove the "dp_selected" class from all of them when user selects a year)
                yearpicker_cells = $('td:not(.dp_disabled)', yearpicker);

            // make the year picker visible
            yearpicker.show();

        };

        /**
         *  Generates an iFrame shim in Internet Explorer 6 so that the date picker appears above select boxes.
         *
         *  @return void
         *
         *  @access private
         */
        var iframeShim = function (action) {

            // this is necessary only if browser is Internet Explorer 6
            if (browser.name == 'explorer' && browser.version == 6) {

                // if the iFrame was not yet created
                // "undefined" evaluates as FALSE
                if (!shim) {

                    // the iFrame has to have the element's zIndex minus 1
                    var zIndex = to_int(datepicker.css('zIndex')) - 1;

                    // create the iFrame
                    shim = jQuery('<iframe>', {
                        'src': 'javascript:document.write("")',
                        'scrolling': 'no',
                        'frameborder': 0,
                        'allowtransparency': 'true',
                        css: {
                            'zIndex': zIndex,
                            'position': 'absolute',
                            'top': -1000,
                            'left': -1000,
                            'width': datepicker.outerWidth(),
                            'height': datepicker.outerHeight(),
                            'filter': 'progid:DXImageTransform.Microsoft.Alpha(opacity=0)',
                            'display': 'none'
                        }
                    });

                    // inject iFrame into DOM
                    $('body').append(shim);

                }

                // what do we need to do
                switch (action) {

                    // hide the iFrame?
                    case 'hide':

                        // set the iFrame's display property to "none"
                        shim.hide();

                        break;

                    // show the iFrame?
                    default:

                        // get date picker top and left position
                        var offset = datepicker.offset();

                        // position the iFrame shim right underneath the date picker
                        // and set its display to "block"
                        shim.css({
                            'top': offset.top,
                            'left': offset.left,
                            'display': 'block'
                        });

                }

            }

        };

        /**
         *  Checks if, according to the restrictions of the calendar and/or the values defined by the "disabled_dates"
         *  property, a day, a month or a year needs to be disabled.
         *
         *  @param  integer     year    The year to check
         *  @param  integer     month   The month to check
         *  @param  integer     day     The day to check
         *
         *  @return boolean         Returns TRUE if the given value is not disabled or FALSE otherwise
         *
         *  @access private
         */
        var is_disabled = function (year, month, day) {

            // don't check bogus values
            if ((undefined === year || isNaN(year)) && (undefined === month || isNaN(month)) && (undefined === day || isNaN(day))) return false;

            // if calendar has direction restrictions
            if (!(!$.isArray(plugin.settings.direction) && to_int(plugin.settings.direction) === 0)) {

                var
                    // normalize and merge arguments then transform the result to an integer
                    now = to_int(str_concat(year, (typeof month != 'undefined' ? str_pad(month, 2) : ''), (typeof day != 'undefined' ? str_pad(day, 2) : ''))),

                    // get the length of the argument
                    len = (now + '').length;

                // if we're checking days
                if (len == 8 && (

                    // day is before the first selectable date
                    (typeof start_date != 'undefined' && now < to_int(str_concat(first_selectable_year, str_pad(first_selectable_month, 2), str_pad(first_selectable_day, 2)))) ||

                    // or day is after the last selectable date
                    (typeof end_date != 'undefined' && now > to_int(str_concat(last_selectable_year, str_pad(last_selectable_month, 2), str_pad(last_selectable_day, 2))))

                    // day needs to be disabled
                )) return true;

                // if we're checking months
                else if (len == 6 && (

                    // month is before the first selectable month
                    (typeof start_date != 'undefined' && now < to_int(str_concat(first_selectable_year, str_pad(first_selectable_month, 2)))) ||

                    // or day is after the last selectable date
                    (typeof end_date != 'undefined' && now > to_int(str_concat(last_selectable_year, str_pad(last_selectable_month, 2))))

                    // month needs to be disabled
                )) return true;

                // if we're checking years
                else if (len == 4 && (

                    // year is before the first selectable year
                    (typeof start_date != 'undefined' && now < first_selectable_year) ||

                    // or day is after the last selectable date
                    (typeof end_date != 'undefined' && now > last_selectable_year)

                    // year needs to be disabled
                )) return true;

            }

            // if month is given as argument, increment it (as JavaScript uses 0 for January, 1 for February...)
            if (typeof month != 'undefined') month = month + 1;

            // by default, we assume the day/month/year is not enabled nor disabled
            var disabled = false, enabled = false;

            // if there are rules for disabling dates
            if (disabled_dates)

                // iterate through the rules for disabling dates
                $.each(disabled_dates, function () {

                    // if the date is to be disabled, don't look any further
                    if (disabled) return;

                    var rule = this;

                    // if the rules apply for the current year
                    if ($.inArray(year, rule[2]) > -1 || $.inArray('*', rule[2]) > -1)

                        // if the rules apply for the current month
                        if ((typeof month != 'undefined' && $.inArray(month, rule[1]) > -1) || $.inArray('*', rule[1]) > -1)

                            // if the rules apply for the current day
                            if ((typeof day != 'undefined' && $.inArray(day, rule[0]) > -1) || $.inArray('*', rule[0]) > -1) {

                                // if day is to be disabled whatever the day
                                // don't look any further
                                if (rule[3] == '*') return (disabled = true);

                                // get the weekday
                                var weekday = new Date(year, month - 1, day).getDay();

                                // if weekday is to be disabled
                                // don't look any further
                                if ($.inArray(weekday, rule[3]) > -1) return (disabled = true);

                            }

                });

            // if there are rules that explicitly enable dates
            if (enabled_dates)

                // iterate through the rules for enabling dates
                $.each(enabled_dates, function () {

                    // if the date is to be enabled, don't look any further
                    if (enabled) return;

                    var rule = this;

                    // if the rules apply for the current year
                    if ($.inArray(year, rule[2]) > -1 || $.inArray('*', rule[2]) > -1) {

                        // the year is enabled
                        enabled = true;

                        // if we're also checking months
                        if (typeof month != 'undefined') {

                            // we assume the month is enabled
                            enabled = true;

                            // if the rules apply for the current month
                            if ($.inArray(month, rule[1]) > -1 || $.inArray('*', rule[1]) > -1) {

                                // if we're also checking days
                                if (typeof day != 'undefined') {

                                    // we assume the day is enabled
                                    enabled = true;

                                    // if the rules apply for the current day
                                    if ($.inArray(day, rule[0]) > -1 || $.inArray('*', rule[0]) > -1) {

                                        // if day is to be enabled whatever the day
                                        // don't look any further
                                        if (rule[3] == '*') return (enabled = true);

                                        // get the weekday
                                        var weekday = new Date(year, month - 1, day).getDay();

                                        // if weekday is to be enabled
                                        // don't look any further
                                        if ($.inArray(weekday, rule[3]) > -1) return (enabled = true);

                                        // if we get this far, it means the day is not enabled
                                        enabled = false;

                                        // if day is not enabled
                                    } else enabled = false;

                                }

                                // if month is not enabled
                            } else enabled = false;

                        }

                    }

                });

            // if checked date is enabled, return false
            if (enabled_dates && enabled) return false;

            // if checked date is disabled return false
            else if (disabled_dates && disabled) return true;

            // if script gets this far it means that the day/month/year doesn't need to be disabled
            return false;

        };

        /**
         *  Checks whether a value is an integer number.
         *
         *  @param  mixed   value   Value to check
         *
         *  @return                 Returns TRUE if the value represents an integer number, or FALSE otherwise
         *
         *  @access private
         */
        var is_integer = function (value) {

            // return TRUE if value represents an integer number, or FALSE otherwise
            return (value + '').match(/^\-?[0-9]+$/) ? true : false;

        };

        /**
         *  Sets the caption in the header of the date picker and enables or disables navigation buttons when necessary.
         *
         *  @param  string  caption     String that needs to be displayed in the header
         *
         *  @return void
         *
         *  @access private
         */
        var manage_header = function (caption) {

            // update the caption in the header
            $('.dp_caption', header).html(caption);

            // if calendar has direction restrictions or we're looking only at months
            if (!(!$.isArray(plugin.settings.direction) && to_int(plugin.settings.direction) === 0) || (views.length == 1 && views[0] == 'months')) {

                // get the current year and month
                var year = selected_year,
                    month = selected_month,
                    next, previous;

                // if current view is showing days
                if (view == 'days') {

                    // check if we can click on the "previous" button
                    previous = !is_disabled(month - 1 < 0 ? str_concat(year - 1, '11') : str_concat(year, str_pad(month - 1, 2)));

                    // check if we can click on the "next" button
                    next = !is_disabled(month + 1 > 11 ? str_concat(year + 1, '00') : str_concat(year, str_pad(month + 1, 2)));

                    // if current view is showing months
                } else if (view == 'months') {

                    // check if we can click on the "previous" button
                    if (!start_date || start_date.getFullYear() <= year - 1) previous = true;

                    // check if we can click on the "next" button
                    if (!end_date || end_date.getFullYear() >= year + 1) next = true;

                    // if current view is showing years
                } else if (view == 'years') {

                    // check if we can click on the "previous" button
                    if (!start_date || start_date.getFullYear() < year - 7) previous = true;

                    // check if we can click on the "next" button
                    if (!end_date || end_date.getFullYear() > year + 4) next = true;

                }

                // if we cannot click on the "previous" button
                if (!previous) {

                    // disable the "previous" button
                    $('.dp_previous', header).addClass('dp_blocked');
                    $('.dp_previous', header).removeClass('dp_hover');

                    // otherwise enable the "previous" button
                } else $('.dp_previous', header).removeClass('dp_blocked');

                // if we cannot click on the "next" button
                if (!next) {

                    // disable the "next" button
                    $('.dp_next', header).addClass('dp_blocked');
                    $('.dp_next', header).removeClass('dp_hover');

                    // otherwise enable the "next" button
                } else $('.dp_next', header).removeClass('dp_blocked');

            }

        };

        /**
         *  Shows the appropriate view (days, months or years) according to the current value of the "view" property.
         *
         *  @return void
         *
         *  @access private
         */
        var manage_views = function () {

            // if the day picker was not yet generated
            if (daypicker.text() === '' || view == 'days') {

                // if the day picker was not yet generated
                if (daypicker.text() === '') {

                    // if date picker is not always visible
                    if (!plugin.settings.always_visible)

                        // temporarily set the date picker's left outside of view
                        // so that we can later grab its width and height
                        datepicker.css('left', -1000);

                    // temporarily make the date picker visible
                    // so that we can later grab its width and height
                    datepicker.show();

                    // generate the day picker
                    generate_daypicker();
                    generate_timepicker();

                    // get the day picker's width and height
                    var width = daypicker.outerWidth(),
                        height = daypicker.outerHeight();

                    // make the month picker have the same size as the day picker
                    monthpicker.css({
                        'width': width,
                        'height': height
                    });

                    // make the year picker have the same size as the day picker
                    yearpicker.css({
                        'width': width,
                        'height': height
                    });

                    // make the header and the footer have the same size as the day picker
                    header.css('width', width);
                    // modern time picker sits side-by-side with the calendar — don't override its width
                    if (!(plugin.settings.time && plugin.settings.time_style === 'modern')) {
                        timepicker.css('width', width);
                    }
                    footer.css('width', width);

                    // hide the date picker again
                    datepicker.hide();

                    // if the day picker was previously generated at least once
                    // generate the day picker
                } else generate_daypicker()

                if (!plugin.settings.time) {
                    timepicker.hide();
                } else {
                    timepicker.show();
                }
                // hide the year and the month pickers
                monthpicker.hide();
                yearpicker.hide();

                // if the view is "months"
            } else if (view == 'months') {

                // generate the month picker
                generate_monthpicker();

                // hide the day and the year pickers
                daypicker.hide();
                timepicker.hide();
                yearpicker.hide();

                // if the view is "years"
            } else if (view == 'years') {

                // generate the year picker
                generate_yearpicker();

                // hide the day and the month pickers
                daypicker.hide();
                timepicker.hide();
                monthpicker.hide();

            }

            // if a callback function exists for when navigating through months/years
            if (plugin.settings.onChange && typeof plugin.settings.onChange == 'function' && undefined !== view) {

                // get the "active" elements in the view (ignoring the disabled ones)
                var elements = (view == 'days' ?
                    daypicker.find('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_blocked)') :
                    (view == 'months' ?
                        monthpicker.find('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_blocked)') :
                        yearpicker.find('td:not(.dp_disabled, .dp_weekend_disabled, .dp_not_in_month, .dp_blocked)')));

                // iterate through the active elements
                // and attach a "date" data attribute to each element in the form of
                // YYYY-MM-DD if the view is "days"
                // YYYY-MM if the view is "months"
                // YYYY if the view is "years"
                // so it's easy to identify elements in the list
                elements.each(function () {

                    // if view is "days"
                    if (view == 'days') {

                        // if date is from a next/previous month and is selectable
                        if ($(this).hasClass('dp_not_in_month_selectable')) {

                            // extract date from the attached class
                            var matches = $(this).attr('class').match(/date\_([0-9]{4})(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])/);

                            // attach a "date" data attribute to each element in the form of of YYYY-MM-DD for easily identifying sought elements
                            $(this).data('date', matches[1] + '-' + matches[2] + '-' + matches[3]);

                            // if date is from the currently selected month
                        } else

                            // attach a "date" data attribute to each element in the form of of YYYY-MM-DD for easily identifying sought elements
                            $(this).data('date', selected_year + '-' + str_pad(selected_month + 1, 2) + '-' + str_pad(to_int($(this).text()), 2));

                        // if view is "months"
                    } else if (view == 'months') {

                        // get the month's number for the element's class
                        var matches = $(this).attr('class').match(/dp\_month\_([0-9]+)/);

                        // attach a "date" data attribute to each element in the form of of YYYY-MM for easily identifying sought elements
                        $(this).data('date', selected_year + '-' + str_pad(to_int(matches[1]) + 1, 2));

                        // if view is "years"
                    } else

                        // attach a "date" data attribute to each element in the form of of YYYY for easily identifying sought elements
                        $(this).data('date', to_int($(this).text()));

                });

                // execute the callback function and send as arguments the current view, the elements in the view, and
                // the element the plugin is attached to
                plugin.settings.onChange(view, elements, $element);

            }

            // assume the footer is visible
            footer.show();

            // if the button for clearing a previously selected date needs to be visible all the time,
            // or the "Clear" button needs to be shown only when a date was previously selected, and now it's the case,
            // or the date picker is always visible and the "Clear" button was not explicitly disabled
            if (
                plugin.settings.show_clear_date === true ||
                (plugin.settings.show_clear_date === 0 && $element.val() !== '') ||
                (plugin.settings.always_visible && plugin.settings.show_clear_date !== false)
            ) {

                // show the "Clear" button
                cleardate.show();

                // if the "Today" button is visible
                if (show_select_today) {

                    // show it, and set it's width to 50% of the available space
                    selecttoday.css('width', '50%');

                    // the "Clear date" button only takes up 50% of the available space
                    cleardate.css('width', '50%');

                    // if the "Today" button is not visible
                } else {

                    // hide the "Today" button
                    selecttoday.hide();

                    // the "Clear date" button takes up 100% of the available space
                    cleardate.css('width', '100%');

                }

                // otherwise
            } else {

                // hide the "Clear" button
                cleardate.hide();

                // if the "Today" button is visible, it will now take up all the available space
                if (show_select_today) selecttoday.show().css('width', '100%');

                // if the "Today" button is also not visible, hide the footer entirely
                else footer.hide();

            }


        };

        /**
         *  Puts the specified date in the element the plugin is attached to, and hides the date picker.
         *
         *  @param  integer     year    The year
         *
         *  @param  integer     month   The month
         *
         *  @param  integer     day     The day
         *
         *  @param  string      view    The view from where the method was called
         *
         *  @param  object      cell    The element that was clicked
         *
         *  @return void
         *
         *  @access private
         */
        var select_date = function (year, month, day, view, cell) {

            var

                // construct a new date object from the arguments
                default_date = new Date(year, month, day || selected_day, selected_hour, selected_minute, selected_second),

                selected_value = format(default_date);
            $element.val(selected_value).trigger("change");
            if (view) {
                // pointer to the cells in the current view
                var view_cells = (view == 'days' ? daypicker_cells : (view == 'months' ? monthpicker_cells : yearpicker_cells))

                // the selected date, formatted correctly

                // set the currently selected and formated date as the value of the element the plugin is attached to


                // if date picker is always visible
                if (plugin.settings.always_visible) {

                    // extract the date parts and reassign values to these variables
                    // so that everything will be correctly highlighted
                    default_month = default_date.getMonth();
                    selected_month = default_date.getMonth();
                    default_year = default_date.getFullYear();
                    selected_year = default_date.getFullYear();
                    default_day = default_date.getDate();

                    // remove the "selected" class from all cells in the current view
                    view_cells.removeClass('dp_selected');

                    // add the "selected" class to the currently selected cell
                    cell.addClass('dp_selected');

                    // if we're on the "days" view and days from other months are selectable and one of those days was
                    // selected, repaint the datepicker so it will take us to the selected month
                    if (view == 'days' && cell.hasClass('dp_not_in_month_selectable')) plugin.show();

                }
            }

            // hide the date picker
            plugin.hide();

            // updates value for the date picker whose starting date depends on the selected date (if any)
            update_dependent(default_date);

            // if a callback function exists for when selecting a date
            if (plugin.settings.onSelect && typeof plugin.settings.onSelect == 'function')

                // execute the callback function
                plugin.settings.onSelect(selected_value, year + '-' + str_pad(month + 1, 2) + '-' + str_pad(day, 2), default_date, $element);

            // move focus to the element the plugin is attached to
            $element.focus();

        };

        /**
         *  Concatenates any number of arguments and returns them as string.
         *
         *  @return string  Returns the concatenated values.
         *
         *  @access private
         */
        var str_concat = function () {

            var str = '';

            // concatenate as string
            for (var i = 0; i < arguments.length; i++) str += (arguments[i] + '');

            // return the concatenated values
            return str;

        };

        /**
         *  Left-pad a string to a certain length with zeroes.
         *
         *  @param  string  str     The string to be padded.
         *
         *  @param  integer len     The length to which the string must be padded
         *
         *  @return string          Returns the string left-padded with leading zeroes
         *
         *  @access private
         */
        var str_pad = function (str, len) {

            // make sure argument is a string
            str += '';

            // pad with leading zeroes until we get to the desired length
            while (str.length < len) str = '0' + str;

            // return padded string
            return str;

        };

        /**
         *  Returns the integer representation of a string
         *
         *  @return int     Returns the integer representation of the string given as argument
         *
         *  @access private
         */
        var to_int = function (str) {

            // return the integer representation of the string given as argument
            return parseInt(str, 10);

        };

        /**
         *  Updates the paired date picker (whose starting date depends on the value of the current date picker)
         *
         *  @param  date    date    A JavaScript date object representing the currently selected date
         *
         *  @return void
         *
         *  @access private
         */
        var update_dependent = function (date) {

            // if the pair element exists
            if (plugin.settings.pair) {

                // iterate through the pair elements (as there may be more than just one)
                $.each(plugin.settings.pair, function () {

                    var $pair = $(this);

                    // chances are that in the beginning the pair element doesn't have the Zebra_DatePicker attached to it yet
                    // (as the "start" element is usually created before the "end" element)
                    // so we'll have to rely on "data" to send the starting date to the pair element

                    // therefore, if Zebra_DatePicker is not yet attached
                    if (!($pair.data && $pair.data('Zebra_DatePicker')))

                        // set the starting date like this
                        $pair.data('zdp_reference_date', date);

                    // if Zebra_DatePicker is attached to the pair element
                    else {

                        // reference the date picker object attached to the other element
                        var dp = $pair.data('Zebra_DatePicker');

                        // update the other date picker's starting date
                        // the value depends on the original value of the "direction" attribute
                        // (also, if the pair date picker does not have a direction, set it to 1)
                        dp.update({
                            'reference_date': date,
                            'direction': dp.settings.direction === 0 ? 1 : dp.settings.direction
                        });

                        // if the other date picker is always visible, update the visuals now
                        if (dp.settings.always_visible) dp.show();

                    }
                    if($pair.val() && date) {
                        var pairDate = new Date($pair.val());
                        if(pairDate < date) {
                            $pair.val("");
                        }
                    }

                });

            }

        };

        /**
         *  Calculate the ISO 8601 week number for a given date.
         *
         *  Code is based on the algorithm at http://www.tondering.dk/claus/cal/week.php#calcweekno
         */
        var getWeekNumber = function (date) {

            var y = date.getFullYear(),
                m = date.getMonth() + 1,
                d = date.getDate(),
                a, b, c, s, e, f, g, n, w;

            // If month jan. or feb.
            if (m < 3) {

                a = y - 1;
                b = (a / 4 | 0) - (a / 100 | 0) + (a / 400 | 0);
                c = ((a - 1) / 4 | 0) - ((a - 1) / 100 | 0) + ((a - 1) / 400 | 0);
                s = b - c;
                e = 0;
                f = d - 1 + 31 * (m - 1);

                // If month mar. through dec.
            } else {

                a = y;
                b = (a / 4 | 0) - (a / 100 | 0) + (a / 400 | 0);
                c = ((a - 1) / 4 | 0) - ((a - 1) / 100 | 0) + ((a - 1) / 400 | 0);
                s = b - c;
                e = s + 1;
                f = d + ((153 * (m - 3) + 2) / 5 | 0) + 58 + s;

            }

            g = (a + b) % 7;
            // ISO Weekday (0 is monday, 1 is tuesday etc.)
            d = (f + g - e) % 7;
            n = f + 3 - d;

            if (n < 0) w = 53 - ((g - s) / 5 | 0);

            else if (n > 364 + s) w = 1;

            else w = (n / 7 | 0) + 1;

            return w;

        };

        /**
         *  Function to be called when the "onKeyUp" event occurs
         *
         *  Why as a separate function and not inline when binding the event? Because only this way we can "unbind" it
         *  if the date picker is destroyed
         *
         *  @return void
         *
         *  @access private
         */
        var _keyup = function (e) {

            // if the date picker is visible
            // and the pressed key is ESC
            // hide the date picker
            if (datepicker.css('display') != 'none' || e.which == 27) plugin.hide();

        };

        /**
         *  Function to be called when the "onMouseDown" event occurs
         *
         *  Why as a separate function and not inline when binding the event? Because only this way we can "unbind" it
         *  if the date picker is destroyed
         *
         *  @return void
         *
         *  @access private
         */
        var _mousedown = function (e) {

            // if the date picker is visible (modern picker uses display:flex, not block)
            if (datepicker.css('display') != 'none') {

                // if the calendar icon is visible and we clicked it, let the onClick event of the icon to handle the event
                // (we want it to toggle the date picker)
                if (plugin.settings.show_icon && $(e.target).get(0) === icon.get(0)) return true;

                // if what's clicked is not inside the date picker
                // hide the date picker
                if ($(e.target).parents().filter('.Zebra_DatePicker').length === 0) plugin.hide();

            }

        };

        /**
         *  Function to be called when the "onResize" event occurs
         *
         *  Why as a separate function and not inline when binding the event? Because only this way we can "unbind" it
         *  if the date picker is destroyed
         *
         *  @return void
         *
         *  @access private
         */
        var _resize = function () {

            // hide the date picker
            plugin.hide();

            // if the icon is visible, update its position as the parent element might have changed position
            if (icon !== undefined) {

                // we use timeouts so that we do not call the "update" method on *every* step of the resize event

                // clear a previously set timeout
                clearTimeout(timeout);

                // set timeout again
                timeout = setTimeout(function () {

                    // update the date picker
                    plugin.update();

                }, 100);

            }

        };

        // since with jQuery 1.9.0 the $.browser object was removed, we rely on this piece of code from
        // http://www.quirksmode.org/js/detect.html to detect the browser
        var browser = {
            init: function () {
                this.name = this.searchString(this.dataBrowser) || '';
                this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || '';
            },
            searchString: function (data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) != -1)
                            return data[i].identity;
                    }
                    else if (dataProp)
                        return data[i].identity;
                }
            },
            searchVersion: function (dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            },
            dataBrowser: [
                {
                    string: navigator.userAgent,
                    subString: 'Firefox',
                    identity: 'firefox'
                },
                {
                    string: navigator.userAgent,
                    subString: 'MSIE',
                    identity: 'explorer',
                    versionSearch: 'MSIE'
                }
            ]
        };

        browser.init();

        // initialize the plugin
        init();

    };

    $.fn.date = function (options) {

        // iterate through all the elements to which we need to attach the date picker to
        return this.each(function () {

            // if element has a date picker already attached
            if (undefined !== $(this).data('Zebra_DatePicker'))

                // remove the attached date picker
                $(this).data('Zebra_DatePicker').destroy();

            // create an instance of the plugin
            var plugin = new $.Zebra_DatePicker(this, options);

            // save a reference to the newly created object
            $(this).data('Zebra_DatePicker', plugin);

        });

    };

})(jQuery);

; 
(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['../../'], factory);
    } else if (typeof exports === 'object' && typeof require === 'function') {
        // Browserify
        factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {
    'use strict';

    var
        utils = (function () {
            return {
                escapeRegExChars: function (value) {
                    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
                },
                createNode: function (containerClass) {
                    var div = document.createElement('div');
                    div.className = containerClass;
                    div.style.position = 'absolute';
                    div.style.display = 'none';
                    return div;
                }
            };
        }()),

        keys = {
            ESC: 27,
            TAB: 9,
            RETURN: 13,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40
        };

    function Autocomplete(el, options) {
        var noop = function () { },
            that = this,
            defaults = {
                ajaxSettings: {},
                autoSelectFirst: false,
                appendTo: document.body,
                serviceUrl: null,
                lookup: null,
                onSelect: null,
                width: 'auto',
                minChars: 1,
                maxHeight: 300,
                deferRequestBy: 0,
                params: {},
                formatResult: Autocomplete.formatResult,
                delimiter: null,
                zIndex: 9999,
                type: 'GET',
                noCache: false,
                onSearchStart: noop,
                onSearchComplete: noop,
                onSearchError: noop,
                preserveInput: false,
                containerClass: 'autocomplete-suggestions scrollable',
                tabDisabled: false,
                dataType: 'text',
                currentRequest: null,
                triggerSelectOnValidInput: true,
                preventBadQueries: true,
                lookupFilter: function (suggestion, originalQuery, queryLowerCase) {
                    return suggestion.value.toLowerCase().indexOf(queryLowerCase) !== -1;
                },
                paramName: 'query',
                transformResult: function (response) {
                    return typeof response === 'string' ? $.parseJSON(response) : response;
                },
                showNoSuggestionNotice: false,
                noSuggestionNotice: 'No results',
                orientation: 'bottom',
                forceFixPosition: false,
            };

        // Shared variables:
        that.element = el;
        that.el = $(el);
        that.suggestions = [];
        that.badQueries = [];
        that.selectedIndex = -1;
        that.currentValue = that.element.value;
        that.intervalId = 0;
        that.cachedResponse = {};
        that.onChangeInterval = null;
        that.onChange = null;
        that.isLocal = false;
        that.suggestionsContainer = null;
        that.noSuggestionsContainer = null;
        that.options = $.extend({}, defaults, options);
        that.classes = {
            selected: 'autocomplete-selected',
            suggestion: 'autocomplete-suggestion'
        };
        that.hint = null;
        that.hintValue = '';
        that.selection = null;

        // Initialize and set options:
        that.initialize();
        that.setOptions(options);
    }

    Autocomplete.utils = utils;

    $.Autocomplete = Autocomplete;

    Autocomplete.formatResult = function (suggestion, currentValue) {
        return suggestion.value;
    };

    Autocomplete.prototype = {

        killerFn: null,

        initialize: function () {
            var that = this,
                suggestionSelector = '.' + that.classes.suggestion,
                selected = that.classes.selected,
                options = that.options,
                container;

            // Remove autocomplete attribute to prevent native suggestions:
            that.element.setAttribute('autocomplete', 'off');

            that.killerFn = function (e) {
                if ($(e.target).closest('.' + that.options.containerClass).length === 0) {
                    that.killSuggestions();
                    that.disableKillerFn();
                }
            };

            // html() deals with many types: htmlString or Element or Array or jQuery
            that.noSuggestionsContainer = $('<div class="autocomplete-no-suggestion"></div>')
                .html(this.options.noSuggestionNotice).get(0);

            that.suggestionsContainer = Autocomplete.utils.createNode(options.containerClass);

            container = $(that.suggestionsContainer);

            container.appendTo(options.appendTo);

            // Only set width if it was provided:
            if (options.width !== 'auto') {
                container.width(options.width);
            }

            // Listen for mouse over event on suggestions list:
            container.on('mouseover.autocomplete', suggestionSelector, function () {
                that.activate($(this).data('index'));
            });

            // Deselect active element when mouse leaves suggestions container:
            container.on('mouseout.autocomplete', function () {
                that.selectedIndex = -1;
                container.children('.' + selected).removeClass(selected);
            });

            // Listen for click event on suggestions list:
            container.on('click.autocomplete', suggestionSelector, function () {
                that.select($(this).data('index'));
            });

            that.fixPositionCapture = function () {
                if (that.visible) {
                    that.fixPosition();
                }
            };

            $(window).on('resize.autocomplete', that.fixPositionCapture);

            that.el.on('keydown.autocomplete', function (e) { that.onKeyPress(e); });
            that.el.on('keyup.autocomplete', function (e) { that.onKeyUp(e); });
            that.el.on('blur.autocomplete', function () { that.onBlur(); });
            that.el.on('focus.autocomplete', function () { that.onFocus(); });
            that.el.on('change.autocomplete', function (e) { that.onKeyUp(e); });
            that.el.on('input.autocomplete', function (e) { that.onKeyUp(e); });
        },

        onFocus: function () {
            var that = this;
            that.fixPosition();
            if (that.options.minChars <= that.el.val().length) {
                that.onValueChange();
            }
        },

        onBlur: function () {
            this.enableKillerFn();
        },

        setOptions: function (suppliedOptions) {
            var that = this,
                options = that.options;

            $.extend(options, suppliedOptions);

            that.isLocal = $.isArray(options.lookup);

            if (that.isLocal) {
                options.lookup = that.verifySuggestionsFormat(options.lookup);
            }

            options.orientation = that.validateOrientation(options.orientation, 'bottom');

            // Adjust height, width and z-index:
            $(that.suggestionsContainer).css({
                'max-height': options.maxHeight + 'px',
                'width': options.width + 'px',
                'z-index': options.zIndex
            });
        },


        clearCache: function () {
            this.cachedResponse = {};
            this.badQueries = [];
        },

        clear: function () {
            this.clearCache();
            this.currentValue = '';
            this.suggestions = [];
        },

        disable: function () {
            var that = this;
            that.disabled = true;
            clearInterval(that.onChangeInterval);
            if (that.currentRequest) {
                that.currentRequest.abort();
            }
        },

        enable: function () {
            this.disabled = false;
        },

        fixPosition: function () {
            // Use only when container has already its content

            var that = this,
                $container = $(that.suggestionsContainer),
                containerParent = $container.parent().get(0);
            // Fix position automatically when appended to body.
            // In other cases force parameter must be given.
            if (containerParent !== document.body && !that.options.forceFixPosition) {
                return;
            }

            // Choose orientation
            var orientation = that.options.orientation,
                containerHeight = $container.outerHeight(),
                height = that.el.outerHeight(),
                offset = that.el.offset(),
                styles = { 'top': offset.top, 'left': offset.left };

            if (orientation === 'auto') {
                var viewPortHeight = $(window).height(),
                    scrollTop = $(window).scrollTop(),
                    topOverflow = -scrollTop + offset.top - containerHeight,
                    bottomOverflow = scrollTop + viewPortHeight - (offset.top + height + containerHeight);

                orientation = (Math.max(topOverflow, bottomOverflow) === topOverflow) ? 'top' : 'bottom';
            }

            if (orientation === 'top') {
                styles.top += -containerHeight;
            } else {
                styles.top += height;
            }

            // If container is not positioned to body,
            // correct its position using offset parent offset
            if(containerParent !== document.body) {
                var opacity = $container.css('opacity'),
                    parentOffsetDiff;

                if (!that.visible){
                    $container.css('opacity', 0).show();
                }

                parentOffsetDiff = $container.offsetParent().offset();
                styles.top -= parentOffsetDiff.top;
                styles.left -= parentOffsetDiff.left;

                if (!that.visible){
                    $container.css('opacity', opacity).hide();
                }
            }

            // -2px to account for suggestions border.
            if (that.options.width === 'auto') {
                styles.width = (that.el.outerWidth() - 2) + 'px';
            }

            $container.css(styles);
        },

        enableKillerFn: function () {
            var that = this;
            $(document).on('click.autocomplete', that.killerFn);
        },

        disableKillerFn: function () {
            var that = this;
            $(document).off('click.autocomplete', that.killerFn);
        },

        killSuggestions: function () {
            var that = this;
            that.stopKillSuggestions();
            that.intervalId = window.setInterval(function () {
                that.hide();
                that.stopKillSuggestions();
            }, 50);
        },

        stopKillSuggestions: function () {
            window.clearInterval(this.intervalId);
        },

        isCursorAtEnd: function () {
            var that = this,
                valLength = that.el.val().length,
                selectionStart = that.element.selectionStart,
                range;

            if (typeof selectionStart === 'number') {
                return selectionStart === valLength;
            }
            if (document.selection) {
                range = document.selection.createRange();
                range.moveStart('character', -valLength);
                return valLength === range.text.length;
            }
            return true;
        },

        onKeyPress: function (e) {
            var that = this;

            // If suggestions are hidden and user presses arrow down, display suggestions:
            if (!that.disabled && !that.visible && e.which === keys.DOWN && that.currentValue) {
                that.suggest();
                return;
            }

            if (that.disabled || !that.visible) {
                return;
            }

            switch (e.which) {
                case keys.ESC:
                    that.el.val(that.currentValue);
                    that.hide();
                    break;
                case keys.RIGHT:
                    if (that.hint && that.options.onHint && that.isCursorAtEnd()) {
                        that.selectHint();
                        break;
                    }
                    return;
                case keys.TAB:
                    if (that.hint && that.options.onHint) {
                        that.selectHint();
                        return;
                    }
                    if (that.selectedIndex === -1) {
                        that.hide();
                        return;
                    }
                    that.select(that.selectedIndex);
                    if (that.options.tabDisabled === false) {
                        return;
                    }
                    break;
                case keys.RETURN:
                    if (that.selectedIndex === -1) {
                        that.hide();
                        return;
                    }else if(that.options.linkedSuggestion) {
                        window.location = that.suggestions[that.selectedIndex].value.jqObject[0].attributes.href.value
                        that.el[0].blur();
                    }
                    that.select(that.selectedIndex);
                    break;
                case keys.UP:
                    that.moveUp();
                    break;
                case keys.DOWN:
                    that.moveDown();
                    break;
                default:
                    return;
            }

            // Cancel event if function did not return:
            e.stopImmediatePropagation();
            e.preventDefault();
        },

        onKeyUp: function (e) {
            var that = this;

            if (that.disabled) {
                return;
            }

            switch (e.which) {
                case keys.UP:
                case keys.DOWN:
                    return;
            }

            clearInterval(that.onChangeInterval);

            if (that.currentValue !== that.el.val()) {
                that.findBestHint();
                if (that.options.deferRequestBy > 0) {
                    // Defer lookup in case when value changes very quickly:
                    that.onChangeInterval = setInterval(function () {
                        that.onValueChange();
                    }, that.options.deferRequestBy);
                } else {
                    that.onValueChange();
                }
            }
        },

        onValueChange: function () {
            var that = this,
                options = that.options,
                value = that.el.val(),
                query = that.getQuery(value),
                index;

            if (that.selection && that.currentValue !== query) {
                that.selection = null;
                (options.onInvalidateSelection || $.noop).call(that.element);
            }

            clearInterval(that.onChangeInterval);
            that.currentValue = value;
            that.selectedIndex = -1;

            // Check existing suggestion for the match before proceeding:
            if (options.triggerSelectOnValidInput) {
                index = that.findSuggestionIndex(query);
                if (index !== -1) {
                    that.select(index);
                    return;
                }
            }

            if (query.length < options.minChars) {
                that.hide();
            } else {
                that.getSuggestions(query);
            }
        },

        findSuggestionIndex: function (query) {
            var that = this,
                index = -1,
                queryLowerCase = query.toLowerCase();

            $.each(that.suggestions, function (i, suggestion) {
                if (suggestion.value.toLowerCase() === queryLowerCase) {
                    index = i;
                    return false;
                }
            });

            return index;
        },

        getQuery: function (value) {
            var delimiter = this.options.delimiter,
                parts;

            if (!delimiter) {
                return value;
            }
            parts = value.split(delimiter);
            return $.trim(parts[parts.length - 1]);
        },

        getSuggestionsLocal: function (query) {
            var that = this,
                options = that.options,
                queryLowerCase = query.toLowerCase(),
                filter = options.lookupFilter,
                limit = parseInt(options.lookupLimit, 10),
                data;

            data = {
                suggestions: $.grep(options.lookup, function (suggestion) {
                    return filter(suggestion, query, queryLowerCase);
                })
            };

            if (limit && data.suggestions.length > limit) {
                data.suggestions = data.suggestions.slice(0, limit);
            }

            return data;
        },

        getSuggestions: function (q) {
            var response,
                that = this,
                options = that.options,
                serviceUrl = options.serviceUrl,
                params,
                cacheKey,
                ajaxSettings;

            options.params[options.paramName] = q;
            params = options.ignoreParams ? null : options.params;


            that.suggestionsContainer.jqObject.html('<div class="autocomplete-suggestion-searching"><span></span></div>');

            if (options.onSearchStart.call(that.element, options.params) === false) {
                return;
            }

            if ($.isFunction(options.lookup)){
                options.lookup(q, function (data) {
                    that.suggestions = data.suggestions;
                    that.suggest();
                    options.onSearchComplete.call(that.element, q, data.suggestions);
                });
                return;
            }

            if (that.isLocal) {
                response = that.getSuggestionsLocal(q);
            } else {
                if ($.isFunction(serviceUrl)) {
                    serviceUrl = serviceUrl.call(that.element, q);
                }
                cacheKey = serviceUrl + '?' + $.param(params || {});
                response = that.cachedResponse[cacheKey];
            }

            if (response && $.isArray(response.suggestions)) {
                that.suggestions = response.suggestions;
                that.suggest();
                options.onSearchComplete.call(that.element, q, response.suggestions);
            } else if (!that.isBadQuery(q)) {
                if (that.currentRequest) {
                    that.currentRequest.abort();
                }

                ajaxSettings = {
                    url: serviceUrl,
                    data: params,
                    type: options.type,
                    dataType: options.dataType
                };

                $.extend(ajaxSettings, options.ajaxSettings);

                that.currentRequest = $.ajax(ajaxSettings).done(function (data) {
                    var result;
                    that.currentRequest = null;
                    result = options.transformResult(data);
                    that.processResponse(result, q, cacheKey);
                    options.onSearchComplete.call(that.element, q, result.suggestions);
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    options.onSearchError.call(that.element, q, jqXHR, textStatus, errorThrown);
                });
            } else {
                options.onSearchComplete.call(that.element, q, []);
            }
        },

        isBadQuery: function (q) {
            if (!this.options.preventBadQueries){
                return false;
            }

            var badQueries = this.badQueries,
                i = badQueries.length;

            while (i--) {
                if (q.indexOf(badQueries[i]) === 0) {
                    return true;
                }
            }

            return false;
        },

        hide: function () {
            var that = this;
            that.visible = false;
            that.selectedIndex = -1;
            clearInterval(that.onChangeInterval);
            $(that.suggestionsContainer).hide();
            that.signalHint(null);
        },

        suggest: function () {
            if (this.suggestions.length === 0) {
                if (this.options.showNoSuggestionNotice) {
                    this.noSuggestions();
                } else {
                    this.hide();
                }
                return;
            }

            var that = this,
                options = that.options,
                groupBy = options.groupBy,
                formatResult = options.formatResult,
                value = that.getQuery(that.currentValue),
                className = that.classes.suggestion,
                classSelected = that.classes.selected,
                container = $(that.suggestionsContainer),
                noSuggestionsContainer = $(that.noSuggestionsContainer),
                beforeRender = options.beforeRender,
                html = '',
                category,
                formatGroup = function (suggestion, index) {
                    var currentCategory = suggestion.data[groupBy];

                    if (category === currentCategory){
                        return '';
                    }

                    category = currentCategory;

                    return '<div class="autocomplete-group"><strong>' + category + '</strong></div>';
                },
                index;

            if (options.triggerSelectOnValidInput) {
                index = that.findSuggestionIndex(value);
                if (index !== -1) {
                    that.select(index);
                    return;
                }
            }

            // Build suggestions inner HTML:
            $.each(that.suggestions, function (i, suggestion) {
                if (groupBy){
                    html += formatGroup(suggestion, value, i);
                }

                html += '<div class="' + className + '" data-index="' + i + '">' + formatResult(suggestion, value) + '</div>';
            });

            this.adjustContainerWidth();

            noSuggestionsContainer.detach();
            container.html(html);

            if ($.isFunction(beforeRender)) {
                beforeRender.call(that.element, container);
            }

            that.fixPosition();
            container.show();

            // Select first value by default:
            if (options.autoSelectFirst) {
                that.selectedIndex = 0;
                container.scrollTop(0);
                container.children().first().addClass(classSelected);
            }

            that.visible = true;
            that.findBestHint();
        },

        noSuggestions: function() {
            var that = this,
                container = $(that.suggestionsContainer),
                noSuggestionsContainer = $(that.noSuggestionsContainer);

            this.adjustContainerWidth();

            // Some explicit steps. Be careful here as it easy to get
            // noSuggestionsContainer removed from DOM if not detached properly.
            noSuggestionsContainer.detach();
            container.empty(); // clean suggestions if any
            container.append(noSuggestionsContainer);

            that.fixPosition();

            container.show();
            that.visible = true;
        },

        adjustContainerWidth: function() {
            var that = this,
                options = that.options,
                width,
                container = $(that.suggestionsContainer);

            // If width is auto, adjust width before displaying suggestions,
            // because if instance was created before input had width, it will be zero.
            // Also it adjusts if input width has changed.
            // -2px to account for suggestions border.
            if (options.width === 'auto') {
                width = that.el.outerWidth() - 2;
                container.width(width > 0 ? width : 300);
            }
        },

        findBestHint: function () {
            var that = this,
                value = that.el.val().toLowerCase(),
                bestMatch = null;

            if (!value) {
                return;
            }

            $.each(that.suggestions, function (i, suggestion) {
                var foundMatch = suggestion.value.toLowerCase().indexOf(value) === 0;
                if (foundMatch) {
                    bestMatch = suggestion;
                }
                return !foundMatch;
            });

            that.signalHint(bestMatch);
        },

        signalHint: function (suggestion) {
            var hintValue = '',
                that = this;
            if (suggestion) {
                hintValue = that.currentValue + suggestion.value.substr(that.currentValue.length);
            }
            if (that.hintValue !== hintValue) {
                that.hintValue = hintValue;
                that.hint = suggestion;
                (this.options.onHint || $.noop)(hintValue);
            }
        },

        verifySuggestionsFormat: function (suggestions) {
            // If suggestions is string array, convert them to supported format:
            if (suggestions.length && typeof suggestions[0] === 'string') {
                return $.map(suggestions, function (value) {
                    return { value: value, data: null };
                });
            }

            return suggestions;
        },

        validateOrientation: function(orientation, fallback) {
            orientation = $.trim(orientation || '').toLowerCase();

            if($.inArray(orientation, ['auto', 'bottom', 'top']) === -1){
                orientation = fallback;
            }

            return orientation;
        },

        processResponse: function (result, originalQuery, cacheKey) {
            var that = this,
                options = that.options;

            result.suggestions = that.verifySuggestionsFormat(result.suggestions);

            // Cache results if cache is not disabled:
            if (!options.noCache) {
                that.cachedResponse[cacheKey] = result;
                if (options.preventBadQueries && result.suggestions.length === 0) {
                    that.badQueries.push(originalQuery);
                }
            }

            // Return if originalQuery is not matching current query:
            if (originalQuery !== that.getQuery(that.currentValue)) {
                return;
            }

            that.suggestions = result.suggestions;
            that.suggest();
        },

        activate: function (index) {
            var that = this,
                activeItem,
                selected = that.classes.selected,
                container = $(that.suggestionsContainer),
                children = container.find('.' + that.classes.suggestion);

            container.find('.' + selected).removeClass(selected);

            that.selectedIndex = index;

            if (that.selectedIndex !== -1 && children.length > that.selectedIndex) {
                activeItem = children.get(that.selectedIndex);
                $(activeItem).addClass(selected);
                return activeItem;
            }

            return null;
        },

        selectHint: function () {
            var that = this,
                i = $.inArray(that.hint, that.suggestions);

            that.select(i);
        },

        select: function (i) {
            var that = this;
            that.hide();
            that.onSelect(i);
        },

        moveUp: function () {
            var that = this;

            if (that.selectedIndex === -1) {
                return;
            }

            if (that.selectedIndex === 0) {
                $(that.suggestionsContainer).children().first().removeClass(that.classes.selected);
                that.selectedIndex = -1;
                that.el.val(that.currentValue);
                that.findBestHint();
                return;
            }

            that.adjustScroll(that.selectedIndex - 1);
        },

        moveDown: function () {
            var that = this;

            if (that.selectedIndex === (that.suggestions.length - 1)) {
                return;
            }

            that.adjustScroll(that.selectedIndex + 1);
        },

        adjustScroll: function (index) {
            var that = this,
                activeItem = that.activate(index);

            if (!activeItem) {
                return;
            }

            var offsetTop,
                upperBound,
                lowerBound,
                heightDelta = $(activeItem).outerHeight();

            offsetTop = activeItem.offsetTop;
            upperBound = $(that.suggestionsContainer).scrollTop();
            lowerBound = upperBound + that.options.maxHeight - heightDelta;

            if (offsetTop < upperBound) {
                $(that.suggestionsContainer).scrollTop(offsetTop);
            } else if (offsetTop > lowerBound) {
                $(that.suggestionsContainer).scrollTop(offsetTop - that.options.maxHeight + heightDelta);
            }

            if (!that.options.preserveInput && !that.options.linkedSuggestion) {
                that.el.val(that.getValue(that.suggestions[index].value));
            }
            that.signalHint(null);
        },

        onSelect: function (index) {
            var that = this,
                onSelectCallback = that.options.onSelect,
                suggestion = that.suggestions[index];
            that.currentValue = that.getValue(suggestion.value);
            if (that.currentValue !== that.el.val() && !that.options.preserveInput && !that.options.linkedSuggestion) {
                that.el.val(that.currentValue);
            }
            that.signalHint(null);
            that.suggestions = [];
            that.selection = suggestion;

            if ($.isFunction(onSelectCallback)) {
                onSelectCallback.call(that.element, suggestion);
            }
        },

        getValue: function (value) {
            var that = this,
                delimiter = that.options.delimiter,
                currentValue,
                parts;

            if (!delimiter) {
                return value;
            }

            currentValue = that.currentValue;
            parts = currentValue.split(delimiter);

            if (parts.length === 1) {
                return value;
            }

            return currentValue.substr(0, currentValue.length - parts[parts.length - 1].length) + value;
        },

        dispose: function () {
            var that = this;
            that.el.off('.autocomplete').removeData('autocomplete');
            that.disableKillerFn();
            $(window).off('resize.autocomplete', that.fixPositionCapture);
            $(that.suggestionsContainer).remove();
        }
    };

    // Create chainable jQuery plugin:
    $.fn.autocomplete = $.fn.devbridgeAutocomplete = function (options, args) {
        var dataKey = 'autocomplete';
        // If function invoked without argument return
        // instance of the first matched element:
        if (arguments.length === 0) {
            return this.first().data(dataKey);
        }

        return this.each(function () {
            var inputElement = $(this),
                instance = inputElement.data(dataKey);

            if (typeof options === 'string') {
                if (instance && typeof instance[options] === 'function') {
                    instance[options](args);
                }
            } else {
                // If instance already exists, destroy it:
                if (instance && instance.dispose) {
                    instance.dispose();
                }
                instance = new Autocomplete(this, options);
                inputElement.data(dataKey, instance);
            }
        });
    };
}));

; (function($){
$.fn.dropzie = function(settingsOverrides){

    // options

        var settings = $.extend({
            // this is the list of all available options and their defaults
            'search': true,
            'tagMode': false, // shows the selected options in the toggle as tags - custom toggles not supported
            'hideFirstOptionFromList': true, // use this if your first option is 'Select...' or similar
            'customToggle': null // css selector for a custom trigger/button you'd like to use to open the menu – if set the standard trigger will be hidden
       }, settingsOverrides);
       
       var rootMenu = $(this);
       
       var multiSelect = false;
       if ( $(rootMenu).attr('multiple') ) multiSelect = true;
       
       var callback = settings.change;
           
    // basic setup

        $(rootMenu).hide();

        // if no options selected, make the first one selected
        if ( !$(rootMenu).find('option[selected]').length ) {
           $(rootMenu).find('option:first-child').attr('selected', '1');
        }

        // get options as an array
        var options = [];
        $(rootMenu).find('option').each(function(i){
            var selected = false;
            if ( $(this).attr('selected') ) var selected = true;
            options.push({
                'label': $(this).html(),
                'value': $(this).attr('value'),
                'html': $(this).attr('data-html'),
                'selected': selected
            });
        });

        // get currently selected options and create label
        
        var dr = $('<div class="dropzie" tabindex="0"></div>');

        var label = '';
        var selected = [];
        $.each(options, function(i, opt){
           if ( opt['selected'] == true ) {
                if ( !settings.tagMode ) {
                    label = label + opt['label'] + ', ';
                } else {
                    label = label + '<a class="dropzieTag" data-value="' + opt['value'] + '"><span></span>' + opt['label'] + '</a>';
                }
                selected.push(opt);
           }
        });
        if ( !settings.tagMode ) var label = label.slice(0, -2);
        
        if ( settings.tagMode ) {
            $(dr).append('<div class="dropzieToggle dropzieTagMode">'+label+'</div>');
        } else if ( settings.customToggle ) {
            $(dr).append('<button class="dropzieToggle" style="display:none;">'+label+'</button>');
        } else {
            $(dr).append('<button class="dropzieToggle">'+label+'</button>');
        }

        var drList = $('<div class="dropzieList"></div>');
        $.each(options, function(i, opt){
           if ( i == 0 && settings.hideFirstOptionFromList == true ) {
               // skip
           } else {
               if ( opt['html'] ) {
                   var label = opt['html'];
               } else {
                   var label = opt['label'];
               }
               $(drList).append('<div class="dropzieOption" data-value="'+opt['value']+'" data-selected="'+opt['selected']+'" data-label="'+opt['label']+'">'+label+'</div>');
           }
        });
        if ( settings.search ) {
            $(dr).append('<div class="dropzieMenu"><input type="text" class="dropzieSearch" placeholder="Search" />'+$(drList).html()+'</div>');
        } else {
            $(dr).append('<div class="dropzieMenu">'+$(drList).html()+'</div>');
        }

        $(rootMenu).after(dr);
        
        // update dropzie menu whenever root menu changes
        $(rootMenu).on('change', function(){
            
            $(dr).find('.dropzieOption[data-selected="true"]').each(function(){
                $(this).attr('data-selected', 'false');
            });
            
            $(rootMenu).find('option:selected').each(function(){
                var val = $(this).attr('value');
                $(dr).find('.dropzieOption[data-value="'+val+'"]').click();
            });
            
        });

    // interactions

        // open/close
        
            function dropzieOpen(){
                
                // close any other dropzies on page
                $('.dropzie').each(function(){
                    $(this).removeClass('active');
                    $(this).find('input').val('').blur();
                });
                
                // open this one
                $(dr).addClass('active');
                setTimeout(function(){
                    $(dr).find('input').focus();
                }, 10);
                
            }
            
            function dropzieClose(){
                $(dr).removeClass('active');
                $(dr).find('input').val('').blur();
            }

            function rebindCloseOnOutsideClick() {
                $(document).unbind().on('click', function (event) {
                    if (!$(event.target).closest('.dropzieToggle').length) {
                        dropzieClose();
                    }
                });
            }
            
            // open/close on toggle click
            $(dr).find('.dropzieToggle').click(function(e){
                e.preventDefault();
                rebindCloseOnOutsideClick(dr);
                if ( $(dr).hasClass('active') ) {
                    dropzieClose();
                } else {
                    dropzieOpen();
                }
            });
            $(settings.customToggle).click(function(e){
                e.preventDefault();
                if ( $(dr).hasClass('active') ) {
                    dropzieClose();
                } else {
                    dropzieOpen();
                }
            });
            
            // close if user clicks outside dropdown
            $(document).click(function(e){
                if ( !$(e.target).parents('.dropzie').length && $(e.target) && !$(e.target).parents(settings.customToggle) ) {
                    dropzieClose();
                }
            });
        
        // select/deselect options
        
            $(dr).find('.dropzieOption, .dropzieTag span').click(function(){
                
                if ( multiSelect == false ) {
                    // when in single-select mode, you cannot deselect the selected item
                    $(dr).find('.dropzieOption[data-selected="true"]').attr('data-selected', 'false');
                }
                
                if ( $(this).parent('.dropzieTag').length !== 0 ) {
                    $(dr).find('.dropzieOption[data-value="'+$(this).parent('.dropzieTag').attr('data-value')+'"]').attr('data-selected', 'false');
                } else if ( $(this).attr('data-selected') == 'true' ) {
                    $(this).attr('data-selected', 'false');
                } else {
                    $(this).attr('data-selected', 'true');
                }
                
                if ( multiSelect == false ) {
                    // when in single-select mode, automatically close the menu
                    dropzieClose();
                }
                
                // update label
                
                    var label = '';
                    var selected = [];
                    $(dr).find('.dropzieOption[data-selected="true"]').each(function(){
                       if ( $(this).attr('data-selected') == 'true' ) {
                           if ( !settings.tagMode ) {
                               label = label + $(this).attr('data-label') + ', ';
                           } else {
                               label = label + '<a class="dropzieTag" data-value="' + $(this).attr('data-value') + '"><span></span>' + $(this).attr('data-label') + '</a>';
                           }
                       }
                    });
                    if ( label ) {
                        if ( !settings.tagMode ) var label = label.slice(0, -2);
                    } else {
                        var firstOpt = $(rootMenu).find('option').first();
                        if ( $(firstOpt).attr('data-html') ) {
                            var label = $(firstOpt).attr('data-html');
                        } else {
                            var label = $(firstOpt).html();
                        }
                    }
                    $(dr).find('.dropzieToggle').html(label);
                
                // update root menu
                
                    $(rootMenu).find('option:selected').each(function(){
                        $(this).removeAttr('selected');
                    });
                    
                    $(dr).find('.dropzieOption[data-selected="true"]').each(function(){
                        var val = $(this).attr('data-value');
                        $(rootMenu).find('option[value="'+val+'"]').prop('selected', 'selected');
                    });
                    
                // callback
                
                    if ($.isFunction(callback)) {
                        callback.call();
                    }
                
            });
        
        // search
        
            var search = $(dr).find('.dropzieSearch');
            $(search).on('keyup', function(){
                var searchVal = $(this).val().toLowerCase();
                if ( searchVal.length > 0 ) {
                    $(dr).find('.dropzieOption').each(function(){
                        $(this).hide();
                        if ( $(this).html().toLowerCase().includes(searchVal) || $(this).attr('data-selected') == 'true' ) {
                            $(this).show();
                        } else {
                            $(this).hide();
                        }
                    });
                } else {
                    $(dr).find('.dropzieOption').show();
                }
            });
        
        // arrow keys
        
            $(document).on('keydown', function(e){
                if ( $(dr).hasClass('active') ) {
                    var max = $(dr).find('.dropzieOption.hov').length;
                    if ( e.which == 38 ) {
                        // up
                        if ( !$(dr).find('.dropzieOption.hov').length ) {
                            $(dr).find('.dropzieOption:last-of-type').addClass('hov');
                        } else {
                            var activeHovItem = $(dr).find('.dropzieOption.hov').index() + 1;
                            if ( activeHovItem == 1 ) {
                                var itemToSelect = max;
                            } else {
                                var itemToSelect = activeHovItem - 1;
                            }
                            $(dr).find('.dropzieOption.hov').removeClass('hov');
                            $(dr).find('.dropzieOption:nth-child('+itemToSelect+')').addClass('hov');
                        }
                    } else if ( e.which == 40 ) {
                        // down
                        if ( !$(dr).find('.dropzieOption.hov').length ) {
                            $(dr).find('.dropzieOption:first-of-type').addClass('hov');
                        } else {
                            var activeHovItem = $(dr).find('.dropzieOption.hov').index() + 1;
                            if ( activeHovItem == max ) {
                                var itemToSelect = 1;
                            } else {
                                var itemToSelect = activeHovItem + 1;
                            }
                            $(dr).find('.dropzieOption.hov').removeClass('hov');
                            $(dr).find('.dropzieOption:nth-child('+itemToSelect+')').addClass('hov');
                        }
                    } else if ( e.which == 13 ) {
                        $(dr).find('.dropzieOption.hov').click();
                    }
                }
            });
    
};
})(jQuery);

; /*
 * jQuery File Upload Plugin 5.40.1
 * https://github.com/blueimp/jQuery-File-Upload
 *
 * Copyright 2010, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * http://www.opensource.org/licenses/MIT
 */

/* jshint nomen:false */
/* global define, window, document, location, Blob, FormData */

(function (factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        // Register as an anonymous AMD module:
        define([
            'jquery',
            'jquery.ui.widget'
        ], factory);
    } else {
        // Browser globals:
        factory(window.jQuery);
    }
}(function ($) {
    'use strict';

    // Detect file input support, based on
    // http://viljamis.com/blog/2012/file-upload-support-on-mobile/
    $.support.fileInput = !(new RegExp(
        // Handle devices which give false positives for the feature detection:
        '(Android (1\\.[0156]|2\\.[01]))' +
        '|(Windows Phone (OS 7|8\\.0))|(XBLWP)|(ZuneWP)|(WPDesktop)' +
        '|(w(eb)?OSBrowser)|(webOS)' +
        '|(Kindle/(1\\.0|2\\.[05]|3\\.0))'
        ).test(window.navigator.userAgent) ||
        // Feature detection for all other devices:
        $('<input type="file">').prop('disabled'));

    // The FileReader API is not actually used, but works as feature detection,
    // as some Safari versions (5?) support XHR file uploads via the FormData API,
    // but not non-multipart XHR file uploads.
    // window.XMLHttpRequestUpload is not available on IE10, so we check for
    // window.ProgressEvent instead to detect XHR2 file upload capability:
    $.support.xhrFileUpload = !!(window.ProgressEvent && window.FileReader);
    $.support.xhrFormDataFileUpload = !!window.FormData;

    // Detect support for Blob slicing (required for chunked uploads):
    $.support.blobSlice = window.Blob && (Blob.prototype.slice ||
        Blob.prototype.webkitSlice || Blob.prototype.mozSlice);

    // The fileupload widget listens for change events on file input fields defined
    // via fileInput setting and paste or drop events of the given dropZone.
    // In addition to the default jQuery Widget methods, the fileupload widget
    // exposes the "add" and "send" methods, to add or directly send files using
    // the fileupload API.
    // By default, files added via file input selection, paste, drag & drop or
    // "add" method are uploaded immediately, but it is possible to override
    // the "add" callback option to queue file uploads.
    var xFileOptions = {
        // The drop target element(s), by the default the complete document.
        // Set to null to disable drag & drop support:
        dropZone: $(document),
        // The paste target element(s), by the default the complete document.
        // Set to null to disable paste support:
        pasteZone: $(document),
        // The file input field(s), that are listened to for change events.
        // If undefined, it is set to the file input fields inside
        // of the widget element on plugin initialization.
        // Set to null to disable the change listener.
        fileInput: undefined,
        // By default, the file input field is replaced with a clone after
        // each input field change event. This is required for iframe transport
        // queues and allows change events to be fired for the same file
        // selection, but can be disabled by setting the following option to false:
        replaceFileInput: true,
        // The parameter name for the file form data (the request argument name).
        // If undefined or empty, the name property of the file input field is
        // used, or "files[]" if the file input name property is also empty,
        // can be a string or an array of strings:
        paramName: undefined,
        // By default, each file of a selection is uploaded using an individual
        // request for XHR type uploads. Set to false to upload file
        // selections in one request each:
        singleFileUploads: true,
        // To limit the number of files uploaded with one XHR request,
        // set the following option to an integer greater than 0:
        limitMultiFileUploads: undefined,
        // The following option limits the number of files uploaded with one
        // XHR request to keep the request size under or equal to the defined
        // limit in bytes:
        limitMultiFileUploadSize: undefined,
        // Multipart file uploads add a number of bytes to each uploaded file,
        // therefore the following option adds an overhead for each file used
        // in the limitMultiFileUploadSize configuration:
        limitMultiFileUploadSizeOverhead: 512,
        // Set the following option to true to issue all file upload requests
        // in a sequential order:
        sequentialUploads: false,
        // To limit the number of concurrent uploads,
        // set the following option to an integer greater than 0:
        limitConcurrentUploads: undefined,
        // Set the following option to true to force iframe transport uploads:
        forceIframeTransport: false,
        // Set the following option to the location of a redirect url on the
        // origin server, for cross-domain iframe transport uploads:
        redirect: undefined,
        // The parameter name for the redirect url, sent as part of the form
        // data and set to 'redirect' if this option is empty:
        redirectParamName: undefined,
        // Set the following option to the location of a postMessage window,
        // to enable postMessage transport uploads:
        postMessage: undefined,
        // By default, XHR file uploads are sent as multipart/form-data.
        // The iframe transport is always using multipart/form-data.
        // Set to false to enable non-multipart XHR uploads:
        multipart: true,
        // To upload large files in smaller chunks, set the following option
        // to a preferred maximum chunk size. If set to 0, null or undefined,
        // or the browser does not support the required Blob API, files will
        // be uploaded as a whole.
        maxChunkSize: undefined,
        // When a non-multipart upload or a chunked multipart upload has been
        // aborted, this option can be used to resume the upload by setting
        // it to the size of the already uploaded bytes. This option is most
        // useful when modifying the options object inside of the "add" or
        // "send" callbacks, as the options are cloned for each file upload.
        uploadedBytes: undefined,
        // By default, failed (abort or error) file uploads are removed from the
        // global progress calculation. Set the following option to false to
        // prevent recalculating the global progress data:
        recalculateProgress: true,
        // Interval in milliseconds to calculate and trigger progress events:
        progressInterval: 100,
        // Interval in milliseconds to calculate progress bitrate:
        bitrateInterval: 500,
        // By default, uploads are started automatically when adding files:
        autoUpload: true,

        // Error and info messages:
        messages: {
            uploadedBytes: 'Uploaded bytes exceed file size'
        },

        // Translation function, gets the message key to be translated
        // and an object with context specific data as arguments:
        i18n: function (message, context) {
            message = this.messages[message] || message.toString();
            if (context) {
                $.each(context, function (key, value) {
                    message = message.replace('{' + key + '}', value);
                });
            }
            return message;
        },

        // Additional form data to be sent along with the file uploads can be set
        // using this option, which accepts an array of objects with name and
        // value properties, a function returning such an array, a FormData
        // object (for XHR file uploads), or a simple object.
        // The form of the first fileInput is given as parameter to the function:
        formData: function (form) {
            return form.serializeArray();
        },

        // The add callback is invoked as soon as files are added to the fileupload
        // widget (via file input selection, drag & drop, paste or add API call).
        // If the singleFileUploads option is enabled, this callback will be
        // called once for each file in the selection for XHR file uploads, else
        // once for each file selection.
        //
        // The upload starts when the submit method is invoked on the data parameter.
        // The data object contains a files property holding the added files
        // and allows you to override plugin options as well as define ajax settings.
        //
        // Listeners for this callback can also be bound the following way:
        // .bind('fileuploadadd', func);
        //
        // data.submit() returns a Promise object and allows to attach additional
        // handlers using jQuery's Deferred callbacks:
        // data.submit().done(func).fail(func).always(func);
        add: function (e, data) {
            if (e.isDefaultPrevented()) {
                return false;
            }
            if (data.autoUpload || (data.autoUpload !== false &&
                $(this).fileupload('option', 'autoUpload'))) {
                data.process().done(function () {
                    data.submit();
                });
            }
        },

        // Other callbacks:

        // Callback for the submit event of each file upload:
        // submit: function (e, data) {}, // .bind('fileuploadsubmit', func);

        // Callback for the start of each file upload request:
        // send: function (e, data) {}, // .bind('fileuploadsend', func);

        // Callback for successful uploads:
        // done: function (e, data) {}, // .bind('fileuploaddone', func);

        // Callback for failed (abort or error) uploads:
        // fail: function (e, data) {}, // .bind('fileuploadfail', func);

        // Callback for completed (success, abort or error) requests:
        // always: function (e, data) {}, // .bind('fileuploadalways', func);

        // Callback for upload progress events:
        // progress: function (e, data) {}, // .bind('fileuploadprogress', func);

        // Callback for global upload progress events:
        // progressall: function (e, data) {}, // .bind('fileuploadprogressall', func);

        // Callback for uploads start, equivalent to the global ajaxStart event:
        // start: function (e) {}, // .bind('fileuploadstart', func);

        // Callback for uploads stop, equivalent to the global ajaxStop event:
        // stop: function (e) {}, // .bind('fileuploadstop', func);

        // Callback for change events of the fileInput(s):
        // change: function (e, data) {}, // .bind('fileuploadchange', func);

        // Callback for paste events to the pasteZone(s):
        // paste: function (e, data) {}, // .bind('fileuploadpaste', func);

        // Callback for drop events of the dropZone(s):
        // drop: function (e, data) {}, // .bind('fileuploaddrop', func);

        // Callback for dragover events of the dropZone(s):
        // dragover: function (e) {}, // .bind('fileuploaddragover', func);

        // Callback for the start of each chunk upload request:
        // chunksend: function (e, data) {}, // .bind('fileuploadchunksend', func);

        // Callback for successful chunk uploads:
        // chunkdone: function (e, data) {}, // .bind('fileuploadchunkdone', func);

        // Callback for failed (abort or error) chunk uploads:
        // chunkfail: function (e, data) {}, // .bind('fileuploadchunkfail', func);

        // Callback for completed (success, abort or error) chunk upload requests:
        // chunkalways: function (e, data) {}, // .bind('fileuploadchunkalways', func);

        // The plugin options are used as settings object for the ajax calls.
        // The following are jQuery ajax settings required for the file uploads:
        processData: false,
        contentType: false,
        cache: false
    }
    var XFile = function(element, options) {
        this.element = element;
        this.options = $.extend({}, xFileOptions, options);
        this._create();
    }
    bm.jquerify("fileupload", XFile)
    XFile.prototype = {

        // A list of options that require reinitializing event listeners and/or
        // special initialization code:
        _specialOptions: [
            'fileInput',
            'dropZone',
            'pasteZone',
            'multipart',
            'forceIframeTransport'
        ],

        _blobSlice: $.support.blobSlice && function () {
            var slice = this.slice || this.webkitSlice || this.mozSlice;
            return slice.apply(this, arguments);
        },

        _BitrateTimer: function () {
            this.timestamp = ((Date.now) ? Date.now() : (new Date()).getTime());
            this.loaded = 0;
            this.bitrate = 0;
            this.getBitrate = function (now, loaded, interval) {
                var timeDiff = now - this.timestamp;
                if (!this.bitrate || !interval || timeDiff > interval) {
                    this.bitrate = (loaded - this.loaded) * (1000 / timeDiff) * 8;
                    this.loaded = loaded;
                    this.timestamp = now;
                }
                return this.bitrate;
            };
        },

        _isXHRUpload: function (options) {
            return !options.forceIframeTransport &&
                ((!options.multipart && $.support.xhrFileUpload) ||
                    $.support.xhrFormDataFileUpload);
        },

        _getFormData: function (options) {
            var formData;
            if ($.type(options.formData) === 'function') {
                return options.formData(options.form);
            }
            if ($.isArray(options.formData)) {
                return options.formData;
            }
            if ($.type(options.formData) === 'object') {
                formData = [];
                $.each(options.formData, function (name, value) {
                    formData.push({name: name, value: value});
                });
                return formData;
            }
            return [];
        },

        _getTotal: function (files) {
            var total = 0;
            $.each(files, function (index, file) {
                total += file.size || 1;
            });
            return total;
        },

        _initProgressObject: function (obj) {
            var progress = {
                loaded: 0,
                total: 0,
                bitrate: 0
            };
            if (obj._progress) {
                $.extend(obj._progress, progress);
            } else {
                obj._progress = progress;
            }
        },

        _initResponseObject: function (obj) {
            var prop;
            if (obj._response) {
                for (prop in obj._response) {
                    if (obj._response.hasOwnProperty(prop)) {
                        delete obj._response[prop];
                    }
                }
            } else {
                obj._response = {};
            }
        },

        _onProgress: function (e, data) {
            if (e.lengthComputable) {
                var now = ((Date.now) ? Date.now() : (new Date()).getTime()),
                    loaded;
                if (data._time && data.progressInterval &&
                    (now - data._time < data.progressInterval) &&
                    e.loaded !== e.total) {
                    return;
                }
                data._time = now;
                loaded = Math.floor(
                    e.loaded / e.total * (data.chunkSize || data._progress.total)
                ) + (data.uploadedBytes || 0);
                // Add the difference from the previously loaded state
                // to the global loaded counter:
                this._progress.loaded += (loaded - data._progress.loaded);
                this._progress.bitrate = this._bitrateTimer.getBitrate(
                    now,
                    this._progress.loaded,
                    data.bitrateInterval
                );
                data._progress.loaded = data.loaded = loaded;
                data._progress.bitrate = data.bitrate = data._bitrateTimer.getBitrate(
                    now,
                    loaded,
                    data.bitrateInterval
                );
                // Trigger a custom progress event with a total data property set
                // to the file size(s) of the current upload and a loaded data
                // property calculated accordingly:
                this._trigger(
                    'progress',
                    $.Event('progress', {delegatedEvent: e}),
                    data
                );
                // Trigger a global progress event for all current file uploads,
                // including ajax calls queued for sequential file uploads:
                this._trigger(
                    'progressall',
                    $.Event('progressall', {delegatedEvent: e}),
                    this._progress
                );
            }
        },

        _initProgressListener: function (options) {
            var that = this,
                xhr = options.xhr ? options.xhr() : $.ajaxSettings.xhr();
            // Accesss to the native XHR object is required to add event listeners
            // for the upload progress event:
            if (xhr.upload) {
                $(xhr.upload).bind('progress', function (e) {
                    var oe = e.originalEvent;
                    // Make sure the progress event properties get copied over:
                    e.lengthComputable = oe.lengthComputable;
                    e.loaded = oe.loaded;
                    e.total = oe.total;
                    that._onProgress(e, options);
                });
                options.xhr = function () {
                    return xhr;
                };
            }
        },

        _isInstanceOf: function (type, obj) {
            // Cross-frame instanceof check
            return Object.prototype.toString.call(obj) === '[object ' + type + ']';
        },

        _initXHRData: function (options) {
            var that = this,
                formData,
                file = options.files[0],
                // Ignore non-multipart setting if not supported:
                multipart = options.multipart || !$.support.xhrFileUpload,
                paramName = $.type(options.paramName) === 'array' ?
                    options.paramName[0] : options.paramName;
            options.headers = $.extend({}, options.headers);
            if (options.contentRange) {
                options.headers['Content-Range'] = options.contentRange;
            }
            if (!multipart || options.blob || !this._isInstanceOf('File', file)) {
                options.headers['Content-Disposition'] = 'attachment; filename="' +
                    encodeURI(file.name) + '"';
            }
            if (!multipart) {
                options.contentType = file.type || 'application/octet-stream';
                options.data = options.blob || file;
            } else if ($.support.xhrFormDataFileUpload) {
                if (options.postMessage) {
                    // window.postMessage does not allow sending FormData
                    // objects, so we just add the File/Blob objects to
                    // the formData array and let the postMessage window
                    // create the FormData object out of this array:
                    formData = this._getFormData(options);
                    if (options.blob) {
                        formData.push({
                            name: paramName,
                            value: options.blob
                        });
                    } else {
                        $.each(options.files, function (index, file) {
                            formData.push({
                                name: ($.type(options.paramName) === 'array' &&
                                    options.paramName[index]) || paramName,
                                value: file
                            });
                        });
                    }
                } else {
                    if (that._isInstanceOf('FormData', options.formData)) {
                        formData = options.formData;
                    } else {
                        formData = new FormData();
                        $.each(this._getFormData(options), function (index, field) {
                            formData.append(field.name, field.value);
                        });
                    }
                    if (options.blob) {
                        formData.append(paramName, options.blob, file.name);
                    } else {
                        $.each(options.files, function (index, file) {
                            // This check allows the tests to run with
                            // dummy objects:
                            if (that._isInstanceOf('File', file) ||
                                that._isInstanceOf('Blob', file)) {
                                formData.append(
                                    ($.type(options.paramName) === 'array' &&
                                        options.paramName[index]) || paramName,
                                    file,
                                    file.uploadName || file.name
                                );
                            }
                        });
                    }
                }
                options.data = formData;
            }
            // Blob reference is not needed anymore, free memory:
            options.blob = null;
        },

        _initIframeSettings: function (options) {
            var targetHost = $('<a></a>').prop('href', options.url).prop('host');
            // Setting the dataType to iframe enables the iframe transport:
            options.dataType = 'iframe ' + (options.dataType || '');
            // The iframe transport accepts a serialized array as form data:
            options.formData = this._getFormData(options);
            // Add redirect url to form data on cross-domain uploads:
            if (options.redirect && targetHost && targetHost !== location.host) {
                options.formData.push({
                    name: options.redirectParamName || 'redirect',
                    value: options.redirect
                });
            }
        },

        _initDataSettings: function (options) {
            if (this._isXHRUpload(options)) {
                if (!this._chunkedUpload(options, true)) {
                    if (!options.data) {
                        this._initXHRData(options);
                    }
                    this._initProgressListener(options);
                }
                if (options.postMessage) {
                    // Setting the dataType to postmessage enables the
                    // postMessage transport:
                    options.dataType = 'postmessage ' + (options.dataType || '');
                }
            } else {
                this._initIframeSettings(options);
            }
        },

        _getParamName: function (options) {
            var fileInput = $(options.fileInput),
                paramName = options.paramName;
            if (!paramName) {
                paramName = [];
                fileInput.each(function () {
                    var input = $(this),
                        name = input.prop('name') || 'files[]',
                        i = (input.prop('files') || [1]).length;
                    while (i) {
                        paramName.push(name);
                        i -= 1;
                    }
                });
                if (!paramName.length) {
                    paramName = [fileInput.prop('name') || 'files[]'];
                }
            } else if (!$.isArray(paramName)) {
                paramName = [paramName];
            }
            return paramName;
        },

        _initFormSettings: function (options) {
            // Retrieve missing options from the input field and the
            // associated form, if available:
            if (!options.form || !options.form.length) {
                options.form = $(options.fileInput.prop('form'));
                // If the given file input doesn't have an associated form,
                // use the default widget file input's form:
                if (!options.form.length) {
                    options.form = $(this.options.fileInput.prop('form'));
                }
            }
            options.paramName = this._getParamName(options);
            if (!options.url) {
                options.url = options.form.prop('action') || location.href;
            }
            // The HTTP request method must be "POST" or "PUT":
            options.type = (options.type ||
                ($.type(options.form.prop('method')) === 'string' &&
                    options.form.prop('method')) || ''
            ).toUpperCase();
            if (options.type !== 'POST' && options.type !== 'PUT' &&
                options.type !== 'PATCH') {
                options.type = 'POST';
            }
            if (!options.formAcceptCharset) {
                options.formAcceptCharset = options.form.attr('accept-charset');
            }
        },

        _getAJAXSettings: function (data) {
            var options = $.extend({}, this.options, data);
            this._initFormSettings(options);
            this._initDataSettings(options);
            return options;
        },

        // jQuery 1.6 doesn't provide .state(),
        // while jQuery 1.8+ removed .isRejected() and .isResolved():
        _getDeferredState: function (deferred) {
            if (deferred.state) {
                return deferred.state();
            }
            if (deferred.isResolved()) {
                return 'resolved';
            }
            if (deferred.isRejected()) {
                return 'rejected';
            }
            return 'pending';
        },

        // Maps jqXHR callbacks to the equivalent
        // methods of the given Promise object:
        _enhancePromise: function (promise) {
            promise.success = promise.done;
            promise.error = promise.fail;
            promise.complete = promise.always;
            return promise;
        },

        // Creates and returns a Promise object enhanced with
        // the jqXHR methods abort, success, error and complete:
        _getXHRPromise: function (resolveOrReject, context, args) {
            var dfd = $.Deferred(),
                promise = dfd.promise();
            context = context || this.options.context || promise;
            if (resolveOrReject === true) {
                dfd.resolveWith(context, args);
            } else if (resolveOrReject === false) {
                dfd.rejectWith(context, args);
            }
            promise.abort = dfd.promise;
            return this._enhancePromise(promise);
        },

        // Adds convenience methods to the data callback argument:
        _addConvenienceMethods: function (e, data) {
            var that = this,
                getPromise = function (args) {
                    return $.Deferred().resolveWith(that, args).promise();
                };
            data.process = function (resolveFunc, rejectFunc) {
                if (resolveFunc || rejectFunc) {
                    data._processQueue = this._processQueue =
                        (this._processQueue || getPromise([this])).pipe(
                            function () {
                                if (data.errorThrown) {
                                    return $.Deferred()
                                        .rejectWith(that, [data]).promise();
                                }
                                return getPromise(arguments);
                            }
                        ).pipe(resolveFunc, rejectFunc);
                }
                return this._processQueue || getPromise([this]);
            };
            data.submit = function () {
                if (this.state() !== 'pending') {
                    data.jqXHR = this.jqXHR =
                        (that._trigger(
                            'submit',
                            $.Event('submit', {delegatedEvent: e}),
                            this
                        ) !== false) && that._onSend(e, this);
                }
                return this.jqXHR || that._getXHRPromise();
            };
            data.abort = function () {
                if (this.jqXHR) {
                    return this.jqXHR.abort();
                }
                this.errorThrown = 'abort';
                that._trigger('fail', null, this);
                return that._getXHRPromise(false);
            };
            data.state = function () {
                if (this.jqXHR) {
                    return that._getDeferredState(this.jqXHR);
                }
                if (this._processQueue) {
                    return that._getDeferredState(this._processQueue);
                }
            };
            data.processing = function () {
                return !this.jqXHR && this._processQueue && that
                    ._getDeferredState(this._processQueue) === 'pending';
            };
            data.progress = function () {
                return this._progress;
            };
            data.response = function () {
                return this._response;
            };
        },

        // Parses the Range header from the server response
        // and returns the uploaded bytes:
        _getUploadedBytes: function (jqXHR) {
            var range = jqXHR.getResponseHeader('Range'),
                parts = range && range.split('-'),
                upperBytesPos = parts && parts.length > 1 &&
                    parseInt(parts[1], 10);
            return upperBytesPos && upperBytesPos + 1;
        },

        // Uploads a file in multiple, sequential requests
        // by splitting the file up in multiple blob chunks.
        // If the second parameter is true, only tests if the file
        // should be uploaded in chunks, but does not invoke any
        // upload requests:
        _chunkedUpload: function (options, testOnly) {
            options.uploadedBytes = options.uploadedBytes || 0;
            var that = this,
                file = options.files[0],
                fs = file.size,
                ub = options.uploadedBytes,
                mcs = options.maxChunkSize || fs,
                slice = this._blobSlice,
                dfd = $.Deferred(),
                promise = dfd.promise(),
                jqXHR,
                upload;
            if (!(this._isXHRUpload(options) && slice && (ub || mcs < fs)) ||
                options.data) {
                return false;
            }
            if (testOnly) {
                return true;
            }
            if (ub >= fs) {
                file.error = options.i18n('uploadedBytes');
                return this._getXHRPromise(
                    false,
                    options.context,
                    [null, 'error', file.error]
                );
            }
            // The chunk upload method:
            upload = function () {
                // Clone the options object for each chunk upload:
                var o = $.extend({}, options),
                    currentLoaded = o._progress.loaded;
                o.blob = slice.call(
                    file,
                    ub,
                    ub + mcs,
                    file.type
                );
                // Store the current chunk size, as the blob itself
                // will be dereferenced after data processing:
                o.chunkSize = o.blob.size;
                // Expose the chunk bytes position range:
                o.contentRange = 'bytes ' + ub + '-' +
                    (ub + o.chunkSize - 1) + '/' + fs;
                // Process the upload data (the blob and potential form data):
                that._initXHRData(o);
                // Add progress listeners for this chunk upload:
                that._initProgressListener(o);
                jqXHR = ((that._trigger('chunksend', null, o) !== false && bm.ajax(o)) ||
                    that._getXHRPromise(false, o.context))
                    .done(function (result, textStatus, jqXHR) {
                        ub = that._getUploadedBytes(jqXHR) ||
                            (ub + o.chunkSize);
                        // Create a progress event if no final progress event
                        // with loaded equaling total has been triggered
                        // for this chunk:
                        if (currentLoaded + o.chunkSize - o._progress.loaded) {
                            that._onProgress($.Event('progress', {
                                lengthComputable: true,
                                loaded: ub - o.uploadedBytes,
                                total: ub - o.uploadedBytes
                            }), o);
                        }
                        options.uploadedBytes = o.uploadedBytes = ub;
                        o.result = result;
                        o.textStatus = textStatus;
                        o.jqXHR = jqXHR;
                        that._trigger('chunkdone', null, o);
                        that._trigger('chunkalways', null, o);
                        if (ub < fs) {
                            // File upload not yet complete,
                            // continue with the next chunk:
                            upload();
                        } else {
                            dfd.resolveWith(
                                o.context,
                                [result, textStatus, jqXHR]
                            );
                        }
                    })
                    .fail(function (jqXHR, textStatus, errorThrown) {
                        o.jqXHR = jqXHR;
                        o.textStatus = textStatus;
                        o.errorThrown = errorThrown;
                        that._trigger('chunkfail', null, o);
                        that._trigger('chunkalways', null, o);
                        dfd.rejectWith(
                            o.context,
                            [jqXHR, textStatus, errorThrown]
                        );
                    });
            };
            this._enhancePromise(promise);
            promise.abort = function () {
                return jqXHR.abort();
            };
            upload();
            return promise;
        },

        _beforeSend: function (e, data) {
            if (this._active === 0) {
                // the start callback is triggered when an upload starts
                // and no other uploads are currently running,
                // equivalent to the global ajaxStart event:
                this._trigger('start');
                // Set timer for global bitrate progress calculation:
                this._bitrateTimer = new this._BitrateTimer();
                // Reset the global progress values:
                this._progress.loaded = this._progress.total = 0;
                this._progress.bitrate = 0;
            }
            // Make sure the container objects for the .response() and
            // .progress() methods on the data object are available
            // and reset to their initial state:
            this._initResponseObject(data);
            this._initProgressObject(data);
            data._progress.loaded = data.loaded = data.uploadedBytes || 0;
            data._progress.total = data.total = this._getTotal(data.files) || 1;
            data._progress.bitrate = data.bitrate = 0;
            this._active += 1;
            // Initialize the global progress values:
            this._progress.loaded += data.loaded;
            this._progress.total += data.total;
        },

        _onDone: function (result, textStatus, jqXHR, options) {
            var total = options._progress.total,
                response = options._response;
            if (options._progress.loaded < total) {
                // Create a progress event if no final progress event
                // with loaded equaling total has been triggered:
                this._onProgress($.Event('progress', {
                    lengthComputable: true,
                    loaded: total,
                    total: total
                }), options);
            }
            response.result = options.result = result;
            response.textStatus = options.textStatus = textStatus;
            response.jqXHR = options.jqXHR = jqXHR;
            this._trigger('done', null, options);
        },

        _onFail: function (jqXHR, textStatus, errorThrown, options) {
            var response = options._response;
            if (options.recalculateProgress) {
                // Remove the failed (error or abort) file upload from
                // the global progress calculation:
                this._progress.loaded -= options._progress.loaded;
                this._progress.total -= options._progress.total;
            }
            response.jqXHR = options.jqXHR = jqXHR;
            response.textStatus = options.textStatus = textStatus;
            response.errorThrown = options.errorThrown = errorThrown;
            this._trigger('fail', null, options);
        },

        _onAlways: function (jqXHRorResult, textStatus, jqXHRorError, options) {
            // jqXHRorResult, textStatus and jqXHRorError are added to the
            // options object via done and fail callbacks
            this._trigger('always', null, options);
        },

        _onSend: function (e, data) {
            if (!data.submit) {
                this._addConvenienceMethods(e, data);
            }
            var that = this,
                jqXHR,
                aborted,
                slot,
                pipe,
                options = that._getAJAXSettings(data),
                send = function () {
                    that._sending += 1;
                    // Set timer for bitrate progress calculation:
                    options._bitrateTimer = new that._BitrateTimer();
                    jqXHR = jqXHR || (
                        ((aborted || that._trigger(
                            'send',
                            $.Event('send', {delegatedEvent: e}),
                            options
                            ) === false) &&
                            that._getXHRPromise(false, options.context, aborted)) ||
                        that._chunkedUpload(options) || bm.ajax(options)
                    ).done(function (result, textStatus, jqXHR) {
                        that._onDone(result, textStatus, jqXHR, options);
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        that._onFail(jqXHR, textStatus, errorThrown, options);
                    }).always(function (jqXHRorResult, textStatus, jqXHRorError) {
                        that._onAlways(
                            jqXHRorResult,
                            textStatus,
                            jqXHRorError,
                            options
                        );
                        that._sending -= 1;
                        that._active -= 1;
                        if (options.limitConcurrentUploads &&
                            options.limitConcurrentUploads > that._sending) {
                            // Start the next queued upload,
                            // that has not been aborted:
                            var nextSlot = that._slots.shift();
                            while (nextSlot) {
                                if (that._getDeferredState(nextSlot) === 'pending') {
                                    nextSlot.resolve();
                                    break;
                                }
                                nextSlot = that._slots.shift();
                            }
                        }
                        if (that._active === 0) {
                            // The stop callback is triggered when all uploads have
                            // been completed, equivalent to the global ajaxStop event:
                            that._trigger('stop');
                        }
                    });
                    return jqXHR;
                };
            this._beforeSend(e, options);
            if (this.options.sequentialUploads ||
                (this.options.limitConcurrentUploads &&
                    this.options.limitConcurrentUploads <= this._sending)) {
                if (this.options.limitConcurrentUploads > 1) {
                    slot = $.Deferred();
                    this._slots.push(slot);
                    pipe = slot.pipe(send);
                } else {
                    this._sequence = this._sequence.pipe(send, send);
                    pipe = this._sequence;
                }
                // Return the piped Promise object, enhanced with an abort method,
                // which is delegated to the jqXHR object of the current upload,
                // and jqXHR callbacks mapped to the equivalent Promise methods:
                pipe.abort = function () {
                    aborted = [undefined, 'abort', 'abort'];
                    if (!jqXHR) {
                        if (slot) {
                            slot.rejectWith(options.context, aborted);
                        }
                        return send();
                    }
                    return jqXHR.abort();
                };
                return this._enhancePromise(pipe);
            }
            return send();
        },

        _onAdd: function (e, data) {
            var that = this,
                result = true,
                options = $.extend({}, this.options, data),
                files = data.files,
                filesLength = files.length,
                limit = options.limitMultiFileUploads,
                limitSize = options.limitMultiFileUploadSize,
                overhead = options.limitMultiFileUploadSizeOverhead,
                batchSize = 0,
                paramName = this._getParamName(options),
                paramNameSet,
                paramNameSlice,
                fileSet,
                i,
                j = 0;
            if (limitSize && (!filesLength || files[0].size === undefined)) {
                limitSize = undefined;
            }
            if (!(options.singleFileUploads || limit || limitSize) ||
                !this._isXHRUpload(options)) {
                fileSet = [files];
                paramNameSet = [paramName];
            } else if (!(options.singleFileUploads || limitSize) && limit) {
                fileSet = [];
                paramNameSet = [];
                for (i = 0; i < filesLength; i += limit) {
                    fileSet.push(files.slice(i, i + limit));
                    paramNameSlice = paramName.slice(i, i + limit);
                    if (!paramNameSlice.length) {
                        paramNameSlice = paramName;
                    }
                    paramNameSet.push(paramNameSlice);
                }
            } else if (!options.singleFileUploads && limitSize) {
                fileSet = [];
                paramNameSet = [];
                for (i = 0; i < filesLength; i = i + 1) {
                    batchSize += files[i].size + overhead;
                    if (i + 1 === filesLength ||
                        ((batchSize + files[i + 1].size + overhead) > limitSize) ||
                        (limit && i + 1 - j >= limit)) {
                        fileSet.push(files.slice(j, i + 1));
                        paramNameSlice = paramName.slice(j, i + 1);
                        if (!paramNameSlice.length) {
                            paramNameSlice = paramName;
                        }
                        paramNameSet.push(paramNameSlice);
                        j = i + 1;
                        batchSize = 0;
                    }
                }
            } else {
                paramNameSet = paramName;
            }
            data.originalFiles = files;
            $.each(fileSet || files, function (index, element) {
                var newData = $.extend({}, data);
                newData.files = fileSet ? element : [element];
                newData.paramName = paramNameSet[index];
                that._initResponseObject(newData);
                that._initProgressObject(newData);
                that._addConvenienceMethods(e, newData);
                result = that._trigger(
                    'add',
                    $.Event('add', {delegatedEvent: e}),
                    newData
                );
                return result;
            });
            return result;
        },

        _replaceFileInput: function (input) {
            var inputClone = input.clone(true);
            $('<form></form>').append(inputClone)[0].reset();
            // Detaching allows to insert the fileInput on another form
            // without loosing the file input value:
            input.after(inputClone).detach();
            // Avoid memory leaks with the detached file input:
            $.cleanData(input.unbind('remove'));
            // Replace the original file input element in the fileInput
            // elements set with the clone, which has been copied including
            // event handlers:
            this.options.fileInput = this.options.fileInput.map(function (i, el) {
                if (el === input[0]) {
                    return inputClone[0];
                }
                return el;
            });
            // If the widget has been initialized on the file input itself,
            // override this.element with the file input clone:
            if (input[0] === this.element[0]) {
                this.element = inputClone;
            }
        },

        _handleFileTreeEntry: function (entry, path) {
            var that = this,
                dfd = $.Deferred(),
                errorHandler = function (e) {
                    if (e && !e.entry) {
                        e.entry = entry;
                    }
                    // Since $.when returns immediately if one
                    // Deferred is rejected, we use resolve instead.
                    // This allows valid files and invalid items
                    // to be returned together in one set:
                    dfd.resolve([e]);
                },
                dirReader;
            path = path || '';
            if (entry.isFile) {
                if (entry._file) {
                    // Workaround for Chrome bug #149735
                    entry._file.relativePath = path;
                    dfd.resolve(entry._file);
                } else {
                    entry.file(function (file) {
                        file.relativePath = path;
                        dfd.resolve(file);
                    }, errorHandler);
                }
            } else if (entry.isDirectory) {
                dirReader = entry.createReader();
                dirReader.readEntries(function (entries) {
                    that._handleFileTreeEntries(
                        entries,
                        path + entry.name + '/'
                    ).done(function (files) {
                        dfd.resolve(files);
                    }).fail(errorHandler);
                }, errorHandler);
            } else {
                // Return an empy list for file system items
                // other than files or directories:
                dfd.resolve([]);
            }
            return dfd.promise();
        },

        _handleFileTreeEntries: function (entries, path) {
            var that = this;
            return $.when.apply(
                $,
                $.map(entries, function (entry) {
                    return that._handleFileTreeEntry(entry, path);
                })
            ).pipe(function () {
                return Array.prototype.concat.apply(
                    [],
                    arguments
                );
            });
        },

        _getDroppedFiles: function (dataTransfer) {
            dataTransfer = dataTransfer || {};
            var items = dataTransfer.items;
            if (items && items.length && (items[0].webkitGetAsEntry ||
                items[0].getAsEntry)) {
                return this._handleFileTreeEntries(
                    $.map(items, function (item) {
                        var entry;
                        if (item.webkitGetAsEntry) {
                            entry = item.webkitGetAsEntry();
                            if (entry) {
                                // Workaround for Chrome bug #149735:
                                entry._file = item.getAsFile();
                            }
                            return entry;
                        }
                        return item.getAsEntry();
                    })
                );
            }
            return $.Deferred().resolve(
                $.makeArray(dataTransfer.files)
            ).promise();
        },

        _getSingleFileInputFiles: function (fileInput) {
            fileInput = $(fileInput);
            var entries = fileInput.prop('entries'),
                files,
                value;
            if (entries && entries.length) {
                return this._handleFileTreeEntries(entries);
            }
            files = $.makeArray(fileInput.prop('files'));
            if (!files.length) {
                value = fileInput.prop('value');
                if (!value) {
                    return $.Deferred().resolve([]).promise();
                }
                // If the files property is not available, the browser does not
                // support the File API and we add a pseudo File object with
                // the input value as name with path information removed:
                files = [{name: value.replace(/^.*\\/, '')}];
            } else if (files[0].name === undefined && files[0].fileName) {
                // File normalization for Safari 4 and Firefox 3:
                $.each(files, function (index, file) {
                    file.name = file.fileName;
                    file.size = file.fileSize;
                });
            }
            return $.Deferred().resolve(files).promise();
        },

        _getFileInputFiles: function (fileInput) {
            if (!(fileInput instanceof $) || fileInput.length === 1) {
                return this._getSingleFileInputFiles(fileInput);
            }
            return $.when.apply(
                $,
                $.map(fileInput, this._getSingleFileInputFiles)
            ).pipe(function () {
                return Array.prototype.concat.apply(
                    [],
                    arguments
                );
            });
        },

        _onChange: function (e) {
            var that = this,
                data = {
                    fileInput: $(e.target),
                    form: $(e.target.form)
                };
            this._getFileInputFiles(data.fileInput).always(function (files) {
                data.files = files;
                if (that.options.replaceFileInput) {
                    that._replaceFileInput(data.fileInput);
                }
                if (that._trigger(
                    'change',
                    $.Event('change', {delegatedEvent: e}),
                    data
                ) !== false) {
                    that._onAdd(e, data);
                }
            });
        },

        _onPaste: function (e) {
            var items = e.originalEvent && e.originalEvent.clipboardData &&
                e.originalEvent.clipboardData.items,
                data = {files: []};
            if (items && items.length) {
                $.each(items, function (index, item) {
                    var file = item.getAsFile && item.getAsFile();
                    if (file) {
                        data.files.push(file);
                    }
                });
                if (this._trigger(
                    'paste',
                    $.Event('paste', {delegatedEvent: e}),
                    data
                ) !== false) {
                    this._onAdd(e, data);
                }
            }
        },

        _onDrop: function (e) {
            e.stopPropagation()
            e.preventDefault();
            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
            var that = this,
                dataTransfer = e.dataTransfer,
                data = {};
            if (dataTransfer && dataTransfer.files && dataTransfer.files.length) {
                this._getDroppedFiles(dataTransfer).always(function (files) {
                    data.files = files;
                    if (that._trigger(
                        'drop',
                        $.Event('drop', {delegatedEvent: e}),
                        data
                    ) !== false) {
                        that._onAdd(e, data);
                    }
                });
            }
        },

        _onDragOver: function (e) {
            e.stopPropagation()
            e.preventDefault();
            e.dataTransfer = e.originalEvent && e.originalEvent.dataTransfer;
            var dataTransfer = e.dataTransfer;
            if (dataTransfer && $.inArray('Files', dataTransfer.types) !== -1 &&
                this._trigger(
                    'dragover',
                    $.Event('dragover', {delegatedEvent: e})
                ) !== false) {
                dataTransfer.dropEffect = 'copy';
            }
        },

        _initEventHandlers: function () {
            var _self = this;
            if (this._isXHRUpload(this.options)) {
                this.options.dropZone.on({
                    dragover: this._onDragOver.bind(this),
                    drop: this._onDrop.bind(this),
                    dragenter: function(e) {
                        e.stopPropagation()
                        e.preventDefault();
                        _self._trigger('dragenter', e)
                        return false
                    },
                    dragleave: function(e) {
                        e.stopPropagation()
                        e.preventDefault();
                        _self._trigger('dragleave', e)
                        return false;
                    }
                });
                this.options.pasteZone.on({
                    paste: this._onPaste.bind(this)
                });
            }
            if ($.support.fileInput) {
                this.options.fileInput.on({
                    change: this._onChange.bind(this)
                });
            }
        },

        _destroyEventHandlers: function () {
            this.options.dropZone.off('dragover drop');
            this.options.pasteZone.off('paste');
            this.options.fileInput.off('change');
        },

        _setOption: function (key, value) {
            var reinit = $.inArray(key, this._specialOptions) !== -1;
            if (reinit) {
                this._destroyEventHandlers();
            }
            this._super(key, value);
            if (reinit) {
                this._initSpecialOptions();
                this._initEventHandlers();
            }
        },

        _initSpecialOptions: function () {
            var options = this.options;
            if (options.fileInput === undefined) {
                options.fileInput = this.element.is('input[type="file"]') ?
                    this.element : this.element.find('input[type="file"]');
            } else if (!(options.fileInput instanceof $)) {
                options.fileInput = $(options.fileInput);
            }
            if (!(options.dropZone instanceof $)) {
                options.dropZone = $(options.dropZone);
            }
            if (!(options.pasteZone instanceof $)) {
                options.pasteZone = $(options.pasteZone);
            }
        },

        _getRegExp: function (str) {
            var parts = str.split('/'),
                modifiers = parts.pop();
            parts.shift();
            return new RegExp(parts.join('/'), modifiers);
        },

        _isRegExpOption: function (key, value) {
            return key !== 'url' && $.type(value) === 'string' &&
                /^\/.*\/[igm]{0,3}$/.test(value);
        },

        _initDataAttributes: function () {
            var that = this,
                options = this.options,
                clone = $(this.element[0].cloneNode(false));
            // Initialize options set via HTML5 data-attributes:
            $.each(
                clone.data(),
                function (key, value) {
                    var dataAttributeName = 'data-' +
                        // Convert camelCase to hyphen-ated key:
                        key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
                    if (clone.attr(dataAttributeName)) {
                        if (that._isRegExpOption(key, value)) {
                            value = that._getRegExp(value);
                        }
                        options[key] = value;
                    }
                }
            );
        },

        _create: function () {
            this._initDataAttributes();
            this._initSpecialOptions();
            this._slots = [];
            this._sequence = this._getXHRPromise(true);
            this._sending = this._active = 0;
            this._initProgressObject(this);
            this._initEventHandlers();
        },
        _trigger: function( type, event, data ) {
            var prop, orig,
                callback = this.options[ type ];

            data = data || {};
            event = $.Event( event );
            event.type = ( type === this.widgetEventPrefix ?
                type :
                this.widgetEventPrefix + type ).toLowerCase();
            // the original event may come from any element
            // so we need to reset the target on the new event
            event.target = this.element[ 0 ];

            // copy original event properties over to the new event
            orig = event.originalEvent;
            if ( orig ) {
                for ( prop in orig ) {
                    if ( !( prop in event ) ) {
                        event[ prop ] = orig[ prop ];
                    }
                }
            }

            this.element.trigger( event, data );
            return !( $.isFunction( callback ) &&
                callback.apply( this.element[0], [ event ].concat( data ) ) === false ||
                event.isDefaultPrevented() );
        },

        // This method is exposed to the widget API and allows to query
        // the number of active uploads:
        active: function () {
            return this._active;
        },

        // This method is exposed to the widget API and allows to query
        // the widget upload progress.
        // It returns an object with loaded, total and bitrate properties
        // for the running uploads:
        progress: function () {
            return this._progress;
        },

        // This method is exposed to the widget API and allows adding files
        // using the fileupload API. The data parameter accepts an object which
        // must have a files property and can contain additional options:
        // .fileupload('add', {files: filesList});
        add: function (data) {
            var that = this;
            if (!data || this.options.disabled) {
                return;
            }
            if (data.fileInput && !data.files) {
                this._getFileInputFiles(data.fileInput).always(function (files) {
                    data.files = files;
                    that._onAdd(null, data);
                });
            } else {
                data.files = $.makeArray(data.files);
                this._onAdd(null, data);
            }
        },

        // This method is exposed to the widget API and allows sending files
        // using the fileupload API. The data parameter accepts an object which
        // must have a files or fileInput property and can contain additional options:
        // .fileupload('send', {files: filesList});
        // The method returns a Promise object for the file upload call.
        send: function (data) {
            if (data && !this.options.disabled) {
                if (data.fileInput && !data.files) {
                    var that = this,
                        dfd = $.Deferred(),
                        promise = dfd.promise(),
                        jqXHR,
                        aborted;
                    promise.abort = function () {
                        aborted = true;
                        if (jqXHR) {
                            return jqXHR.abort();
                        }
                        dfd.reject(null, 'abort', 'abort');
                        return promise;
                    };
                    this._getFileInputFiles(data.fileInput).always(
                        function (files) {
                            if (aborted) {
                                return;
                            }
                            if (!files.length) {
                                dfd.reject();
                                return;
                            }
                            data.files = files;
                            jqXHR = that._onSend(null, data).then(
                                function (result, textStatus, jqXHR) {
                                    dfd.resolve(result, textStatus, jqXHR);
                                },
                                function (jqXHR, textStatus, errorThrown) {
                                    dfd.reject(jqXHR, textStatus, errorThrown);
                                }
                            );
                        }
                    );
                    return this._enhancePromise(promise);
                }
                data.files = $.makeArray(data.files);
                if (data.files.length) {
                    return this._onSend(null, data);
                }
            }
            return this._getXHRPromise(false, data && data.context);
        }

    };

}));
; 
'use strict';

// ============================================================================
// PREVENT DUPLICATE LOADING
// ============================================================================
if (typeof window.CloudUploadError === 'undefined') {

// ============================================================================
// CUSTOM EXCEPTIONS
// ============================================================================

/**
 * Custom error class for cloud upload operations
 */
window.CloudUploadError = class CloudUploadError extends Error {
    /**
     * @param {string} code - Error code (e.g., 'VALIDATION_FAILED')
     * @param {string} message - Human-readable error message
     * @param {Object} details - Additional error context
     */
    constructor(code, message, details = {}) {
        super(message);
        this.name = 'CloudUploadError';
        this.code = code;
        this.details = details;
        this.timestamp = new Date().toISOString();
    }

    /**
     * Get full error details for logging
     */
    toJSON() {
        return {
            name: this.name,
            code: this.code,
            message: this.message,
            details: this.details,
            timestamp: this.timestamp,
            stack: this.stack
        };
    }
}

// ============================================================================
// CONFIGURATION
// ============================================================================

/**
 * Global configuration for cloud upload operations
 */
window.CloudUploadConfig = {
    // Image processing
    defaultMaxSize: 1920,
    defaultQuality: 0.85,
    webpSupport: null, // lazy loaded

    // Upload behavior
    retryAttempts: 3,
    retryBaseDelay: 1000, // ms
    timeout: 60000, // 60 seconds
    chunkSize: 5 * 1024 * 1024, // 5MB

    // Validation
    maxFileSizeMB: 50,
    allowedImageTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'image/avif'],
    allowedPresignedHosts: [], // Whitelist of allowed presigned URL hosts (empty = allow all)

    // Logging
    logLevel: 'info', // 'debug', 'info', 'warn', 'error', 'none'

    /**
     * Update configuration at runtime
     * @param {Object} newConfig - Configuration updates
     */
    updateConfig: function(newConfig) {
        Object.assign(this, newConfig);
        CloudLogger.setLevel(this.logLevel);
    },

    /**
     * Reset to default configuration
     */
    resetConfig: function() {
        Object.assign(this, {
            defaultMaxSize: 1920,
            defaultQuality: 0.85,
            retryAttempts: 3,
            retryBaseDelay: 1000,
            timeout: 60000,
            maxFileSizeMB: 50,
            allowedPresignedHosts: [],
            logLevel: 'info'
        });
    }
};

// ============================================================================
// LOGGER
// ============================================================================

/**
 * Configurable logger for cloud upload operations
 */
window.CloudLogger = {
    level: 'info',
    levels: { debug: 0, info: 1, warn: 2, error: 3, none: 4 },

    setLevel: function(level) {
        this.level = level;
    },

    shouldLog: function(level) {
        return this.levels[level] >= this.levels[this.level];
    },

    debug: function(...args) {
        if (this.shouldLog('debug')) {
            console.debug('[CloudUpload]', ...args);
        }
    },

    info: function(...args) {
        if (this.shouldLog('info')) {
            console.log('[CloudUpload]', ...args);
        }
    },

    warn: function(...args) {
        if (this.shouldLog('warn')) {
            console.warn('[CloudUpload]', ...args);
        }
    },

    error: function(...args) {
        if (this.shouldLog('error')) {
            console.error('[CloudUpload]', ...args);
        }
    }
};

// ============================================================================
// VALIDATION
// ============================================================================

/**
 * Validate upload parameters
 * @param {File|Blob} file - File to validate
 * @param {string} bucketName - S3 bucket name
 * @param {string} filepath - Destination path in S3
 * @param {string} presignedHost - Presigned URL endpoint
 * @returns {string[]} Array of validation errors (empty if valid)
 */
function validateUploadParams(file, bucketName, filepath, presignedHost) {
    const errors = [];

    // File validation
    if (!file) {
        errors.push('File is required');
    } else {
        if (file.size === 0) {
            errors.push('File is empty');
        }

        const maxBytes = CloudUploadConfig.maxFileSizeMB * 1024 * 1024;
        if (file.size > maxBytes) {
            errors.push(
                `File size ${formatFileSize(file.size)} exceeds maximum of ${formatFileSize(maxBytes)}`
            );
        }
    }

    // Bucket name validation (AWS naming rules)
    if (!bucketName) {
        errors.push('Bucket name is required');
    } else if (!/^[a-z0-9][a-z0-9\-]{1,61}[a-z0-9]$/.test(bucketName)) {
        errors.push('Invalid bucket name format (must be lowercase, 3-63 chars, alphanumeric with hyphens)');
    }

    // Filepath validation (prevent directory traversal)
    if (!filepath) {
        errors.push('Filepath is required');
    } else {
        if (filepath.includes('..') || filepath.startsWith('/')) {
            errors.push('Invalid filepath: contains directory traversal or absolute path');
        }
        if (filepath.length > 1024) {
            errors.push('Filepath exceeds maximum length of 1024 characters');
        }
    }

    // Presigned host validation
    if (!presignedHost) {
        errors.push('Presigned host URL is required');
    } else {
        try {
            var parsedUrl = new URL(presignedHost);

            // Enforce HTTPS in production
            if (parsedUrl.protocol !== 'https:' && parsedUrl.hostname !== 'localhost' && parsedUrl.hostname !== '127.0.0.1') {
                errors.push('Presigned host must use HTTPS');
            }

            // Whitelist check if configured
            var allowedHosts = CloudUploadConfig.allowedPresignedHosts;
            if (allowedHosts && allowedHosts.length > 0) {
                var hostAllowed = allowedHosts.some(function(allowed) {
                    return parsedUrl.hostname === allowed || parsedUrl.hostname.endsWith('.' + allowed);
                });
                if (!hostAllowed) {
                    errors.push('Presigned host is not in the allowed hosts list');
                }
            }
        } catch {
            errors.push('Invalid presigned host URL format');
        }
    }

    return errors;
}

/**
 * Validate content type
 * @param {File} file - File to validate
 * @param {string[]} allowedTypes - Array of allowed MIME types (supports wildcards like 'image/*')
 * @returns {string} Validated content type
 * @throws {CloudUploadError} If content type is invalid or not allowed
 */
function validateContentType(file, allowedTypes = null) {
    if (!file.type) {
        throw new CloudUploadError(
            'INVALID_FILE_TYPE',
            'File type cannot be determined'
        );
    }

    if (allowedTypes && allowedTypes.length > 0) {
        const isAllowed = allowedTypes.some(type => {
            if (type.endsWith('/*')) {
                const prefix = type.slice(0, -2);
                return file.type.startsWith(prefix);
            }
            return file.type === type;
        });

        if (!isAllowed) {
            throw new CloudUploadError(
                'FILE_TYPE_NOT_ALLOWED',
                `File type '${file.type}' is not allowed`,
                { allowedTypes, actualType: file.type }
            );
        }
    }

    return file.type;
}

/**
 * Sanitize filepath to prevent security issues
 * @param {string} filepath - Path to sanitize
 * @returns {string} Sanitized filepath
 */
function sanitizeFilepath(filepath) {
    return filepath
        .replace(/\\/g, '/')           // Backslash to forward slash
        .replace(/\/+/g, '/')          // Remove multiple slashes
        .replace(/^\/+/, '')           // Remove leading slashes
        .replace(/\.\.+/g, '.')        // Remove directory traversal attempts
        .trim();
}

// ============================================================================
// CORE UPLOAD FUNCTIONS
// ============================================================================

/**
 * Upload file to S3 with presigned URL
 *
 * @param {File|Blob} file - File to upload
 * @param {string} bucketName - S3 bucket name
 * @param {string} filepath - Destination path in S3
 * @param {string} presignedHost - Presigned URL generation endpoint
 * @param {Object} options - Upload options
 * @param {Function} [options.onProgress] - Progress callback (progress) => void
 * @param {string} [options.contentType] - Override content type
 * @param {boolean} [options.retry=true] - Enable retry logic
 * @param {number} [options.retryAttempts] - Number of retry attempts
 * @param {AbortSignal} [options.abortSignal] - AbortController signal for cancellation
 * @returns {Promise<string>} S3 key on success
 * @throws {CloudUploadError} On validation or upload failure
 */
async function uploadFileToS3(file, bucketName, filepath, presignedHost, options = {}) {
    // Extract options with defaults
    const {
        onProgress = null,
        contentType = file.type || 'application/octet-stream',
        retry = true,
        retryAttempts = CloudUploadConfig.retryAttempts,
        abortSignal = null
    } = options;

    // Check if already aborted
    if (abortSignal?.aborted) {
        throw new CloudUploadError('UPLOAD_ABORTED', 'Upload was cancelled before starting');
    }

    // Sanitize filepath
    filepath = sanitizeFilepath(filepath);

    // Validate parameters
    const validationErrors = validateUploadParams(file, bucketName, filepath, presignedHost);
    if (validationErrors.length > 0) {
        throw new CloudUploadError(
            'VALIDATION_FAILED',
            'Upload validation failed',
            { errors: validationErrors }
        );
    }

    CloudLogger.debug('Starting upload:', { bucketName, filepath, size: file.size, type: contentType });

    // Retry logic wrapper
    if (retry && retryAttempts > 1) {
        return uploadWithRetry(file, bucketName, filepath, presignedHost, {
            ...options,
            retry: false
        }, retryAttempts);
    }

    try {
        // Step 1: Request presigned URL
        const presignedUrl = presignedHost.endsWith('/')
            ? `${presignedHost}generate-presigned`
            : `${presignedHost}/generate-presigned`;

        CloudLogger.debug('Requesting presigned URL:', presignedUrl);

        const presignResponse = await fetchWithTimeout(
            presignedUrl,
            {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    bucket_name: bucketName,
                    filepath: filepath,
                    content_type: contentType
                }),
                signal: abortSignal
            },
            CloudUploadConfig.timeout
        );

        if (!presignResponse.ok) {
            throw new CloudUploadError(
                'PRESIGN_FAILED',
                `Presigned URL request failed with status ${presignResponse.status}`,
                { status: presignResponse.status }
            );
        }

        const presignData = await presignResponse.json();

        if (presignData.error) {
            throw new CloudUploadError(
                'PRESIGN_ERROR',
                `Presigned URL service error: ${presignData.error}`,
                { serviceError: presignData.error }
            );
        }

        if (!presignData.url || !presignData.fields) {
            throw new CloudUploadError(
                'INVALID_PRESIGN_RESPONSE',
                'Invalid presigned response: missing url or fields',
                { response: presignData }
            );
        }

        CloudLogger.debug('Presigned URL obtained, uploading to S3...');

        // Step 2: Upload to S3
        const formData = new FormData();

        // Add presigned fields
        Object.entries(presignData.fields).forEach(([key, value]) => {
            formData.append(key, value);
        });

        // Add file (MUST be last according to AWS S3 requirements)
        formData.append('file', file);

        // Upload with progress tracking
        const uploadResponse = await uploadWithProgress(
            presignData.url,
            formData,
            onProgress,
            abortSignal
        );

        if (!uploadResponse.ok) {
            const errorText = await uploadResponse.text().catch(() => 'Unknown error');
            throw new CloudUploadError(
                'UPLOAD_FAILED',
                `Upload to S3 failed with status ${uploadResponse.status}`,
                { status: uploadResponse.status, error: errorText }
            );
        }

        const s3Key = presignData.key;
        CloudLogger.info('File uploaded successfully to S3:', s3Key);

        // ✅ Return s3Key, presignData and the ACTUAL uploaded byte size (post-processing)
        // for backend usage tracking. `file` here is the exact payload sent to S3, so
        // file.size is the stored object size, not the pre-resize original.
        return {
            s3Key: s3Key,
            size: file.size,
            presignedData: {
                url: presignData.url,
                fields: presignData.fields,
                key: presignData.key
            }
        };

    } catch (error) {
        if (error.name === 'AbortError') {
            throw new CloudUploadError('UPLOAD_ABORTED', 'Upload was cancelled by user');
        }

        if (error instanceof CloudUploadError) {
            throw error;
        }

        // Wrap unexpected errors
        throw new CloudUploadError(
            'UPLOAD_FAILED',
            `Unexpected upload error: ${error.message}`,
            { originalError: error.message, stack: error.stack }
        );
    }
}

/**
 * Upload with retry logic and exponential backoff
 * @private
 */
async function uploadWithRetry(file, bucketName, filepath, presignedHost, options, attemptsLeft) {
    try {
        return await uploadFileToS3(file, bucketName, filepath, presignedHost, {
            ...options,
            retry: false
        });
    } catch (error) {
        // Don't retry on validation errors or user cancellation
        if (error.code === 'VALIDATION_FAILED' || error.code === 'UPLOAD_ABORTED') {
            throw error;
        }

        if (attemptsLeft <= 1) {
            CloudLogger.error('Upload failed after all retry attempts');
            throw error;
        }

        // Exponential backoff: 1s, 2s, 4s, 8s...
        const attempt = CloudUploadConfig.retryAttempts - attemptsLeft + 1;
        const delay = CloudUploadConfig.retryBaseDelay * Math.pow(2, attempt - 1);

        CloudLogger.warn(`Upload failed, retrying in ${delay}ms... (${attemptsLeft - 1} attempts left)`);
        CloudLogger.debug('Error details:', error);

        await sleep(delay);
        return uploadWithRetry(file, bucketName, filepath, presignedHost, options, attemptsLeft - 1);
    }
}

/**
 * Upload with progress tracking using XMLHttpRequest
 * @private
 */
function uploadWithProgress(url, formData, onProgress, abortSignal) {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();

        // Progress tracking
        if (onProgress && typeof onProgress === 'function') {
            xhr.upload.addEventListener('progress', (e) => {
                if (e.lengthComputable) {
                    const percentComplete = Math.round((e.loaded / e.total) * 100);
                    onProgress({
                        loaded: e.loaded,
                        total: e.total,
                        percentage: percentComplete
                    });
                }
            });
        }

        // Abort signal support with cleanup
        var onAbort = null;
        if (abortSignal) {
            onAbort = () => { xhr.abort(); };
            abortSignal.addEventListener('abort', onAbort, { once: true });
        }

        function cleanup() {
            if (abortSignal && onAbort) {
                abortSignal.removeEventListener('abort', onAbort);
            }
        }

        xhr.addEventListener('load', () => {
            cleanup();
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve({
                    ok: true,
                    status: xhr.status,
                    text: () => Promise.resolve(xhr.responseText)
                });
            } else {
                resolve({
                    ok: false,
                    status: xhr.status,
                    text: () => Promise.resolve(xhr.responseText)
                });
            }
        });

        xhr.addEventListener('error', () => {
            cleanup();
            reject(new Error('Network error during upload'));
        });

        xhr.addEventListener('timeout', () => {
            cleanup();
            reject(new Error('Upload timeout'));
        });

        xhr.addEventListener('abort', () => {
            cleanup();
            reject(new Error('Upload aborted'));
        });

        xhr.open('POST', url);
        xhr.timeout = CloudUploadConfig.timeout;
        xhr.send(formData);
    });
}

/**
 * Fetch with timeout support
 * @private
 */
function fetchWithTimeout(url, options, timeout) {
    const controller = new AbortController();
    const existingSignal = options.signal;

    // If caller already provided an AbortSignal, forward its abort
    if (existingSignal) {
        if (existingSignal.aborted) {
            controller.abort();
        } else {
            existingSignal.addEventListener('abort', () => controller.abort(), { once: true });
        }
    }

    const timeoutId = setTimeout(() => controller.abort(), timeout);

    return fetch(url, { ...options, signal: controller.signal })
        .then(function(response) {
            clearTimeout(timeoutId);
            return response;
        })
        .catch(function(error) {
            clearTimeout(timeoutId);
            if (controller.signal.aborted && !(existingSignal && existingSignal.aborted)) {
                throw new Error($.i18n.prop("request.timeout"));
            }
            throw error;
        });
}

// ============================================================================
// IMAGE PROCESSING
// ============================================================================

/**
 * Process and upload image with automatic resizing and WebP conversion
 *
 * @param {File} imageFile - Image file to process
 * @param {string} bucketName - S3 bucket name
 * @param {string} filepath - Destination path
 * @param {string} presignedHost - Presigned URL endpoint
 * @param {Object} options - Processing and upload options
 * @param {number} [options.maxWidth] - Maximum width in pixels
 * @param {number} [options.maxHeight] - Maximum height in pixels
 * @param {number} [options.quality] - Compression quality (0-1)is
 * @param {boolean} [options.convertToWebP=true] - Convert to WebP format
 * @param {Function} [options.onProgress] - Progress callback
 * @param {AbortSignal} [options.abortSignal] - Cancellation signal
 * @returns {Promise<string>} S3 key on success
 * @throws {CloudUploadError} On processing or upload failure
 */
async function uploadImageToS3(imageFile, bucketName, filepath, presignedHost, options = {}) {
    const {
        maxWidth = CloudUploadConfig.defaultMaxSize,
        maxHeight = CloudUploadConfig.defaultMaxSize,
        quality = CloudUploadConfig.defaultQuality,
        convertToWebP = true,
        onProgress = null,
        abortSignal = null
    } = options;

    // Validate image type
    validateContentType(imageFile, CloudUploadConfig.allowedImageTypes);

    try {
        CloudLogger.debug('Processing image:', {
            name: imageFile.name,
            size: imageFile.size,
            type: imageFile.type
        });

        // AVIF and GIF may be animated; canvas conversion would flatten them
        // (drawImage captures only the first frame). Upload the original untouched.
        if (imageFile.type === 'image/avif' || imageFile.type === 'image/gif') {
            return await uploadFileToS3(imageFile, bucketName, filepath, presignedHost, {
                onProgress,
                contentType: imageFile.type,
                abortSignal
            });
        }

        // Process image
        const processedFile = await processImage(imageFile, {
            maxWidth,
            maxHeight,
            quality,
            convertToWebP
        });

        CloudLogger.info('Image processed:', {
            originalSize: imageFile.size,
            processedSize: processedFile.size,
            reduction: `${Math.round((1 - processedFile.size / imageFile.size) * 100)}%`,
            originalType: imageFile.type,
            processedType: processedFile.type
        });

        // Update filepath extension to match processed file type
        // PNG → WebP: photo.png → photo.webp
        const processedExtension = processedFile.type === 'image/webp' ? 'webp' : 'jpg';
        const updatedFilepath = filepath.replace(/\.[^.]+$/, `.${processedExtension}`);

        CloudLogger.debug('Filepath updated:', {
            original: filepath,
            updated: updatedFilepath,
            extension: processedExtension
        });

        // Upload processed image with correct content type and filepath
        return await uploadFileToS3(
            processedFile,
            bucketName,
            updatedFilepath,  // ✅ Updated filepath with correct extension
            presignedHost,
            {
                onProgress,
                contentType: processedFile.type,  // ✅ Actual processed file type (image/webp or image/jpeg)
                abortSignal
            }
        );

    } catch (error) {
        if (error instanceof CloudUploadError) {
            throw error;
        }

        throw new CloudUploadError(
            'IMAGE_PROCESSING_FAILED',
            `Image processing failed: ${error.message}`,
            { originalError: error.message }
        );
    }
}

/**
 * Process image (resize and optionally convert to WebP)
 * @private
 */
async function processImage(file, options = {}) {
    const {
        maxWidth = CloudUploadConfig.defaultMaxSize,
        maxHeight = CloudUploadConfig.defaultMaxSize,
        quality = CloudUploadConfig.defaultQuality,
        convertToWebP = true
    } = options;

    // Load image
    const img = await loadImage(file);

    // Calculate dimensions maintaining aspect ratio
    let width = img.width;
    let height = img.height;

    if (width > maxWidth || height > maxHeight) {
        const ratio = Math.min(maxWidth / width, maxHeight / height);
        width = Math.round(width * ratio);
        height = Math.round(height * ratio);
    }

    // Create canvas and draw resized image
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;

    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, width, height);

    // Convert to blob
    const webpSupported = convertToWebP && await supportsWebP();
    const format = webpSupported ? 'image/webp' : 'image/jpeg';
    const blob = await new Promise((resolve) => {
        canvas.toBlob(resolve, format, quality);
    });

    // Create file with appropriate extension
    const extension = format === 'image/webp' ? 'webp' : 'jpg';
    const baseName = file.name.replace(/\.[^/.]+$/, '');

    return new File([blob], `${baseName}.${extension}`, { type: format });
}

/**
 * Load image from file
 * @private
 */
function loadImage(file) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            URL.revokeObjectURL(img.src);
            resolve(img);
        };
        img.onerror = () => {
            URL.revokeObjectURL(img.src);
            reject(new Error('Failed to load image'));
        };
        img.src = URL.createObjectURL(file);
    });
}

/**
 * Check WebP support (cached result)
 * @private
 */
async function supportsWebP() {
    if (CloudUploadConfig.webpSupport !== null) {
        return CloudUploadConfig.webpSupport;
    }

    try {
        const canvas = document.createElement('canvas');
        canvas.width = 1;
        canvas.height = 1;
        CloudUploadConfig.webpSupport = canvas.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    } catch (e) {
        CloudUploadConfig.webpSupport = false;
    }

    return CloudUploadConfig.webpSupport;
}

// ============================================================================
// BATCH UPLOAD
// ============================================================================

/**
 * Upload multiple files in parallel with concurrency control
 *
 * @param {File[]} files - Array of files to upload
 * @param {string} bucketName - S3 bucket name
 * @param {string} basePath - Base path in S3
 * @param {string} presignedHost - Presigned URL endpoint
 * @param {Object} options - Upload options
 * @param {boolean} [options.processImages=true] - Auto-process image files
 * @param {Function} [options.onProgress] - Progress callback per file
 * @param {number} [options.concurrency=3] - Max concurrent uploads
 * @param {string[]} [options.allowedTypes] - Allowed MIME types
 * @param {AbortSignal} [options.abortSignal] - Cancellation signal
 * @returns {Promise<Object[]>} Array of upload results
 */
async function uploadMultipleFiles(files, bucketName, basePath, presignedHost, options = {}) {
    const {
        processImages = true,
        onProgress = null,
        concurrency = 3,
        allowedTypes = null,
        abortSignal = null,
        staticFileName = null
    } = options;

    if (abortSignal?.aborted) {
        throw new CloudUploadError('UPLOAD_ABORTED', 'Batch upload was cancelled before starting');
    }

    CloudLogger.info(`Starting batch upload of ${files.length} files with concurrency ${concurrency}`);

    // Filter files by allowed types if specified
    const validFiles = Array.from(files).filter(file => {
        if (!allowedTypes) return true;

        try {
            validateContentType(file, allowedTypes);
            return true;
        } catch {
            CloudLogger.warn(`File ${file.name} filtered due to type restrictions`);
            return false;
        }
    });

    if (validFiles.length < files.length) {
        CloudLogger.warn(`${files.length - validFiles.length} files were filtered out`);
    }

    const results = [];
    const chunks = chunkArray(validFiles, concurrency);

    for (const chunk of chunks) {
        if (abortSignal?.aborted) {
            throw new CloudUploadError('UPLOAD_ABORTED', 'Batch upload was cancelled');
        }

        const chunkResults = await Promise.all(
            chunk.map(async (file, index) => {
                const globalIndex = results.length + index;
                const uniqueFilename = staticFileName || setUniqueName(file.name);
                const filepath = `${basePath}/${uniqueFilename}`;

                try {
                    const uploadFn = processImages && file.type.startsWith('image/')
                        ? uploadImageToS3
                        : uploadFileToS3;

                    const s3Key = await uploadFn(
                        file,
                        bucketName,
                        filepath,
                        presignedHost,
                        {
                            onProgress: onProgress ? (progress) => {
                                onProgress({
                                    fileIndex: globalIndex,
                                    fileName: file.name,
                                    ...progress
                                });
                            } : null,
                            abortSignal
                        }
                    );

                    const actualS3Key = s3Key.s3Key || s3Key;
                    const actualFilename = actualS3Key.split('/').pop();
                    const actualExtension = getFileExtension(actualFilename);

                    let updatedUniqueFilename = uniqueFilename;
                    if (processImages && actualExtension) {
                        updatedUniqueFilename = uniqueFilename.replace(/\.[^.]+$/, `.${actualExtension}`);
                    }

                    return {
                        uniqueFilename: updatedUniqueFilename,
                        fileName: file.name,
                        s3Key: actualS3Key,
                        success: true,
                        originalSize: file.size,
                        // Actual stored byte size (post resize/webp). Falls back to the
                        // original size for non-image paths that don't reprocess.
                        size: (s3Key && s3Key.size != null) ? s3Key.size : file.size,
                        fileType: file.type,
                        actualExtension: actualExtension,
                        presignedData: s3Key.presignedData || null
                    };

                } catch (error) {
                    CloudLogger.error(`Failed to upload ${file.name}:`, error);

                    return {
                        uniqueFilename: uniqueFilename,
                        fileName: file.name,
                        s3Key: null,
                        success: false,
                        error: error.message,
                        errorCode: error.code
                    };
                }
            })
        );

        results.push(...chunkResults);
    }

    const successCount = results.filter(r => r.success).length;
    CloudLogger.info(`Batch upload complete: ${successCount}/${files.length} files uploaded successfully`);

    return results;
}

/**
 * Create image variants (thumbnail, small, medium, large, original)
 *
 * @param {File} imageFile - Original image file
 * @param {string} bucketName - S3 bucket name
 * @param {string} basePath - Base path in S3
 * @param {string} presignedHost - Presigned URL endpoint
 * @param {Object} options - Variant options
 * @param {Array} [options.variants] - Custom variant configurations
 * @param {Function} [options.onProgress] - Progress callback per variant
 * @param {AbortSignal} [options.abortSignal] - Cancellation signal
 * @returns {Promise<Object>} Object with all variant results
 */
async function uploadImageWithVariants(imageFile, bucketName, basePath, presignedHost, options = {}) {
    const {
        variants = [
            { name: 'thumbnail', size: 200, quality: 0.80 },
            { name: 'small', size: 480, quality: 0.85 },
            { name: 'medium', size: 720, quality: 0.85 },
            { name: 'large', size: 1024, quality: 0.90 },
            { name: 'original', size: 1920, quality: 0.85 }
        ],
        onProgress = null,
        abortSignal = null
    } = options;

    // Validate image type
    validateContentType(imageFile, CloudUploadConfig.allowedImageTypes);

    CloudLogger.info(`Creating ${variants.length} image variants for ${imageFile.name}`);

    if (abortSignal?.aborted) {
        throw new CloudUploadError('UPLOAD_ABORTED', 'Image variant upload was cancelled');
    }

    const results = {};
    const totalVariants = variants.length;

    // Process and upload all variants in parallel
    const variantPromises = variants.map(function(variant, i) {
        return (async () => {
            try {
                const processedFile = await processImage(imageFile, {
                    maxWidth: variant.size,
                    maxHeight: variant.size,
                    quality: variant.quality,
                    convertToWebP: true
                });

                // Generate filename with correct extension based on processed file type
                const extension = processedFile.type === 'image/webp' ? 'webp' : 'jpg';
                const uniqueName = `${crypto.randomUUID()}.${extension}`;
                const filepath = `${basePath}/${variant.name}/${uniqueName}`;

                const s3Key = await uploadFileToS3(
                    processedFile,
                    bucketName,
                    filepath,
                    presignedHost,
                    {
                        contentType: processedFile.type,
                        onProgress: onProgress ? (progress) => {
                            onProgress({
                                variant: variant.name,
                                variantIndex: i,
                                totalVariants: totalVariants,
                                ...progress
                            });
                        } : null,
                        abortSignal
                    }
                );

                results[variant.name] = {
                    s3Key: s3Key,
                    size: processedFile.size,
                    success: true
                };

            } catch (error) {
                CloudLogger.error(`Failed to create variant ${variant.name}:`, error);

                results[variant.name] = {
                    s3Key: null,
                    success: false,
                    error: error.message,
                    errorCode: error.code
                };
            }
        })();
    });

    await Promise.all(variantPromises);

    const successCount = Object.values(results).filter(r => r.success).length;
    CloudLogger.info(`Image variants complete: ${successCount}/${totalVariants} created successfully`);

    return results;
}

// ============================================================================
// UTILITY FUNCTIONS
// ============================================================================

/**
 * Make filename safe for S3
 * Replaces special characters with underscores
 * @param {string} fileName - Original filename
 * @returns {string} Sanitized filename
 */
function makeSafe(fileName) {
    return fileName
        .replace(/(\.){2,}/g, '_')           // Multiple dots → underscore
        .replace(/[^A-Za-z0-9.\-_ ]/g, '_')  // Special chars → underscore
        .replace(/^\./, '_')                 // Leading dot → underscore
        .replace(/\s+/g, '_')                // Whitespace → underscore
        .replace(/_+/g, '_')                 // Collapse multiple underscores
        .replace(/^_+|_+$/g, '');            // Trim leading/trailing underscores
}

/**
 * Truncate filename to maximum length while preserving extension
 * @param {string} fileName - Filename to truncate
 * @param {number} maxLength - Maximum total length (default: 70)
 * @returns {string} Truncated filename
 */
function truncateFilename(fileName, maxLength = 70) {
    if (fileName.length <= maxLength) {
        return fileName;
    }

    const extension = getFileExtension(fileName);
    const extensionLength = extension ? extension.length + 1 : 0; // +1 for dot
    const maxNameLength = maxLength - extensionLength;

    if (maxNameLength <= 0) {
        return fileName.substring(0, maxLength);
    }

    const baseName = fileName.substring(0, fileName.length - extensionLength);
    const truncatedBase = baseName.substring(0, maxNameLength);

    return extension ? `${truncatedBase}.${extension}` : truncatedBase;
}

/**
 * Generate UUID-prefixed filename with original name
 * Format: {uuid}-{sanitized-filename}.{ext}
 * Max length: 70 characters (matches DB column length)
 *
 * @param {string} originalFileName - Original filename
 * @returns {string} UUID-prefixed safe filename
 *
 * @example
 * generateUUIDFileName("My Photo (2024)!.jpg")
 * // Returns: "550e8400-e29b-41d4-a716-446655440000-My_Photo_2024.jpg"
 */
function generateUUIDFileName(originalFileName) {
    const extension = getFileExtension(originalFileName);
    const uuid = crypto.randomUUID();

    // Get base name without extension
    const baseName = originalFileName.substring(0, originalFileName.length - (extension ? extension.length + 1 : 0));

    // Sanitize base name
    const safeName = makeSafe(baseName);

    // Construct: uuid-filename.ext
    const fullName = extension ? `${uuid}-${safeName}.${extension}` : `${uuid}-${safeName}`;

    // Truncate to 70 characters max (matches DB column length)
    return truncateFilename(fullName, 70);
}

/**
 * Get file extension from filename
 * @param {string} fileName - Filename
 * @returns {string} File extension (lowercase, no dot)
 */
function getFileExtension(fileName) {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
}

/**
 * Set unique name for file (UUID prefix + sanitized name + max 70 chars)
 *
 * @param {string} fileName - Original filename
 * @returns {string} Unique, safe filename with UUID prefix
 *
 * @example
 * setUniqueName("My Product Image (Special!).jpg")
 * // Returns: "abc-123-def-456-My_Product_Image_Special.jpg" (truncated to 70 chars)
 */
function setUniqueName(fileName) {
    return generateUUIDFileName(fileName);
}

/**
 * Convert base64 string to Blob
 * @param {string} base64 - Base64-encoded data
 * @param {string} mimeType - MIME type
 * @returns {Blob} Blob object
 */
function base64ToBlob(base64, mimeType) {
    // Handle both data URI format ("data:...;base64,XXX") and raw base64 strings
    const base64Data = base64.includes(',') ? base64.split(',')[1] : base64;
    const byteCharacters = atob(base64Data);
    const byteArray = new Uint8Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteArray[i] = byteCharacters.charCodeAt(i);
    }

    return new Blob([byteArray], { type: mimeType });
}

/**
 * Convert base64 string to File
 * @param {string} base64 - Base64-encoded data
 * @param {string} fileName - Filename
 * @param {string} mimeType - MIME type
 * @returns {File} File object
 */
function base64ToFile(base64, fileName, mimeType) {
    const blob = base64ToBlob(base64, mimeType);
    return new File([blob], fileName, { type: mimeType });
}

/**
 * Format file size in human-readable format
 * @param {number} bytes - File size in bytes
 * @returns {string} Formatted file size (e.g., "1.5 MB")
 */
function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}

/**
 * Sleep utility for delays
 * @param {number} ms - Milliseconds to sleep
 * @returns {Promise<void>}
 */
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

/**
 * Split array into chunks
 * @param {Array} array - Array to chunk
 * @param {number} size - Chunk size
 * @returns {Array[]} Array of chunks
 */
function chunkArray(array, size) {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
    }
    return chunks;
}

/**
 * Check if file is an image
 * @param {File} file - File to check
 * @returns {boolean} True if image
 */
function isImageFile(file) {
    return file.type.startsWith('image/');
}

/**
 * Validate file size
 * @param {File} file - File to check
 * @param {number} maxSizeMB - Maximum size in MB
 * @returns {boolean} True if size is valid
 */
function isFileSizeValid(file, maxSizeMB = CloudUploadConfig.maxFileSizeMB) {
    const maxBytes = maxSizeMB * 1024 * 1024;
    return file.size <= maxBytes;
}

// ============================================================================
// EXPORTS
// ============================================================================

// For ES6 modules
if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
        // Core functions
        uploadFileToS3,
        uploadImageToS3,
        uploadMultipleFiles,
        uploadImageWithVariants,

        // Image processing
        processImage,

        // Utilities
        makeSafe,
        setUniqueName,
        generateUUIDFileName,
        base64ToBlob,
        base64ToFile,
        formatFileSize,
        isImageFile,
        isFileSizeValid,

        // Configuration
        CloudUploadConfig,
        CloudLogger,

        // Error class
        CloudUploadError
    };
}

// For global scope (browser)
if (typeof window !== 'undefined') {
    window.CloudUpload = {
        uploadFileToS3,
        uploadImageToS3,
        uploadMultipleFiles,
        uploadImageWithVariants,
        processImage,
        makeSafe,
        setUniqueName,
        generateUUIDFileName,
        base64ToBlob,
        base64ToFile,
        formatFileSize,
        isImageFile,
        isFileSizeValid,
        CloudUploadConfig,
        CloudLogger,
        CloudUploadError
    };

    // ===== GLOBAL ALIASES FOR BACKWARD COMPATIBILITY =====
    // Export functions to global scope for direct access
    window.uploadFileToS3 = uploadFileToS3;
    window.uploadImageToS3 = uploadImageToS3;
    window.uploadMultipleFiles = uploadMultipleFiles;
    window.uploadImageWithVariants = uploadImageWithVariants;
}

// ============================================================================
// CLOSE DUPLICATE LOADING GUARD
// ============================================================================
} else {
    console.log('aws.cloud.upload.professional.js already loaded, skipping redeclaration');
}

; /**
 * HWC-4153 round 5 - the file-upload half of custom-ui.js: the FileDropHandler family
 * (single/multiple image/video/raw) and $.fn.file, which updateUi calls on every
 * input[type=file]. Ships in the 'forms' site feature chunk next to jquery.fileupload /
 * dropzie / the aws cloud uploader it drives; a js-chunk-loader queueing stub covers pages
 * where the forms chunk was not emitted (empty sets no-op, a real file input lazy-loads the
 * chunk and replays).
 */
(function() {
    // The key FileDropHandler caches dropped/selected files under on the form
    // (form.data("form-extra-data")), read back by every image/file submit path.
    // Declared here, next to its only users - the round 5 split left it behind in
    // custom-ui-editor.js, whose IIFE this file cannot see, so cacheFile/removeCache
    // threw ReferenceError and aborted the fileupload "add" chain mid-select.
    var formFieldDataKey = "form-extra-data";

    function FileDropHandler(input) {
        var _self = this;
        if(input.hasClass("masked-file-input") || input.parent(".dropzone-wrapper").length) {
            this.alreadyInitialized = true;
            return;
        }
        this.uuid = bm.getUUID();
        this.input = input;
        this.clazz = input.attr("class");
        this.auto = input.attr("submit") == "auto";
        if(this.auto) {
            this.submit_url = this.input.attr("ajax-url");
            this.submit_data = this.input.attr("submit-data");
        }
        this.form = this.auto ? null : this.input.closest("form");
        if(this.form && !this.form.length) {
            this.form = null;
        }
        this.input.addClass("masked-file-input");
        this.wrapper = $("<div class='dropzone-wrapper'></div>");
        if(this.clazz) {
            this.wrapper.addClass(this.clazz)
        }
        this.input.after(this.wrapper);
        if(window.FormData) {
            var svgIconUrl = app.svgResourceUrl;
            var iconName = "wc-icon-2020-463-";
            if(this.input.attr("click-only") == "true"){
                iconName = "wc-icon-2020-432-"
            }
            svgIconUrl += iconName;
            if(this.input.is(".dropzone-with-browse-button")){
                this.dropZone = $('<div class="form-image-block"><div class="files-dropzone dropzone-with-browse-view"><div class="nx-drop-box" style="cursor: pointer;"><i class="nxi nxi-upload nx-drop-icon" style="overflow: hidden;"></i><span class="nx-drop-text">' + ($.i18n.prop('drag.and.drop.file.here') || 'Drag and drop file here') + '</span><div class="w-100 orBox"><span>' + ($.i18n.prop('or') || 'or') + '</span></div><input type="file" style="width: 0px; height: 0px; position: absolute; padding: 0px; margin: 0px; overflow: hidden; opacity: 0;"><a class="nx-drop-btn" style="overflow: hidden;">' + ($.i18n.prop('browse.file') || 'Browse File') + '</a></div></div></div>');
            } if(this.input.is(".dropzone-with-browse-button-editor")){
                this.dropZone = $('<div class="form-image-block"><div class="files-dropzone dropzone-with-browse-view">' +
                    '<span class="outline-button" style="overflow: hidden;">' + ($.i18n.prop('change.image') || 'Change Image') + '</span><span style="display: none" class="no-file-selected">' + ($.i18n.prop('no.file.selected') || 'No file selected') + '</span></div>' +
                    '</div>' +
                    '</div>');
            } else if(this.input.is(".dropzone-for-editor")){
                var dropZoneText = $.i18n.prop('drag.and.drop.your.image.here') || 'Drag and drop your image here';
                if(this.input.attr("file-type-text")) {
                    var fileTypeText = this.input.attr("file-type-text");
                    var template = $.i18n.prop('drag.and.drop.your.x.here');
                    dropZoneText = (template && template !== 'drag.and.drop.your.x.here')
                        ? template.replace('{0}', fileTypeText)
                        : 'Drag and drop your ' + fileTypeText + ' here';
                } else if(this.input.attr("file-type") === "video") {
                    dropZoneText = $.i18n.prop('drag.and.drop.your.video.here') || 'Drag and drop your video here';
                }
                this.dropZone = $('<div class="dropzone">\n' +
                    '  <span class="fee-icon"></span>\n' +
                    '  <div class="dropzone-text-wrapper">\n' +
                    '    <span class="dropzone-text">' + dropZoneText + '</span><span class="dropzone-text or">' + ($.i18n.prop('or') || 'or') + '</span>\n' +
                    '   </div>\n' +
                    '   <button type="button" class="outline-button">' + ($.i18n.prop('upload') || 'Upload') + '</button>\n' +
                    '</div>');

                this.input.on("dragover", function (){
                    this.jqObject.next().find(".dropzone").addClass('drag-over');
                })

                this.input.on("dragleave", function (){
                    this.jqObject.next().find(".dropzone").removeClass('drag-over');
                })

                this.dropZone.find(".outline-button").on("dragover", function (){
                    this.jqObject.closest(".dropzone").addClass('drag-over');
                })

                // this.dropZone.find(".outline-button").on("dragleave", function (){
                //     this.jqObject.closest(".dropzone").removeClass('drag-over');
                // })

            } else {
                this.dropZone = $("<div class='dropzone'><svg class=\"wc-icon large\"><use xlink:href=" + svgIconUrl + "></svg><span class='dropzone-text'></span></div>");
            }
            if(!this.input.is(".dropzone-for-editor")){
                this.dropZone.find(".dropzone-text").text(this.dropText);
            }
            this.wrapper.append(this.dropZone)
        } else {
            this.dropZone = $("<button type='button' class='fake-file-chooser'></button>").text(this.chooserText);
            this.dropZone.wrap("<span class='input-wrapper-false-mask' style='display: inline-block;'></span>");
            this.wrapper.append(this.dropZone);
            this.dropZone.after(input);
            var width = input.width();
            this.dropZone.on("mousemove", function(e) {
                var x = e.pageX;
                var y = e.pageY;
                var newPosition = {
                    left: x - width + 5,
                    top: y - 5
                };
                input.offset(newPosition);
            });
            input.parent().width(this.dropZone.outerWidth()).height(this.dropZone.outerHeight());
            this.dropZone.off("click")
        }
        var clazz = this.input.attr("clazz");
        if(clazz) {
            this.dropZone.addClass(clazz);
        }
        // Namespaced so consumers that replace this click-to-browse behavior
        // (e.g. the FEE auto-page wishlist popup, which wires the dropzone to
        // a hidden native input itself) can remove exactly this handler via
        // .off("click.wcFileDrop") instead of stripping every click handler
        // on the node. Unqualified .off("click") continues to remove it too.
        this.dropZone.on("click.wcFileDrop", function() {
            if(!_self.isDisabled) {
                input.trigger("click");
            }
        });
        var size_limit = input.attr("size-limit");
        if(size_limit) {
            this.size_limit = +size_limit;
        }
        if(input.is("[validation]") && !input.is("[error-on]")) {
            var uuid = bm.getUUID();
            this.wrapper.attr("id", uuid);
            input.attr("error-on", uuid)
        }
        this.initializeDrop();
    }

    FileDropHandler.prototype.preAdd = function() {};

    FileDropHandler.prototype.onAdd = function() {};

    FileDropHandler.prototype.onVerifyError = function() {};

    FileDropHandler.prototype.resetFile = function() {};

    FileDropHandler.prototype.initializeDrop = function() {
        var processed_timestamp;
        var _self = this;
        this.dropZone.fileupload({
            dropZone: this.dropZone,
            fileInput: this.input,
            pasteZone: null,
            replaceFileInput: false,
            dataType: "json",
            autoUpload: false,
            add: function(e, data) {
                if(e.delegatedEvent.timeStamp == processed_timestamp) {
                    return;
                }
                _self.preAdd(data);
                var files = data.originalFiles;
                var least_added = false;
                $.each(files, function() {
                    var reader = new FileReader();
                    var added = _self.verify(this);
                    if(added && this.type == "application/pdf" && _self.input.is(".pdf-support")){
                        var blobName =  this.name;
                        var formdata = new FormData();
                        formdata.append('pdfFile', this);
                        formdata.append('pdfFile_filename',blobName);
                        $.ajaxSetup({
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            }
                        });
                        _self.input.closest(".form-row").loader();
                        $.ajax({
                            url: app.baseUrl + "app/pdfToPng",
                            type: 'POST',
                            data: formdata,
                            processData: false,
                            cache: false,
                            contentType: false,
                            success: function (resp) {
                                var request = new XMLHttpRequest();
                                request.open('GET', resp.url, true);
                                request.responseType = 'blob';
                                request.onload = function() {
                                    var pngMultipartFile = request.response;
                                    if (added) {
                                        reader.readAsDataURL(pngMultipartFile);
                                        reader.data = data;
                                        reader.file = pngMultipartFile;

                                        reader.onloadend = function(_file){
                                            var image = new Image();
                                            image.src = _file.target.result;
                                            image.file = this.file;
                                            image.data = this.data;
                                            image.onload = function () {
                                                setTimeout(function() {
                                                    _self.input.closest(".form-row").find(".preview-image").trigger("change");
                                                    setTimeout(function() {
                                                        bm.ajax({
                                                            url: app.baseUrl + "app/removeTempPdfToPngDir",
                                                            data: {tempDirUrl: resp.tempDirUrl},
                                                            dataType: "html",
                                                            response: function () {

                                                            },
                                                            success: function(resp) {
                                                                _self.input.closest(".form-row").loader(false);
                                                            }
                                                        })
                                                    }, 500);
                                                }, 5000);

                                            };
                                        };

                                        least_added = true;
                                        _self.onAdd(e, pngMultipartFile);
                                        _self.input.trigger("file-add", [pngMultipartFile]);
                                        _self.resolation = _self.input.attr("show-resolution") == "true";
                                        if (_self.auto) {
                                            _self.isDisabled = true;
                                            if (_self.input.closest(".form-row")) {
                                                _self.input.closest(".form-row").loader()
                                            }
                                            $(_self.dropZone).fileupload("send", {
                                                files: [this],
                                                formData: {id: _self.submit_data},
                                                url: _self.submit_url,
                                                success: function (e) {
                                                    _self.isDisabled = false;
                                                    if (e.resetUrl) {
                                                        _self.resetUrl = e.resetUrl;
                                                    }
                                                    _self.input.trigger("file-submit", [e]);
                                                    if (_self.input.closest(".form-row")) {
                                                        _self.input.closest(".form-row").loader(false)
                                                    }
                                                },
                                                error: function () {
                                                    _self.isDisabled = false;
                                                    _self.reset = false;
                                                    _self.resetFile();
                                                    if (_self.input.closest(".form-row")) {
                                                        _self.input.closest(".form-row").loader(false)
                                                    }
                                                }
                                            });
                                            _self.remove = _self.input.attr("remove-support") == "true";
                                        }
                                    }
                                };
                                request.send();
                            }
                        });

                    }
                    else {
                        if(added) {
                            var hasPreview = _self.input.closest(".form-row").find(".preview-image").length;
                            if(_self.resolation || hasPreview){
                                reader.readAsDataURL(this);
                                reader.data = data;
                                reader.file = this;
                                reader.onload = function (_file) {
                                    var image = new Image();
                                    image.src = _file.target.result;
                                    image.file = this.file;
                                    image.data = this.data;
                                    image.onload = function () {
                                        _self.input.closest(".form-row").find(".preview-image").trigger("change");
                                        _self.imageWidth = this.width,
                                            _self.imageHeight = this.height,
                                            _self.imageName = this.file.name;
                                        if(_self.resolation){
                                            var resolation = $("<div class='image-resolation'><span class='image-name'>"+_self.imageName+"</span>" +"<span class='image-resolation'>(" + _self.imageWidth +"X"+ _self.imageHeight+ ")</span></div>");
                                            _self.form.find(".dropzone-wrapper .dropzone").after(resolation);
                                        }
                                    };
                                };
                            }
                            least_added = true;
                            _self.onAdd(e, this);
                            _self.input.trigger("file-add", [this]);
                            _self.resolation = _self.input.attr("show-resolution") == "true";
                            if(_self.auto) {
                                _self.isDisabled = true;
                                if(_self.input.closest(".form-row")){
                                    _self.input.closest(".form-row").loader()
                                }
                                $(_self.dropZone).fileupload("send", {files: [this],
                                    formData: { id: _self.submit_data},
                                    url: _self.submit_url,
                                    success : function(e) {
                                        _self.isDisabled = false;
                                        if(e.resetUrl) {
                                            _self.resetUrl = e.resetUrl;
                                        }
                                        _self.input.trigger("file-submit", [e]);
                                        if(_self.input.closest(".form-row")){
                                            _self.input.closest(".form-row").loader(false)
                                        }
                                    },
                                    error : function() {
                                        _self.isDisabled = false;
                                        _self.reset = false;
                                        _self.resetFile();
                                        if(_self.input.closest(".form-row")){
                                            _self.input.closest(".form-row").loader(false)
                                        }
                                    }
                                });
                                _self.remove = _self.input.attr("remove-support") == "true";
                            }
                        }
                    }
                });
                if(e.delegatedEvent.type == "drop" && least_added) {
                    _self.input.trigger("change", data);
                }
                processed_timestamp = e.delegatedEvent.timeStamp;
            },
            dragenter: function() {
                _self.dropZone.addClass('drag-over');
            },
            dragleave: function() {
                _self.dropZone.removeClass('drag-over');
            },
            drop: function() {
                _self.dropZone.removeClass('drag-over');
            }
        })
        // this.wrapper.fileupload({
        //     dragenter: function() {
        //         _self.wrapper.addClass('drag-over');
        //     },
        //     dragleave: function() {
        //         _self.wrapper.removeClass('drag-over');
        //     },
        //     drop: function() {
        //         _self.wrapper.removeClass('drag-over');
        //     }
        // })
    };

    FileDropHandler.prototype.verify = function(file) {
        var errorMessage = null;
        var unsupportedExtensions = ["tif", "tiff", "mpg", "mpeg", "avi"];
        // Opt-in file-count cap (HWC — product images: recommended max 10-12). Only enforced when the input
        // carries a max-file-count attr, so other dropzones are unaffected. Counts already-saved thumbnails +
        // queued uploads; running count naturally caps a multi-file drop. Fails open if the area isn't found.
        var maxFileCount = parseInt(this.input.attr("max-file-count"), 10);
        if (maxFileCount > 0) {
            try {
                var $scope = this.input.closest("#bmui-tab-image, .form-section, form");
                var existingCount = $scope.find(".edit-product-image-sortable .sortable-image-container").length;
                var queuedCount = $scope.find(".multiple-image-queue > *").length;
                if ((existingCount + queuedCount) >= maxFileCount) {
                    var capTpl = $.i18n.prop("image.upload.limit.reached");
                    bm.notify((capTpl && capTpl !== "image.upload.limit.reached")
                        ? capTpl.replace("{0}", maxFileCount)
                        : ("You can upload up to " + maxFileCount + " images."), "alert");
                    return false;
                }
            } catch (e) {}
        }
        if(window.File) {
            var fileType;
            var fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length);
            var supportedExt = this.input.attr("supported-extension")
            var supportedFormat = this.input.attr("supported-format");
            var type = this.input.attr("file-type");
            if(supportedFormat) {
                var supportedFormatList = supportedFormat.split(",");
                if (type == "file" && !supportedFormatList.includes(fileExtension)) {
                    bm.notify($.i18n.prop('please.upload.a.file.in.a.valid.format') || "Please upload a file in a valid format", "alert");
                    var tpl = $.i18n.prop('invalid.format.only.x.files.allowed');
                    errorMessage = (tpl && tpl !== 'invalid.format.only.x.files.allowed')
                        ? tpl.replace('{0}', supportedFormat)
                        : "Invalid format. Only " + supportedFormat + " files are allowed.";
                } else if (type == "image" && !supportedFormatList.includes(fileExtension)) {
                    bm.notify($.i18n.prop('please.upload.a.file.in.a.valid.format') || "Please upload a file in a valid format", "alert");
                    var tpl2 = $.i18n.prop('invalid.format.only.x.files.allowed');
                    errorMessage = (tpl2 && tpl2 !== 'invalid.format.only.x.files.allowed')
                        ? tpl2.replace('{0}', supportedFormat)
                        : "Invalid format. Only " + supportedFormat + " files are allowed.";
                }
            } else if(supportedExt && (supportedExt != fileExtension)){
                bm.notify($.i18n.prop('please.upload.a.file.in.a.valid.format') || "Please upload a file in a valid format", "alert");
                errorMessage = $.i18n.prop("file.type.unsupported");
            } else if(this.fileType && fileExtension && unsupportedExtensions.contains(fileExtension.toLowerCase())){
                bm.notify($.i18n.prop('please.upload.a.file.in.a.valid.format') || "Please upload a file in a valid format", "alert");
                errorMessage = $.i18n.prop("file.type.unsupported");
            } else {
                if(file.type) {
                    fileType = file.type
                } else {
                    fileType = fileExtension
                }
                if(!errorMessage && this.fileType) {
                    if(!new RegExp(this.fileType).test(fileType)) {
                        if(fileType == "application/pdf"){
                            if(!this.input.is(".pdf-support")){
                                errorMessage = $.i18n.prop("file.type.unsupported");
                            }
                        } else {
                            // errorMessage = $.i18n.prop("file.type.unsupported");
                        }
                    }
                }
                if(this.size_limit) {
                    if(file.size > this.size_limit && !errorMessage) {
                        errorMessage = $.i18n.prop("uploaded.file.size.larger.than.expected", [file.size.toByteNotation(), this.size_limit.toByteNotation()]);
                    }
                }
            }
            if(errorMessage) {
                if(this.onVerifyError(errorMessage, file) === false) {
                    return false;
                }
            }
        }
        if(errorMessage) {
            return false;
        }
        return true;
    };

    FileDropHandler.prototype.cacheFile = function(file) {
        var fileData = {name: this.input.attr("name"), value: file};
        fileData.value.formData = fileData;
        if(this.form) {
            var cache = this.caches;
            if(!cache) {
                cache = this.caches = [];
            }
            cache.push(fileData);
            var formCacheData = this.form.data(formFieldDataKey);
            if(!formCacheData) {
                this.form.data(formFieldDataKey, formCacheData = []);
            }
            formCacheData.push(fileData);
        }
    };

    FileDropHandler.prototype.updateCache = function(file) {
        if(this.caches) {
            this.removeCache();
        }
        this.cacheFile(file);
    };

    FileDropHandler.prototype.removeCache = function(fileData) {
        if(this.form) {
            var formCacheData = this.form.data(formFieldDataKey);
            if(!formCacheData) {
                return;
            }
            if(fileData) {
                formCacheData.remove(fileData);
                this.caches.remove(fileData);
            } else {
                this.caches.everyCustomFunc(function() {
                    formCacheData.remove(this);
                });
                this.caches = [];
            }
        }
    };

    function ImageHandler() {}

    ImageHandler.prototype.preview = function(file, img) {
        if(window.FileReader) {
            var reader = new FileReader();
            reader.onload = function(e) {
                img.attr('src', e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    function SingleFileDropHandler(input) {
        var _self = this;
        FileDropHandler.apply(this, arguments);
        if(this.alreadyInitialized) return
        this.viewer = this.input.attr("previewer");
        if(this.viewer) {
            this.remove = this.input.attr("remove-support") == "true";
            var reset = this.input.attr("reset-support");
            if(reset) {
                this.reset = reset == "true";
            } else {
                this.reset = this.remove;
            }
            this.viewer = this.input.parent().find("#"+ this.viewer).length ?  this.input.parent().find("#"+ this.viewer) : $("#" + this.viewer);
            this.wrapper.addClass("single-file-with-preview")
        } else {
            this.wrapper.addClass("single-file-without-preview");
            if(this.input.attr("text-helper") !== "no") {
                this.fakeText = $("<input type='text' class='fake-chooser-text' readonly>");
                this.wrapper.append(this.fakeText);
            }
        }
        if(this.viewer) {
            this.resetUrl = this.viewer ? this.viewer.attr("src") : null;
            this.initializeResets();
        }
        if(this.auto) {
            if(input.attr("enable-remove-after-submit") != "false") {
                input.one("file-submit", function(ev, resp) {
                    if(resp.resetUrl) {
                        _self.enableRemove();
                    }
                })
            }
            if(input.attr("reset-after-submit") == "true") {
                input.on("file-submit", function() {
                    _self.input.reset();
                })
            }
        }
    }
    SingleFileDropHandler.inherit(FileDropHandler);

    SingleFileDropHandler.prototype.initializeResets = function() {
        var _self = this;
        this.removeButton = $("<span class='tool-icon remove image-remove'></span>");
        if(!this.remove) {
            this.removeButton.hide();
        }
        this.viewer.after(this.removeButton);
        this.removeCheck = $("<input type='checkbox' class='single' value='yes'>");
        this.removeCheck.attr("name", this.input.attr("remove-option-name"));
        this.wrapper.prepend(this.removeCheck.hide());
        this.removeButton.on("click", function() {
            if(_self.input.closest(".form-row")){
                _self.input.closest(".form-row").loader()
            }
            _self.removeFile();
            if (!_self.form) {
                _self.form = _self.input.closest("form");
            }
            _self.form.trigger("change")
        });
        if(!this.reset) {
            return;
        }
        var _self = this;
        this.resetUrl = this.viewer ? this.viewer.attr("src") : null;
        this.resetButton = $("<span class='tool-icon reset image-reset'></span>").hide();
        if(this.remove) {
            this.removeButton.after(this.resetButton)
        } else {
            this.viewer.after(this.resetButton)
        }
        this.resetButton.on("click", function() {
            if(!_self.form ){
                _self.form = _self.input.closest("form")
            }
            _self.form.trigger("change");
            _self.resetFile();
        })
    };

    SingleFileDropHandler.prototype.clearFile = function(inputReset) {
        if(this.wrapper.hasClass("file-added")) {
            if(inputReset !== false) {
                this.input.reset();
            }
            if(this.fakeText) {
                this.fakeText.val("");
            }
            this.removeCache();
            this.wrapper.removeClass("file-added");
            if(this.form){
                this.form.find(".dropzone-wrapper .image-resolation").remove()
            }
        }
    };

    SingleFileDropHandler.prototype.enableReset = function() {
        if(this.reset) {
            this.resetButton.show();
        }
    };

    SingleFileDropHandler.prototype.enableRemove = function() {
        if(this.remove) {
            this.removeButton.show();
        }
    };

    SingleFileDropHandler.prototype.removeFile = function() {
        var _self = this;
        this.viewer.hide();
        this.viewer.closest(".preview-image").hide();
        this.removeButton.hide();
        this.removeCheck[0].checked = true;
        this.clearFile();
        this.input.trigger("file-remove");
        if(this.auto) {
            this.disabled = true;
            bm.ajax({
                url: app.baseUrl + this.submit_url,
                data: { id: this.submit_data,
                    "remove-image" : "true"},
                success: function () {
                    _self.resetUrl = ""
                    if(_self.input.closest(".form-row")){
                        _self.input.closest(".form-row").loader(false)
                    }
                },
                error : function () {
                    _self.resetFile();
                    if(_self.input.closest(".form-row")){
                        _self.input.closest(".form-row").loader(false)
                    }
                },
                complete : function () {
                    _self.disabled = false;
                }
            })
        }else {
            this.enableReset();
            if(_self.input.closest(".form-row")){
                _self.input.closest(".form-row").loader(false)
            }
        }
    };

    SingleFileDropHandler.prototype.preAdd = function() {
        FileDropHandler.prototype.preAdd.apply(this, arguments);
        this.clearFile(false);
    };

    SingleFileDropHandler.prototype.onAdd = function(e, file) {
        FileDropHandler.prototype.onAdd.apply(this, arguments);
        this.wrapper.addClass("file-added");
        if(this.fakeText) {
            this.fakeText.val(file.name);
        }
        if(e.delegatedEvent.type == "drop") {
            this.updateCache(file);
            this.input.reset();
        }
        this.enableRemove()
    };

    SingleFileDropHandler.prototype.onVerifyError = function(message) {
        FileDropHandler.prototype.onVerifyError.apply(this, arguments);
        bm.notify(message, "alert");
        this.input.reset();
        this.input.trigger("file-reset");
        return false;
    };

    SingleFileDropHandler.prototype.resetFile = function() {
        this.removeCheck[0].checked = false;
        this.enableRemove();
        this.clearFile();
        this.input.trigger("file-reset");
        if(this.reset) {
            this.resetButton.hide();
        }
    };

    function SingleVideoDropHandler(input) {
        this.fileType = "video";
        this.dropText = input.attr("drop-text") || $.i18n.prop("drop.video.or.click");
        this.chooserText = input.attr("chooser-text") || $.i18n.prop("choose.video");
        SingleFileDropHandler.apply(this, arguments)
    }
    SingleVideoDropHandler.inherit(SingleFileDropHandler);

    SingleVideoDropHandler.prototype.onAdd = function(e, file) {
        SingleFileDropHandler.prototype.onAdd.apply(this, arguments);
        if(this.viewer && this.viewer.length > 0) {
            this.viewer.show();
            // For video elements, we need to update the source and reload
            if(this.viewer[0] && this.viewer[0].tagName === 'VIDEO') {
                var _self = this;
                if(window.FileReader) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        var videoSrc = e.target.result;
                        // Update video source
                        var source = _self.viewer.find('source')[0];
                        if(source) {
                            source.src = videoSrc;
                        } else {
                            _self.viewer.attr('src', videoSrc);
                        }
                        // Reload the video to show the new source
                        if(_self.viewer[0] && _self.viewer[0].load) {
                            _self.viewer[0].load();
                        }
                    };
                    reader.readAsDataURL(file);
                }
            }
            // Don't show remove and reset buttons for video preview
            // Users should use the upload button to replace videos

            // Handle file info display similar to images
            var singleVideoContainer = this.viewer.closest(".image-wrapper").siblings(".image-file-container");
            if(singleVideoContainer.length) {
                singleVideoContainer.find(".single-image-container").remove();
                var queueBlock = $("<div class='single-image-container'><span class='file-name'></span><span class='tool-icon remove file-remove'></span></div>");
                if (file){
                    queueBlock.find(".file-name").text(file.name + "  (" + file.size.toByteNotation() + ")");
                    queueBlock.find(".file-name").prop('title', file.name + "  (" + file.size.toByteNotation() + ")");
                    this.cacheFile(file);
                    var _self = this;
                    queueBlock.data("file", file);
                    this.viewer.closest(".image-wrapper").siblings(".image-file-container").append(queueBlock);
                    queueBlock.find(".file-remove").click(function() {
                        queueBlock.remove();
                        if(file.formData) {
                            _self.removeCache(file.formData);
                        }
                    })
                }
            }
        }
    };

    SingleVideoDropHandler.prototype.resetFile = function() {
        if(this.resetUrl && this.viewer[0].tagName === 'VIDEO') {
            this.viewer.show();
            var source = this.viewer.find('source')[0];
            if(source) {
                source.src = this.resetUrl;
            } else {
                this.viewer.attr('src', this.resetUrl);
            }
            this.viewer[0].load();
        }
        SingleFileDropHandler.prototype.resetFile.apply(this, arguments);
    };

    function SingleImageDropHandler(input) {
        this.fileType = "image";
        this.dropText = input.attr("drop-text") || $.i18n.prop("drop.image.or.click");
        this.chooserText = input.attr("chooser-text") || $.i18n.prop("choose.image");
        SingleFileDropHandler.apply(this, arguments)
    }
    SingleImageDropHandler.inherit(SingleFileDropHandler, ImageHandler);

    SingleImageDropHandler.prototype.onVerifyError = function(message) {
        SingleFileDropHandler.prototype.onVerifyError.apply(this, arguments);
        if(this.reset) {
            this.resetFile()
        }
        return false;
    };

    SingleImageDropHandler.prototype.resetFile = function() {
        if(this.resetUrl) {
            this.viewer.show();
            this.viewer.closest(".preview-image").show();
            this.viewer[0].src = this.resetUrl
        } else {
            this.viewer.hide();
            this.viewer.closest(".preview-image").hide();
        }
        SingleFileDropHandler.prototype.resetFile.apply(this, arguments);
    };

    SingleImageDropHandler.prototype.onAdd = function(e, file) {
        SingleFileDropHandler.prototype.onAdd.apply(this, arguments);
        this.viewer.show();
        this.viewer.closest(".image-wrapper").show();
        this.viewer.closest(".preview-image").show();
        this.preview(file, this.viewer);
        if(this.auto){
            this.removeButton.show();
        }else {
            this.enableReset()
        }

        var singleImageContainer = this.viewer.closest(".image-wrapper").siblings(".image-file-container");
        if(singleImageContainer) {
            singleImageContainer.find(".single-image-container").remove();
            var queueBlock = $("<div class='single-image-container'><span class='file-name'></span><span class='tool-icon remove file-remove'></span></div>");
            if (file){
                queueBlock.find(".file-name").text(file.name + "  (" + file.size.toByteNotation() + ")");
                queueBlock.find(".file-name").prop('title', file.name + "  (" + file.size.toByteNotation() + ")");
                this.cacheFile(file);
                var _self = this;
                queueBlock.data("file", file);
                this.viewer.closest(".image-wrapper").siblings(".image-file-container").append(queueBlock);
                queueBlock.find(".file-remove").click(function() {
                    queueBlock.remove();
                    if(file.formData) {
                        _self.removeCache(file.formData);
                    }
                })
            }
        }
    };

    function SingleRawDropHandler(input) {
        this.dropText = input.attr("drop-text") || $.i18n.prop("drop.file.or.click");
        this.chooserText = input.attr("chooser-text") || $.i18n.prop("choose.file");
        this.fileType = input.attr("file-type");
        SingleFileDropHandler.apply(this, arguments)
    }
    SingleRawDropHandler.inherit(SingleFileDropHandler);

    SingleRawDropHandler.prototype.onAdd = function(e, file) {
        SingleFileDropHandler.prototype.onAdd.apply(this, arguments);
        if(this.viewer) {
            this.viewer.show();
            var existing = this.viewer.attr("class");
            var rclass;
            existing.split(" ").everyCustomFunc(function() {
                if(this.startsWith("type-")) {
                    rclass = this;
                    return false;
                }
            });
            this.viewer.removeClass("" + rclass).addClass("type-" + bm.fileExtension(file.name));
            this.enableReset()
        }
    };

    SingleRawDropHandler.prototype.resetFile = function() {
        if(this.resetUrl) {
            this.viewer.show();
            var existing = this.viewer.attr("class");
            var rclass;
            existing.split(" ").everyCustomFunc(function() {
                if(this.startsWith("type-")) {
                    rclass = this;
                    return false;
                }
            });
            this.viewer.removeClass("" + rclass).addClass("type-" + bm.fileExtension(this.resetUrl));
            this.viewer.attr("src", this.resetUrl)
        } else {
            if(this.viewer) {
                this.viewer.hide();
            }
        }
        SingleFileDropHandler.prototype.resetFile.apply(this, arguments);
    };

    function MultipleFileDropHandler() {
        FileDropHandler.apply(this, arguments);
        if(this.alreadyInitialized) return;
        this.queue = this.form.find("#" + this.input.attr("queue"));
        this.wrapper.addClass("multiple-file")
    }
    MultipleFileDropHandler.inherit(FileDropHandler);

    MultipleFileDropHandler.prototype.onVerifyError = function(message, file) {
        FileDropHandler.prototype.onVerifyError.apply(this, arguments);
        var queueBlock = $("<div class='file-selection-queue error-queue'><span class='file-name'></span><span class='tool-icon remove file-remove'></span></div>");
        if (file){
            queueBlock.find(".file-name").text(message + " : (" + file.name + ")");
            queueBlock.find(".file-name").prop('title', message + " : (" + file.name + ")");
            this.initializeQueue(queueBlock, file)
        }
    };

    MultipleFileDropHandler.prototype.preAdd = function() {
        FileDropHandler.prototype.preAdd.apply(this, arguments);
        this.input.reset();
    };

    MultipleFileDropHandler.prototype.onAdd = function(e, file) {
        FileDropHandler.prototype.onAdd.apply(this, arguments);
        var queueBlock = $("<div class='file-selection-queue'><span class='file-name'></span><span class='tool-icon remove file-remove'></span></div>");
        if (file){
            queueBlock.find(".file-name").text(file.name + "  (" + file.size.toByteNotation() + ")");
            queueBlock.find(".file-name").prop('title', file.name + "  (" + file.size.toByteNotation() + ")");
            this.cacheFile(file);
            this.initializeQueue(queueBlock, file);
        }
        return queueBlock;
    };

    MultipleFileDropHandler.prototype.initializeQueue = function(queue, file) {
        var _self = this;
        queue.data("file", file);
        this.queue.append(queue);
        queue.find(".file-remove").click(function() {
            queue.remove();
            if(file.formData) {
                _self.removeCache(file.formData);
            }
        })
    };

    function MultipleVideoDropHandler(input) {
        this.fileType = "video";
        this.dropText = input.attr("drop-text") || $.i18n.prop("drop.videos.or.click");
        MultipleFileDropHandler.apply(this, arguments)
    }
    MultipleVideoDropHandler.inherit(MultipleFileDropHandler);

    function MultipleImageDropHandler(input) {
        this.fileType = "image";
        this.dropText = input.attr("drop-text") || $.i18n.prop("drop.images.or.click");
        this.chooserText = input.attr("chooser-text") || $.i18n.prop("choose.image");
        MultipleFileDropHandler.apply(this, arguments)
    }
    MultipleImageDropHandler.inherit(MultipleFileDropHandler, ImageHandler);

    MultipleImageDropHandler.prototype.onAdd = function(ev, file) {
        var queue = MultipleFileDropHandler.prototype.onAdd.apply(this, arguments);
        var img = $("<img class='queue-image-preview'>");
        queue.prepend(img);
        this.preview(file, img);
    };

    function MultipleRawDropHandler(input) {
        this.dropText = input.attr("drop-text") || $.i18n.prop("drop.files.or.click");
        this.fileType = input.attr("file-type");
        MultipleFileDropHandler.apply(this, arguments)
    }
    MultipleRawDropHandler.inherit(MultipleFileDropHandler);

    $.prototype.file = function() {
        if(!this.length) {
            return this;
        }
        this.each(function() {
            var input = $(this);
            var type = input.attr("file-type");
            var multiple = input.attr("multiple");
            if(type == "image") {
                if(multiple) {
                    new MultipleImageDropHandler(input)
                } else {
                    new SingleImageDropHandler(input)
                }
            } else if(type == "video") {
                if(multiple) {
                    new MultipleVideoDropHandler(input)
                } else {
                    new SingleVideoDropHandler(input)
                }
            } else {
                if(multiple) {
                    new MultipleRawDropHandler(input)
                } else {
                    new SingleRawDropHandler(input)
                }
            }
        })
    };

    ////////////////// Adding chart in jquery prototype /////////////////

})();
